import { defineComponent as G, reactive as fn, computed as L, openBlock as N, createElementBlock as q, createElementVNode as H, normalizeClass as ze, toDisplayString as oe, Fragment as Ge, renderList as jn, createVNode as xe, pushScopeId as Bo, popScopeId as jo, nextTick as Vr, createBlock as de, renderSlot as gt, normalizeProps as Uo, guardReactiveProps as Wo, withScopeId as Vo, resolveComponent as yt, normalizeStyle as _n, withKeys as Yo, createCommentVNode as ee, mergeProps as Go, withCtx as vt, unref as cr, withDirectives as Qo, withModifiers as Xo, ref as Ko, watch as Jo, onMounted as Zo, onBeforeUnmount as es, resolveDynamicComponent as ts } from "vue";
import { defineStore as Yr } from "pinia";
import ns from "axios";
import { cloneDeep as It, isEqual as rs, sortBy as is, uniq as ur, throttle as os } from "lodash";
import Rn from "dayjs";
import ss from "mustache";
const as = {
  BASE_URI: "",
  API_KEY: ""
}, Un = () => ({
  configuration: as
});
var cs = /* @__PURE__ */ ((e) => (e.TenderGeneratedEvent = "TenderGeneratedEvent", e.MessageSentEvent = "MessageSentEvent", e.InformationRequested = "InformationRequested", e.OfferAccepted = "OfferAccepted", e.ServiceReportCreatedEvent = "ServiceReportCreatedEvent", e.AgreementResponsible = "AgreementResponsible", e.PublicNoteCreated = "PublicNoteCreated", e.NoSuppliersFound = "NoSuppliersFound", e.TenderDeletedEvent = "TenderDeletedEvent", e.CompleteTenderOfferEvent = "CompleteTenderOfferEvent", e.OfferWithdrawnEvent = "OfferWithdrawnEvent", e.OfferRejectedEvent = "OfferRejectedEvent", e.OfferOfferedEvent = "OfferOfferedEvent", e))(cs || {}), le = /* @__PURE__ */ ((e) => (e.ALL = "ALL", e.UNREAD = "UNREAD", e))(le || {}), Pn = /* @__PURE__ */ ((e) => (e.READ = "read", e.UNREAD = "unread", e))(Pn || {});
const us = (e, t = "json") => ns.create({
  baseURL: `${e.baseUri}${e.contextPath}`,
  timeout: 3e6,
  headers: Object.fromEntries(
    e.headers.map((n) => [n.key, n.value])
  ),
  responseType: t
}), ls = (e) => e ? e.map((t) => t.toString()).join("/") : "", Ae = async (e, t) => {
  const { config: n, endpointKey: r } = e, i = n.endpoints.find(
    (c) => c.key === r
  );
  if (!i)
    throw new Error(`Endpoint with key ${String(r)} not found`);
  const o = us(n, t == null ? void 0 : t.responseType), s = `${i.url}/${ls(t == null ? void 0 : t.pathParams)}`, a = await o.request({
    method: i.method,
    url: s,
    data: t == null ? void 0 : t.data,
    params: t == null ? void 0 : t.queryParams
  });
  return {
    data: a.data,
    status: a.status
  };
}, { configuration: ds } = Un(), Gr = () => ({
  key: "Ocp-Apim-Subscription-Key",
  value: ds.API_KEY
}), { configuration: fs } = Un(), et = () => ({
  baseUri: fs.BASE_URI,
  contextPath: "/events",
  headers: [Gr()],
  endpoints: [
    {
      key: Symbol.for(
        "fetchSupplierNotifications"
        /* FETCH_SUPPLIER_NOTIFICATIONS */
      ),
      method: "GET",
      url: "/supplier",
      description: "Fetch supplier notifications"
    },
    {
      key: Symbol.for(
        "fetchCustomerNotifications"
        /* FETCH_CUSTOMER_NOTIFICATIONS */
      ),
      method: "GET",
      url: "/organization",
      description: "Fetch customer notifications"
    },
    {
      key: Symbol.for(
        "updateSupplierNotificationReadState"
        /* UPDATE_SUPPLIER_NOTIFICATION_READ_STATE */
      ),
      method: "PATCH",
      url: "/supplier/readState",
      description: "Mark supplier notification as read"
    },
    {
      key: Symbol.for(
        "markAllSupplierNotificationsAsRead"
        /* MARK_ALL_SUPPLIER_NOTIFICATIONS_AS_READ */
      ),
      method: "PATCH",
      url: "/supplier",
      description: "Mark all supplier notifications as read"
    },
    {
      key: Symbol.for(
        "updateCustomerNotificationReadState"
        /* UPDATE_CUSTOMER_NOTIFICATION_READ_STATE */
      ),
      method: "PATCH",
      url: "/organization/readState",
      description: "Update customer notification read state"
    },
    {
      key: Symbol.for(
        "markAllCustomerNotificationsAsRead"
        /* MARK_ALL_CUSTOMER_NOTIFICATIONS_AS_READ */
      ),
      method: "PATCH",
      url: "/organization",
      description: "Mark all customer notifications as read"
    }
  ]
}), hs = async (e, t) => Ae(
  {
    endpointKey: Symbol.for(
      "fetchSupplierNotifications"
      /* FETCH_SUPPLIER_NOTIFICATIONS */
    ),
    config: et()
  },
  {
    pathParams: [e],
    queryParams: t
  }
), ps = async (e, t) => Ae(
  {
    endpointKey: Symbol.for(
      "fetchCustomerNotifications"
      /* FETCH_CUSTOMER_NOTIFICATIONS */
    ),
    config: et()
  },
  {
    pathParams: [e],
    queryParams: t
  }
), ms = async (e, t) => Ae(
  {
    endpointKey: Symbol.for(
      "updateSupplierNotificationReadState"
      /* UPDATE_SUPPLIER_NOTIFICATION_READ_STATE */
    ),
    config: et()
  },
  {
    pathParams: [e, t]
  }
), gs = async (e) => Ae(
  {
    endpointKey: Symbol.for(
      "markAllSupplierNotificationsAsRead"
      /* MARK_ALL_SUPPLIER_NOTIFICATIONS_AS_READ */
    ),
    config: et()
  },
  {
    pathParams: [e, "read"]
  }
), ys = async (e, t) => Ae(
  {
    endpointKey: Symbol.for(
      "updateCustomerNotificationReadState"
      /* UPDATE_CUSTOMER_NOTIFICATION_READ_STATE */
    ),
    config: et()
  },
  {
    pathParams: [e, t]
  }
), vs = async (e) => Ae(
  {
    endpointKey: Symbol.for(
      "markAllCustomerNotificationsAsRead"
      /* MARK_ALL_CUSTOMER_NOTIFICATIONS_AS_READ */
    ),
    config: et()
  },
  {
    pathParams: [e, "read"]
  }
), Qr = () => ({
  fetchSupplierNotifications: hs,
  updateSupplierNotificationReadState: ms,
  markAllSupplierNotificationsAsRead: gs,
  fetchCustomerNotifications: ps,
  updateCustomerNotificationReadState: ys,
  markAllCustomerNotificationsAsRead: vs
});
var ie = /* @__PURE__ */ ((e) => (e.Supplier = "Supplier", e.Customer = "Customer", e))(ie || {});
const { fetchSupplierNotifications: ws, fetchCustomerNotifications: bs } = Qr(), _s = async (e, t, n, r = {}) => {
  if (e.fetchedAll)
    return e;
  const i = 5, o = 10, s = e.items || [], a = s != null && s.length ? o : i, u = await (t === ie.Supplier ? ws : bs)(n, {
    skip: s.length,
    take: a + 1,
    //+1 used to check if we have fetched all
    ...r
  });
  return {
    items: [...s, ...u.data.slice(0, a)],
    fetchedAll: u.data.length <= a
  };
}, Ss = () => ({
  genericFetchMoreNotifications: _s
}), Et = Qr(), { genericFetchMoreNotifications: Cs } = Ss(), Sn = {
  items: null,
  fetchedAll: !1
}, Wn = Yr("notifications", {
  state: () => ({
    allNotifications: It(Sn),
    unreadNotifications: It(Sn)
  }),
  actions: {
    async fetchMoreNotifications(e, t, n) {
      const r = n === le.ALL ? this.allNotifications : this.unreadNotifications, i = n === le.ALL ? {} : { read: !1 }, o = await Cs(
        r,
        e,
        t,
        i
      );
      n === le.ALL ? this.allNotifications = o : this.unreadNotifications = o;
    },
    async updateNotificationReadState(e, t, n) {
      var s;
      const r = !n.eventRead;
      await (e === ie.Supplier ? Et.updateSupplierNotificationReadState : Et.updateCustomerNotificationReadState)(
        r ? Pn.READ : Pn.UNREAD,
        n.id
      );
      const o = (s = this.allNotifications.items) == null ? void 0 : s.find(
        (a) => a.id === n.id
      );
      if (o && (o.eventRead = !o.eventRead), r) {
        const a = this.unreadNotifications.items || [];
        for (let c = a.length - 1; c >= 0; c--) {
          const u = a[c];
          (u == null ? void 0 : u.id) === n.id && a.splice(c, 1);
        }
      } else
        this.unreadNotifications = It(Sn), this.fetchMoreNotifications(e, t, le.UNREAD).catch((a) => {
          console.log("Error refreshing unread notifications: ", a);
        });
    },
    async markAllNotificationsAsRead(e, t) {
      var r;
      await (e === ie.Supplier ? Et.markAllSupplierNotificationsAsRead : Et.markAllCustomerNotificationsAsRead)(t), (r = this.allNotifications.items) == null || r.forEach((i) => i.eventRead = !0), this.unreadNotifications.items = [], this.unreadNotifications.fetchedAll = !0;
    }
  }
});
var Vn = /* @__PURE__ */ ((e) => (e.NOTIFICATIONS_COMPONENT = "notificationsComponent", e))(Vn || {}), Xr = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function Kr(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var Jr = { exports: {} };
(function(e, t) {
  (function(n, r) {
    e.exports = r();
  })(Xr, function() {
    function n() {
      return n = Object.assign || function(m) {
        for (var g = 1; g < arguments.length; g++) {
          var h = arguments[g];
          for (var p in h)
            Object.prototype.hasOwnProperty.call(h, p) && (m[p] = h[p]);
        }
        return m;
      }, n.apply(this, arguments);
    }
    function r(m, g) {
      if (m) {
        if (typeof m == "string")
          return i(m, g);
        var h = Object.prototype.toString.call(m).slice(8, -1);
        if (h === "Object" && m.constructor && (h = m.constructor.name), h === "Map" || h === "Set")
          return Array.from(m);
        if (h === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(h))
          return i(m, g);
      }
    }
    function i(m, g) {
      (g == null || g > m.length) && (g = m.length);
      for (var h = 0, p = new Array(g); h < g; h++)
        p[h] = m[h];
      return p;
    }
    function o(m, g) {
      var h = typeof Symbol < "u" && m[Symbol.iterator] || m["@@iterator"];
      if (h)
        return (h = h.call(m)).next.bind(h);
      if (Array.isArray(m) || (h = r(m)) || g && m && typeof m.length == "number") {
        h && (m = h);
        var p = 0;
        return function() {
          return p >= m.length ? {
            done: !0
          } : {
            done: !1,
            value: m[p++]
          };
        };
      }
      throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
    }
    var s = "image-Tb9Ew8CXIwaY6R1kjMvI0uRR-2000x3000-jpg";
    function a(m) {
      var g = m.split("-"), h = g[1], p = g[2], x = g[3];
      if (!h || !p || !x)
        throw new Error("Malformed asset _ref '" + m + `'. Expected an id like "` + s + '".');
      var S = p.split("x"), O = S[0], I = S[1], D = +O, Q = +I, X = isFinite(D) && isFinite(Q);
      if (!X)
        throw new Error("Malformed asset _ref '" + m + `'. Expected an id like "` + s + '".');
      return {
        id: h,
        width: D,
        height: Q,
        format: x
      };
    }
    var c = function(g) {
      var h = g;
      return h ? typeof h._ref == "string" : !1;
    }, u = function(g) {
      var h = g;
      return h ? typeof h._id == "string" : !1;
    }, l = function(g) {
      var h = g;
      return h && h.asset ? typeof h.asset.url == "string" : !1;
    };
    function d(m) {
      if (!m)
        return null;
      var g;
      if (typeof m == "string" && f(m))
        g = {
          asset: {
            _ref: y(m)
          }
        };
      else if (typeof m == "string")
        g = {
          asset: {
            _ref: m
          }
        };
      else if (c(m))
        g = {
          asset: m
        };
      else if (u(m))
        g = {
          asset: {
            _ref: m._id || ""
          }
        };
      else if (l(m))
        g = {
          asset: {
            _ref: y(m.asset.url)
          }
        };
      else if (typeof m.asset == "object")
        g = n({}, m);
      else
        return null;
      var h = m;
      return h.crop && (g.crop = h.crop), h.hotspot && (g.hotspot = h.hotspot), w(g);
    }
    function f(m) {
      return /^https?:\/\//.test("" + m);
    }
    function y(m) {
      var g = m.split("/").slice(-1);
      return ("image-" + g[0]).replace(/\.([a-z]+)$/, "-$1");
    }
    function w(m) {
      if (m.crop && m.hotspot)
        return m;
      var g = n({}, m);
      return g.crop || (g.crop = {
        left: 0,
        top: 0,
        bottom: 0,
        right: 0
      }), g.hotspot || (g.hotspot = {
        x: 0.5,
        y: 0.5,
        height: 1,
        width: 1
      }), g;
    }
    var v = [["width", "w"], ["height", "h"], ["format", "fm"], ["download", "dl"], ["blur", "blur"], ["sharpen", "sharp"], ["invert", "invert"], ["orientation", "or"], ["minHeight", "min-h"], ["maxHeight", "max-h"], ["minWidth", "min-w"], ["maxWidth", "max-w"], ["quality", "q"], ["fit", "fit"], ["crop", "crop"], ["saturation", "sat"], ["auto", "auto"], ["dpr", "dpr"], ["pad", "pad"]];
    function b(m) {
      var g = n({}, m || {}), h = g.source;
      delete g.source;
      var p = d(h);
      if (!p)
        throw new Error("Unable to resolve image URL from source (" + JSON.stringify(h) + ")");
      var x = p.asset._ref || p.asset._id || "", S = a(x), O = Math.round(p.crop.left * S.width), I = Math.round(p.crop.top * S.height), D = {
        left: O,
        top: I,
        width: Math.round(S.width - p.crop.right * S.width - O),
        height: Math.round(S.height - p.crop.bottom * S.height - I)
      }, Q = p.hotspot.height * S.height / 2, X = p.hotspot.width * S.width / 2, ue = p.hotspot.x * S.width, Ee = p.hotspot.y * S.height, re = {
        left: ue - X,
        top: Ee - Q,
        right: ue + X,
        bottom: Ee + Q
      };
      return g.rect || g.focalPoint || g.ignoreImageParams || g.crop || (g = n({}, g, C({
        crop: D,
        hotspot: re
      }, g))), _(n({}, g, {
        asset: S
      }));
    }
    function _(m) {
      var g = (m.baseUrl || "https://cdn.sanity.io").replace(/\/+$/, ""), h = m.asset.id + "-" + m.asset.width + "x" + m.asset.height + "." + m.asset.format, p = g + "/images/" + m.projectId + "/" + m.dataset + "/" + h, x = [];
      if (m.rect) {
        var S = m.rect, O = S.left, I = S.top, D = S.width, Q = S.height, X = O !== 0 || I !== 0 || Q !== m.asset.height || D !== m.asset.width;
        X && x.push("rect=" + O + "," + I + "," + D + "," + Q);
      }
      m.bg && x.push("bg=" + m.bg), m.focalPoint && (x.push("fp-x=" + m.focalPoint.x), x.push("fp-y=" + m.focalPoint.y));
      var ue = [m.flipHorizontal && "h", m.flipVertical && "v"].filter(Boolean).join("");
      return ue && x.push("flip=" + ue), v.forEach(function(Ee) {
        var re = Ee[0], Oe = Ee[1];
        typeof m[re] < "u" ? x.push(Oe + "=" + encodeURIComponent(m[re])) : typeof m[Oe] < "u" && x.push(Oe + "=" + encodeURIComponent(m[Oe]));
      }), x.length === 0 ? p : p + "?" + x.join("&");
    }
    function C(m, g) {
      var h, p = g.width, x = g.height;
      if (!(p && x))
        return {
          width: p,
          height: x,
          rect: m.crop
        };
      var S = m.crop, O = m.hotspot, I = p / x, D = S.width / S.height;
      if (D > I) {
        var Q = Math.round(S.height), X = Math.round(Q * I), ue = Math.max(0, Math.round(S.top)), Ee = Math.round((O.right - O.left) / 2 + O.left), re = Math.max(0, Math.round(Ee - X / 2));
        re < S.left ? re = S.left : re + X > S.left + S.width && (re = S.left + S.width - X), h = {
          left: re,
          top: ue,
          width: X,
          height: Q
        };
      } else {
        var Oe = S.width, At = Math.round(Oe / I), Ho = Math.max(0, Math.round(S.left)), zo = Math.round((O.bottom - O.top) / 2 + O.top), nt = Math.max(0, Math.round(zo - At / 2));
        nt < S.top ? nt = S.top : nt + At > S.top + S.height && (nt = S.top + S.height - At), h = {
          left: Ho,
          top: nt,
          width: Oe,
          height: At
        };
      }
      return {
        width: p,
        height: x,
        rect: h
      };
    }
    var T = ["clip", "crop", "fill", "fillmax", "max", "scale", "min"], $ = ["top", "bottom", "left", "right", "center", "focalpoint", "entropy"], R = ["format"];
    function M(m) {
      return m && "config" in m ? typeof m.config == "function" : !1;
    }
    function F(m) {
      return m && "clientConfig" in m ? typeof m.clientConfig == "object" : !1;
    }
    function z(m) {
      for (var g = v, h = o(g), p; !(p = h()).done; ) {
        var x = p.value, S = x[0], O = x[1];
        if (m === S || m === O)
          return S;
      }
      return m;
    }
    function A(m) {
      if (M(m)) {
        var g = m.config(), h = g.apiHost, p = g.projectId, x = g.dataset, S = h || "https://api.sanity.io";
        return new E(null, {
          baseUrl: S.replace(/^https:\/\/api\./, "https://cdn."),
          projectId: p,
          dataset: x
        });
      }
      var O = m;
      if (F(O)) {
        var I = O.clientConfig, D = I.apiHost, Q = I.projectId, X = I.dataset, ue = D || "https://api.sanity.io";
        return new E(null, {
          baseUrl: ue.replace(/^https:\/\/api\./, "https://cdn."),
          projectId: Q,
          dataset: X
        });
      }
      return new E(null, m);
    }
    var E = /* @__PURE__ */ function() {
      function m(h, p) {
        this.options = void 0, this.options = h ? n({}, h.options || {}, p || {}) : n({}, p || {});
      }
      var g = m.prototype;
      return g.withOptions = function(p) {
        var x = p.baseUrl || this.options.baseUrl, S = {
          baseUrl: x
        };
        for (var O in p)
          if (p.hasOwnProperty(O)) {
            var I = z(O);
            S[I] = p[O];
          }
        return new m(this, n({
          baseUrl: x
        }, S));
      }, g.image = function(p) {
        return this.withOptions({
          source: p
        });
      }, g.dataset = function(p) {
        return this.withOptions({
          dataset: p
        });
      }, g.projectId = function(p) {
        return this.withOptions({
          projectId: p
        });
      }, g.bg = function(p) {
        return this.withOptions({
          bg: p
        });
      }, g.dpr = function(p) {
        return this.withOptions(p && p !== 1 ? {
          dpr: p
        } : {});
      }, g.width = function(p) {
        return this.withOptions({
          width: p
        });
      }, g.height = function(p) {
        return this.withOptions({
          height: p
        });
      }, g.focalPoint = function(p, x) {
        return this.withOptions({
          focalPoint: {
            x: p,
            y: x
          }
        });
      }, g.maxWidth = function(p) {
        return this.withOptions({
          maxWidth: p
        });
      }, g.minWidth = function(p) {
        return this.withOptions({
          minWidth: p
        });
      }, g.maxHeight = function(p) {
        return this.withOptions({
          maxHeight: p
        });
      }, g.minHeight = function(p) {
        return this.withOptions({
          minHeight: p
        });
      }, g.size = function(p, x) {
        return this.withOptions({
          width: p,
          height: x
        });
      }, g.blur = function(p) {
        return this.withOptions({
          blur: p
        });
      }, g.sharpen = function(p) {
        return this.withOptions({
          sharpen: p
        });
      }, g.rect = function(p, x, S, O) {
        return this.withOptions({
          rect: {
            left: p,
            top: x,
            width: S,
            height: O
          }
        });
      }, g.format = function(p) {
        return this.withOptions({
          format: p
        });
      }, g.invert = function(p) {
        return this.withOptions({
          invert: p
        });
      }, g.orientation = function(p) {
        return this.withOptions({
          orientation: p
        });
      }, g.quality = function(p) {
        return this.withOptions({
          quality: p
        });
      }, g.forceDownload = function(p) {
        return this.withOptions({
          download: p
        });
      }, g.flipHorizontal = function() {
        return this.withOptions({
          flipHorizontal: !0
        });
      }, g.flipVertical = function() {
        return this.withOptions({
          flipVertical: !0
        });
      }, g.ignoreImageParams = function() {
        return this.withOptions({
          ignoreImageParams: !0
        });
      }, g.fit = function(p) {
        if (T.indexOf(p) === -1)
          throw new Error('Invalid fit mode "' + p + '"');
        return this.withOptions({
          fit: p
        });
      }, g.crop = function(p) {
        if ($.indexOf(p) === -1)
          throw new Error('Invalid crop mode "' + p + '"');
        return this.withOptions({
          crop: p
        });
      }, g.saturation = function(p) {
        return this.withOptions({
          saturation: p
        });
      }, g.auto = function(p) {
        if (R.indexOf(p) === -1)
          throw new Error('Invalid auto mode "' + p + '"');
        return this.withOptions({
          auto: p
        });
      }, g.pad = function(p) {
        return this.withOptions({
          pad: p
        });
      }, g.url = function() {
        return b(this.options);
      }, g.toString = function() {
        return this.url();
      }, m;
    }();
    return A;
  });
})(Jr);
var $s = Jr.exports;
const xs = /* @__PURE__ */ Kr($s), Ts = typeof navigator > "u" ? !1 : navigator.product === "ReactNative", Zr = { timeout: Ts ? 6e4 : 12e4 }, As = function(e) {
  const t = {
    ...Zr,
    ...typeof e == "string" ? { url: e } : e
  };
  if (t.timeout = ei(t.timeout), t.query) {
    const { url: n, searchParams: r } = Es(t.url);
    for (const [i, o] of Object.entries(t.query)) {
      if (o !== void 0)
        if (Array.isArray(o))
          for (const a of o)
            r.append(i, a);
        else
          r.append(i, o);
      const s = r.toString();
      s && (t.url = `${n}?${s}`);
    }
  }
  return t.method = t.body && !t.method ? "POST" : (t.method || "GET").toUpperCase(), t;
};
function Es(e) {
  const t = e.indexOf("?");
  if (t === -1)
    return { url: e, searchParams: new URLSearchParams() };
  const n = e.slice(0, t), r = e.slice(t + 1), i = new URLSearchParams(r);
  if (typeof i.set == "function")
    return { url: n, searchParams: i };
  if (typeof decodeURIComponent != "function")
    throw new Error(
      "Broken `URLSearchParams` implementation, and `decodeURIComponent` is not defined"
    );
  const o = new URLSearchParams();
  for (const s of r.split("&")) {
    const [a, c] = s.split("=");
    a && o.append(lr(a), lr(c || ""));
  }
  return { url: n, searchParams: o };
}
function lr(e) {
  return decodeURIComponent(e.replace(/\+/g, " "));
}
function ei(e) {
  if (e === !1 || e === 0)
    return !1;
  if (e.connect || e.socket)
    return e;
  const t = Number(e);
  return isNaN(t) ? ei(Zr.timeout) : { connect: t, socket: t };
}
const Os = /^https?:\/\//i, Rs = function(e) {
  if (!Os.test(e.url))
    throw new Error(`"${e.url}" is not a valid URL`);
};
var Cn = function(e) {
  return e.replace(/^\s+|\s+$/g, "");
}, Ps = function(e) {
  return Object.prototype.toString.call(e) === "[object Array]";
}, Is = function(e) {
  if (!e)
    return {};
  for (var t = {}, n = Cn(e).split(`
`), r = 0; r < n.length; r++) {
    var i = n[r], o = i.indexOf(":"), s = Cn(i.slice(0, o)).toLowerCase(), a = Cn(i.slice(o + 1));
    typeof t[s] > "u" ? t[s] = a : Ps(t[s]) ? t[s].push(a) : t[s] = [t[s], a];
  }
  return t;
};
const ks = /* @__PURE__ */ Kr(Is), Ns = (e) => function(t, n, ...r) {
  const i = t === "onError";
  let o = n;
  for (let s = 0; s < e[t].length; s++) {
    const a = e[t][s];
    if (o = a(o, ...r), i && !o)
      break;
  }
  return o;
};
function Ms() {
  const e = /* @__PURE__ */ Object.create(null);
  let t = 0;
  function n(i) {
    const o = t++;
    return e[o] = i, function() {
      delete e[o];
    };
  }
  function r(i) {
    for (const o in e)
      e[o](i);
  }
  return {
    publish: r,
    subscribe: n
  };
}
const Ls = [
  "request",
  "response",
  "progress",
  "error",
  "abort"
], dr = [
  "processOptions",
  "validateOptions",
  "interceptRequest",
  "finalizeOptions",
  "onRequest",
  "onResponse",
  "onError",
  "onReturn",
  "onHeaders"
];
function ti(e, t) {
  const n = [], r = dr.reduce(
    (o, s) => (o[s] = o[s] || [], o),
    {
      processOptions: [As],
      validateOptions: [Rs]
    }
  );
  function i(o) {
    const s = (w, v, b) => {
      let _ = w, C = v;
      if (!_)
        try {
          C = c("onResponse", v, b);
        } catch (T) {
          C = null, _ = T;
        }
      _ = _ && c("onError", _, b), _ ? a.error.publish(_) : C && a.response.publish(C);
    }, a = Ls.reduce((w, v) => (w[v] = Ms(), w), {}), c = Ns(r), u = c("processOptions", o);
    c("validateOptions", u);
    const l = { options: u, channels: a, applyMiddleware: c };
    let d;
    const f = a.request.subscribe((w) => {
      d = t(w, (v, b) => s(v, b, w));
    });
    a.abort.subscribe(() => {
      f(), d && d.abort();
    });
    const y = c("onReturn", a, l);
    return y === a && a.request.publish(l), y;
  }
  return i.use = function(o) {
    if (!o)
      throw new Error("Tried to add middleware that resolved to falsey value");
    if (typeof o == "function")
      throw new Error(
        "Tried to add middleware that was a function. It probably expects you to pass options to it."
      );
    if (o.onReturn && r.onReturn.length > 0)
      throw new Error(
        "Tried to add new middleware with `onReturn` handler, but another handler has already been registered for this event"
      );
    return dr.forEach((s) => {
      o[s] && r[s].push(o[s]);
    }), n.push(o), i;
  }, i.clone = () => ti(n, t), e.forEach(i.use), i;
}
var ni = (e, t, n) => {
  if (!t.has(e))
    throw TypeError("Cannot " + n);
}, K = (e, t, n) => (ni(e, t, "read from private field"), n ? n.call(e) : t.get(e)), Re = (e, t, n) => {
  if (t.has(e))
    throw TypeError("Cannot add the same private member more than once");
  t instanceof WeakSet ? t.add(e) : t.set(e, n);
}, pe = (e, t, n, r) => (ni(e, t, "write to private field"), r ? r.call(e, n) : t.set(e, n), n), kt, Nt, We, Mt, me, Lt, Ft;
class ri {
  constructor() {
    this.readyState = 0, this.responseType = "", Re(this, kt, void 0), Re(this, Nt, void 0), Re(this, We, void 0), Re(this, Mt, {}), Re(this, me, void 0), Re(this, Lt, {}), Re(this, Ft, void 0);
  }
  // eslint-disable-next-line @typescript-eslint/no-unused-vars -- _async is only declared for typings compatibility
  open(t, n, r) {
    pe(this, kt, t), pe(this, Nt, n), pe(this, We, ""), this.readyState = 1, this.onreadystatechange(), pe(this, me, void 0);
  }
  abort() {
    K(this, me) && K(this, me).abort();
  }
  getAllResponseHeaders() {
    return K(this, We);
  }
  setRequestHeader(t, n) {
    K(this, Mt)[t] = n;
  }
  // Allow setting extra fetch init options, needed for runtimes such as Vercel Edge to set `cache` and other options in React Server Components
  setInit(t, n = !0) {
    pe(this, Lt, t), pe(this, Ft, n);
  }
  send(t) {
    const n = this.responseType !== "arraybuffer", r = {
      ...K(this, Lt),
      method: K(this, kt),
      headers: K(this, Mt),
      body: t
    };
    typeof AbortController == "function" && K(this, Ft) && (pe(this, me, new AbortController()), typeof EventTarget < "u" && K(this, me).signal instanceof EventTarget && (r.signal = K(this, me).signal)), typeof document < "u" && (r.credentials = this.withCredentials ? "include" : "omit"), fetch(K(this, Nt), r).then((i) => (i.headers.forEach((o, s) => {
      pe(this, We, K(this, We) + `${s}: ${o}\r
`);
    }), this.status = i.status, this.statusText = i.statusText, this.readyState = 3, n ? i.text() : i.arrayBuffer())).then((i) => {
      typeof i == "string" ? this.responseText = i : this.response = i, this.readyState = 4, this.onreadystatechange();
    }).catch((i) => {
      var o;
      if (i.name === "AbortError") {
        this.onabort();
        return;
      }
      (o = this.onerror) == null || o.call(this, i);
    });
  }
}
kt = /* @__PURE__ */ new WeakMap(), Nt = /* @__PURE__ */ new WeakMap(), We = /* @__PURE__ */ new WeakMap(), Mt = /* @__PURE__ */ new WeakMap(), me = /* @__PURE__ */ new WeakMap(), Lt = /* @__PURE__ */ new WeakMap(), Ft = /* @__PURE__ */ new WeakMap();
const In = typeof XMLHttpRequest == "function" ? "xhr" : "fetch", Fs = In === "xhr" ? XMLHttpRequest : ri, Ds = (e, t) => {
  var n;
  const r = e.options, i = e.applyMiddleware("finalizeOptions", r), o = {}, s = e.applyMiddleware("interceptRequest", void 0, {
    adapter: In,
    context: e
  });
  if (s) {
    const $ = setTimeout(t, 0, null, s);
    return { abort: () => clearTimeout($) };
  }
  let a = new Fs();
  a instanceof ri && typeof i.fetch == "object" && a.setInit(i.fetch, (n = i.useAbortSignal) != null ? n : !0);
  const c = i.headers, u = i.timeout;
  let l = !1, d = !1, f = !1;
  if (a.onerror = ($) => {
    _(
      new Error(
        `Request error while attempting to reach ${i.url}${$.lengthComputable ? `(${$.loaded} of ${$.total} bytes transferred)` : ""}`
      )
    );
  }, a.ontimeout = ($) => {
    _(
      new Error(
        `Request timeout while attempting to reach ${i.url}${$.lengthComputable ? `(${$.loaded} of ${$.total} bytes transferred)` : ""}`
      )
    );
  }, a.onabort = () => {
    b(!0), l = !0;
  }, a.onreadystatechange = () => {
    v(), !(l || a.readyState !== 4) && a.status !== 0 && T();
  }, a.open(
    i.method,
    i.url,
    !0
    // Always async
  ), a.withCredentials = !!i.withCredentials, c && a.setRequestHeader)
    for (const $ in c)
      c.hasOwnProperty($) && a.setRequestHeader($, c[$]);
  return i.rawBody && (a.responseType = "arraybuffer"), e.applyMiddleware("onRequest", { options: i, adapter: In, request: a, context: e }), a.send(i.body || null), u && (o.connect = setTimeout(() => w("ETIMEDOUT"), u.connect)), { abort: y };
  function y() {
    l = !0, a && a.abort();
  }
  function w($) {
    f = !0, a.abort();
    const R = new Error(
      $ === "ESOCKETTIMEDOUT" ? `Socket timed out on request to ${i.url}` : `Connection timed out on request to ${i.url}`
    );
    R.code = $, e.channels.error.publish(R);
  }
  function v() {
    u && (b(), o.socket = setTimeout(() => w("ESOCKETTIMEDOUT"), u.socket));
  }
  function b($) {
    ($ || l || a.readyState >= 2 && o.connect) && clearTimeout(o.connect), o.socket && clearTimeout(o.socket);
  }
  function _($) {
    if (d)
      return;
    b(!0), d = !0, a = null;
    const R = $ || new Error(`Network error while attempting to reach ${i.url}`);
    R.isNetworkError = !0, R.request = i, t(R);
  }
  function C() {
    return {
      body: a.response || (a.responseType === "" || a.responseType === "text" ? a.responseText : ""),
      url: i.url,
      method: i.method,
      headers: ks(a.getAllResponseHeaders()),
      statusCode: a.status,
      statusMessage: a.statusText
    };
  }
  function T() {
    if (!(l || d || f)) {
      if (a.status === 0) {
        _(new Error("Unknown XHR error"));
        return;
      }
      b(), d = !0, t(null, C());
    }
  }
}, qs = (e = [], t = Ds) => ti(e, t);
var fr = { exports: {} }, $n, hr;
function Hs() {
  if (hr)
    return $n;
  hr = 1;
  var e = 1e3, t = e * 60, n = t * 60, r = n * 24, i = r * 7, o = r * 365.25;
  $n = function(l, d) {
    d = d || {};
    var f = typeof l;
    if (f === "string" && l.length > 0)
      return s(l);
    if (f === "number" && isFinite(l))
      return d.long ? c(l) : a(l);
    throw new Error(
      "val is not a non-empty string or a valid number. val=" + JSON.stringify(l)
    );
  };
  function s(l) {
    if (l = String(l), !(l.length > 100)) {
      var d = /^(-?(?:\d+)?\.?\d+) *(milliseconds?|msecs?|ms|seconds?|secs?|s|minutes?|mins?|m|hours?|hrs?|h|days?|d|weeks?|w|years?|yrs?|y)?$/i.exec(
        l
      );
      if (d) {
        var f = parseFloat(d[1]), y = (d[2] || "ms").toLowerCase();
        switch (y) {
          case "years":
          case "year":
          case "yrs":
          case "yr":
          case "y":
            return f * o;
          case "weeks":
          case "week":
          case "w":
            return f * i;
          case "days":
          case "day":
          case "d":
            return f * r;
          case "hours":
          case "hour":
          case "hrs":
          case "hr":
          case "h":
            return f * n;
          case "minutes":
          case "minute":
          case "mins":
          case "min":
          case "m":
            return f * t;
          case "seconds":
          case "second":
          case "secs":
          case "sec":
          case "s":
            return f * e;
          case "milliseconds":
          case "millisecond":
          case "msecs":
          case "msec":
          case "ms":
            return f;
          default:
            return;
        }
      }
    }
  }
  function a(l) {
    var d = Math.abs(l);
    return d >= r ? Math.round(l / r) + "d" : d >= n ? Math.round(l / n) + "h" : d >= t ? Math.round(l / t) + "m" : d >= e ? Math.round(l / e) + "s" : l + "ms";
  }
  function c(l) {
    var d = Math.abs(l);
    return d >= r ? u(l, d, r, "day") : d >= n ? u(l, d, n, "hour") : d >= t ? u(l, d, t, "minute") : d >= e ? u(l, d, e, "second") : l + " ms";
  }
  function u(l, d, f, y) {
    var w = d >= f * 1.5;
    return Math.round(l / f) + " " + y + (w ? "s" : "");
  }
  return $n;
}
function zs(e) {
  n.debug = n, n.default = n, n.coerce = c, n.disable = o, n.enable = i, n.enabled = s, n.humanize = Hs(), n.destroy = u, Object.keys(e).forEach((l) => {
    n[l] = e[l];
  }), n.names = [], n.skips = [], n.formatters = {};
  function t(l) {
    let d = 0;
    for (let f = 0; f < l.length; f++)
      d = (d << 5) - d + l.charCodeAt(f), d |= 0;
    return n.colors[Math.abs(d) % n.colors.length];
  }
  n.selectColor = t;
  function n(l) {
    let d, f = null, y, w;
    function v(...b) {
      if (!v.enabled)
        return;
      const _ = v, C = Number(/* @__PURE__ */ new Date()), T = C - (d || C);
      _.diff = T, _.prev = d, _.curr = C, d = C, b[0] = n.coerce(b[0]), typeof b[0] != "string" && b.unshift("%O");
      let $ = 0;
      b[0] = b[0].replace(/%([a-zA-Z%])/g, (M, F) => {
        if (M === "%%")
          return "%";
        $++;
        const z = n.formatters[F];
        if (typeof z == "function") {
          const A = b[$];
          M = z.call(_, A), b.splice($, 1), $--;
        }
        return M;
      }), n.formatArgs.call(_, b), (_.log || n.log).apply(_, b);
    }
    return v.namespace = l, v.useColors = n.useColors(), v.color = n.selectColor(l), v.extend = r, v.destroy = n.destroy, Object.defineProperty(v, "enabled", {
      enumerable: !0,
      configurable: !1,
      get: () => f !== null ? f : (y !== n.namespaces && (y = n.namespaces, w = n.enabled(l)), w),
      set: (b) => {
        f = b;
      }
    }), typeof n.init == "function" && n.init(v), v;
  }
  function r(l, d) {
    const f = n(this.namespace + (typeof d > "u" ? ":" : d) + l);
    return f.log = this.log, f;
  }
  function i(l) {
    n.save(l), n.namespaces = l, n.names = [], n.skips = [];
    let d;
    const f = (typeof l == "string" ? l : "").split(/[\s,]+/), y = f.length;
    for (d = 0; d < y; d++)
      f[d] && (l = f[d].replace(/\*/g, ".*?"), l[0] === "-" ? n.skips.push(new RegExp("^" + l.slice(1) + "$")) : n.names.push(new RegExp("^" + l + "$")));
  }
  function o() {
    const l = [
      ...n.names.map(a),
      ...n.skips.map(a).map((d) => "-" + d)
    ].join(",");
    return n.enable(""), l;
  }
  function s(l) {
    if (l[l.length - 1] === "*")
      return !0;
    let d, f;
    for (d = 0, f = n.skips.length; d < f; d++)
      if (n.skips[d].test(l))
        return !1;
    for (d = 0, f = n.names.length; d < f; d++)
      if (n.names[d].test(l))
        return !0;
    return !1;
  }
  function a(l) {
    return l.toString().substring(2, l.toString().length - 2).replace(/\.\*\?$/, "*");
  }
  function c(l) {
    return l instanceof Error ? l.stack || l.message : l;
  }
  function u() {
    console.warn("Instance method `debug.destroy()` is deprecated and no longer does anything. It will be removed in the next major version of `debug`.");
  }
  return n.enable(n.load()), n;
}
var Bs = zs;
(function(e, t) {
  t.formatArgs = r, t.save = i, t.load = o, t.useColors = n, t.storage = s(), t.destroy = /* @__PURE__ */ (() => {
    let c = !1;
    return () => {
      c || (c = !0, console.warn("Instance method `debug.destroy()` is deprecated and no longer does anything. It will be removed in the next major version of `debug`."));
    };
  })(), t.colors = [
    "#0000CC",
    "#0000FF",
    "#0033CC",
    "#0033FF",
    "#0066CC",
    "#0066FF",
    "#0099CC",
    "#0099FF",
    "#00CC00",
    "#00CC33",
    "#00CC66",
    "#00CC99",
    "#00CCCC",
    "#00CCFF",
    "#3300CC",
    "#3300FF",
    "#3333CC",
    "#3333FF",
    "#3366CC",
    "#3366FF",
    "#3399CC",
    "#3399FF",
    "#33CC00",
    "#33CC33",
    "#33CC66",
    "#33CC99",
    "#33CCCC",
    "#33CCFF",
    "#6600CC",
    "#6600FF",
    "#6633CC",
    "#6633FF",
    "#66CC00",
    "#66CC33",
    "#9900CC",
    "#9900FF",
    "#9933CC",
    "#9933FF",
    "#99CC00",
    "#99CC33",
    "#CC0000",
    "#CC0033",
    "#CC0066",
    "#CC0099",
    "#CC00CC",
    "#CC00FF",
    "#CC3300",
    "#CC3333",
    "#CC3366",
    "#CC3399",
    "#CC33CC",
    "#CC33FF",
    "#CC6600",
    "#CC6633",
    "#CC9900",
    "#CC9933",
    "#CCCC00",
    "#CCCC33",
    "#FF0000",
    "#FF0033",
    "#FF0066",
    "#FF0099",
    "#FF00CC",
    "#FF00FF",
    "#FF3300",
    "#FF3333",
    "#FF3366",
    "#FF3399",
    "#FF33CC",
    "#FF33FF",
    "#FF6600",
    "#FF6633",
    "#FF9900",
    "#FF9933",
    "#FFCC00",
    "#FFCC33"
  ];
  function n() {
    return typeof window < "u" && window.process && (window.process.type === "renderer" || window.process.__nwjs) ? !0 : typeof navigator < "u" && navigator.userAgent && navigator.userAgent.toLowerCase().match(/(edge|trident)\/(\d+)/) ? !1 : typeof document < "u" && document.documentElement && document.documentElement.style && document.documentElement.style.WebkitAppearance || // Is firebug? http://stackoverflow.com/a/398120/376773
    typeof window < "u" && window.console && (window.console.firebug || window.console.exception && window.console.table) || // Is firefox >= v31?
    // https://developer.mozilla.org/en-US/docs/Tools/Web_Console#Styling_messages
    typeof navigator < "u" && navigator.userAgent && navigator.userAgent.toLowerCase().match(/firefox\/(\d+)/) && parseInt(RegExp.$1, 10) >= 31 || // Double check webkit in userAgent just in case we are in a worker
    typeof navigator < "u" && navigator.userAgent && navigator.userAgent.toLowerCase().match(/applewebkit\/(\d+)/);
  }
  function r(c) {
    if (c[0] = (this.useColors ? "%c" : "") + this.namespace + (this.useColors ? " %c" : " ") + c[0] + (this.useColors ? "%c " : " ") + "+" + e.exports.humanize(this.diff), !this.useColors)
      return;
    const u = "color: " + this.color;
    c.splice(1, 0, u, "color: inherit");
    let l = 0, d = 0;
    c[0].replace(/%[a-zA-Z%]/g, (f) => {
      f !== "%%" && (l++, f === "%c" && (d = l));
    }), c.splice(d, 0, u);
  }
  t.log = console.debug || console.log || (() => {
  });
  function i(c) {
    try {
      c ? t.storage.setItem("debug", c) : t.storage.removeItem("debug");
    } catch {
    }
  }
  function o() {
    let c;
    try {
      c = t.storage.getItem("debug");
    } catch {
    }
    return !c && typeof process < "u" && "env" in process && (c = process.env.DEBUG), c;
  }
  function s() {
    try {
      return localStorage;
    } catch {
    }
  }
  e.exports = Bs(t);
  const { formatters: a } = e.exports;
  a.j = function(c) {
    try {
      return JSON.stringify(c);
    } catch (u) {
      return "[UnexpectedJSONParseError]: " + u.message;
    }
  };
})(fr, fr.exports);
/*!
 * is-plain-object <https://github.com/jonschlinkert/is-plain-object>
 *
 * Copyright (c) 2014-2017, Jon Schlinkert.
 * Released under the MIT License.
 */
function pr(e) {
  return Object.prototype.toString.call(e) === "[object Object]";
}
function js(e) {
  var t, n;
  return pr(e) === !1 ? !1 : (t = e.constructor, t === void 0 ? !0 : (n = t.prototype, !(pr(n) === !1 || n.hasOwnProperty("isPrototypeOf") === !1)));
}
const Us = typeof Buffer > "u" ? () => !1 : (e) => Buffer.isBuffer(e), Ws = ["boolean", "string", "number"];
function Vs() {
  return {
    processOptions: (e) => {
      const t = e.body;
      return !t || !(typeof t.pipe != "function" && !Us(t) && (Ws.indexOf(typeof t) !== -1 || Array.isArray(t) || js(t))) ? e : Object.assign({}, e, {
        body: JSON.stringify(e.body),
        headers: Object.assign({}, e.headers, {
          "Content-Type": "application/json"
        })
      });
    }
  };
}
function Ys(e) {
  return {
    onResponse: (n) => {
      const r = n.headers["content-type"] || "", i = e && e.force || r.indexOf("application/json") !== -1;
      return !n.body || !r || !i ? n : Object.assign({}, n, { body: t(n.body) });
    },
    processOptions: (n) => Object.assign({}, n, {
      headers: Object.assign({ Accept: "application/json" }, n.headers)
    })
  };
  function t(n) {
    try {
      return JSON.parse(n);
    } catch (r) {
      throw r.message = `Failed to parsed response body as JSON: ${r.message}`, r;
    }
  }
}
let rt = {};
typeof globalThis < "u" ? rt = globalThis : typeof window < "u" ? rt = window : typeof global < "u" ? rt = global : typeof self < "u" && (rt = self);
var Gs = rt;
function Qs(e = {}) {
  const t = (
    // eslint-disable-next-line @typescript-eslint/no-explicit-any -- @TODO consider dropping checking for a global Observable since it's not on a standards track
    e.implementation || Gs.Observable
  );
  if (!t)
    throw new Error(
      "`Observable` is not available in global scope, and no implementation was passed"
    );
  return {
    onReturn: (n, r) => new t((i) => (n.error.subscribe((o) => i.error(o)), n.progress.subscribe(
      (o) => i.next(Object.assign({ type: "progress" }, o))
    ), n.response.subscribe((o) => {
      i.next(Object.assign({ type: "response" }, o)), i.complete();
    }), n.request.publish(r), () => n.abort.publish()))
  };
}
function Xs() {
  return {
    onRequest: (e) => {
      if (e.adapter !== "xhr")
        return;
      const t = e.request, n = e.context;
      "upload" in t && "onprogress" in t.upload && (t.upload.onprogress = r("upload")), "onprogress" in t && (t.onprogress = r("download"));
      function r(i) {
        return (o) => {
          const s = o.lengthComputable ? o.loaded / o.total * 100 : -1;
          n.channels.progress.publish({
            stage: i,
            percent: s,
            total: o.total,
            loaded: o.loaded,
            lengthComputable: o.lengthComputable
          });
        };
      }
    }
  };
}
class Ks {
  constructor(t) {
    this.__CANCEL__ = !0, this.message = t;
  }
  toString() {
    return `Cancel${this.message ? `: ${this.message}` : ""}`;
  }
}
const mr = class {
  constructor(e) {
    if (typeof e != "function")
      throw new TypeError("executor must be a function.");
    let t = null;
    this.promise = new Promise((n) => {
      t = n;
    }), e((n) => {
      this.reason || (this.reason = new Ks(n), t(this.reason));
    });
  }
};
mr.source = () => {
  let e;
  return {
    token: new mr((t) => {
      e = t;
    }),
    cancel: e
  };
};
var ii = (e, t, n) => n.method !== "GET" && n.method !== "HEAD" ? !1 : e.isNetworkError || !1;
const Js = (e) => e !== null && typeof e == "object" && typeof e.pipe == "function";
var Zs = (e) => {
  const t = e.maxRetries || 5, n = e.retryDelay || ea, r = e.shouldRetry;
  return {
    onError: (i, o) => {
      const s = o.options, a = s.maxRetries || t, c = s.shouldRetry || r, u = s.attemptNumber || 0;
      if (Js(s.body) || !c(i, u, s) || u >= a)
        return i;
      const l = Object.assign({}, o, {
        options: Object.assign({}, s, { attemptNumber: u + 1 })
      });
      return setTimeout(() => o.channels.request.publish(l), n(u)), null;
    }
  };
};
function ea(e) {
  return 100 * Math.pow(2, e) + Math.random() * 100;
}
const Yn = (e = {}) => Zs({ shouldRetry: ii, ...e });
Yn.shouldRetry = ii;
var kn = function(e, t) {
  return kn = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(n, r) {
    n.__proto__ = r;
  } || function(n, r) {
    for (var i in r)
      Object.prototype.hasOwnProperty.call(r, i) && (n[i] = r[i]);
  }, kn(e, t);
};
function Gn(e, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Class extends value " + String(t) + " is not a constructor or null");
  kn(e, t);
  function n() {
    this.constructor = e;
  }
  e.prototype = t === null ? Object.create(t) : (n.prototype = t.prototype, new n());
}
function ta(e, t, n, r) {
  function i(o) {
    return o instanceof n ? o : new n(function(s) {
      s(o);
    });
  }
  return new (n || (n = Promise))(function(o, s) {
    function a(l) {
      try {
        u(r.next(l));
      } catch (d) {
        s(d);
      }
    }
    function c(l) {
      try {
        u(r.throw(l));
      } catch (d) {
        s(d);
      }
    }
    function u(l) {
      l.done ? o(l.value) : i(l.value).then(a, c);
    }
    u((r = r.apply(e, t || [])).next());
  });
}
function oi(e, t) {
  var n = { label: 0, sent: function() {
    if (o[0] & 1)
      throw o[1];
    return o[1];
  }, trys: [], ops: [] }, r, i, o, s;
  return s = { next: a(0), throw: a(1), return: a(2) }, typeof Symbol == "function" && (s[Symbol.iterator] = function() {
    return this;
  }), s;
  function a(u) {
    return function(l) {
      return c([u, l]);
    };
  }
  function c(u) {
    if (r)
      throw new TypeError("Generator is already executing.");
    for (; s && (s = 0, u[0] && (n = 0)), n; )
      try {
        if (r = 1, i && (o = u[0] & 2 ? i.return : u[0] ? i.throw || ((o = i.return) && o.call(i), 0) : i.next) && !(o = o.call(i, u[1])).done)
          return o;
        switch (i = 0, o && (u = [u[0] & 2, o.value]), u[0]) {
          case 0:
          case 1:
            o = u;
            break;
          case 4:
            return n.label++, { value: u[1], done: !1 };
          case 5:
            n.label++, i = u[1], u = [0];
            continue;
          case 7:
            u = n.ops.pop(), n.trys.pop();
            continue;
          default:
            if (o = n.trys, !(o = o.length > 0 && o[o.length - 1]) && (u[0] === 6 || u[0] === 2)) {
              n = 0;
              continue;
            }
            if (u[0] === 3 && (!o || u[1] > o[0] && u[1] < o[3])) {
              n.label = u[1];
              break;
            }
            if (u[0] === 6 && n.label < o[1]) {
              n.label = o[1], o = u;
              break;
            }
            if (o && n.label < o[2]) {
              n.label = o[2], n.ops.push(u);
              break;
            }
            o[2] && n.ops.pop(), n.trys.pop();
            continue;
        }
        u = t.call(e, n);
      } catch (l) {
        u = [6, l], i = 0;
      } finally {
        r = o = 0;
      }
    if (u[0] & 5)
      throw u[1];
    return { value: u[0] ? u[1] : void 0, done: !0 };
  }
}
function wt(e) {
  var t = typeof Symbol == "function" && Symbol.iterator, n = t && e[t], r = 0;
  if (n)
    return n.call(e);
  if (e && typeof e.length == "number")
    return {
      next: function() {
        return e && r >= e.length && (e = void 0), { value: e && e[r++], done: !e };
      }
    };
  throw new TypeError(t ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function Be(e, t) {
  var n = typeof Symbol == "function" && e[Symbol.iterator];
  if (!n)
    return e;
  var r = n.call(e), i, o = [], s;
  try {
    for (; (t === void 0 || t-- > 0) && !(i = r.next()).done; )
      o.push(i.value);
  } catch (a) {
    s = { error: a };
  } finally {
    try {
      i && !i.done && (n = r.return) && n.call(r);
    } finally {
      if (s)
        throw s.error;
    }
  }
  return o;
}
function je(e, t, n) {
  if (n || arguments.length === 2)
    for (var r = 0, i = t.length, o; r < i; r++)
      (o || !(r in t)) && (o || (o = Array.prototype.slice.call(t, 0, r)), o[r] = t[r]);
  return e.concat(o || Array.prototype.slice.call(t));
}
function Qe(e) {
  return this instanceof Qe ? (this.v = e, this) : new Qe(e);
}
function na(e, t, n) {
  if (!Symbol.asyncIterator)
    throw new TypeError("Symbol.asyncIterator is not defined.");
  var r = n.apply(e, t || []), i, o = [];
  return i = {}, s("next"), s("throw"), s("return"), i[Symbol.asyncIterator] = function() {
    return this;
  }, i;
  function s(f) {
    r[f] && (i[f] = function(y) {
      return new Promise(function(w, v) {
        o.push([f, y, w, v]) > 1 || a(f, y);
      });
    });
  }
  function a(f, y) {
    try {
      c(r[f](y));
    } catch (w) {
      d(o[0][3], w);
    }
  }
  function c(f) {
    f.value instanceof Qe ? Promise.resolve(f.value.v).then(u, l) : d(o[0][2], f);
  }
  function u(f) {
    a("next", f);
  }
  function l(f) {
    a("throw", f);
  }
  function d(f, y) {
    f(y), o.shift(), o.length && a(o[0][0], o[0][1]);
  }
}
function ra(e) {
  if (!Symbol.asyncIterator)
    throw new TypeError("Symbol.asyncIterator is not defined.");
  var t = e[Symbol.asyncIterator], n;
  return t ? t.call(e) : (e = typeof wt == "function" ? wt(e) : e[Symbol.iterator](), n = {}, r("next"), r("throw"), r("return"), n[Symbol.asyncIterator] = function() {
    return this;
  }, n);
  function r(o) {
    n[o] = e[o] && function(s) {
      return new Promise(function(a, c) {
        s = e[o](s), i(a, c, s.done, s.value);
      });
    };
  }
  function i(o, s, a, c) {
    Promise.resolve(c).then(function(u) {
      o({ value: u, done: a });
    }, s);
  }
}
function W(e) {
  return typeof e == "function";
}
function si(e) {
  var t = function(r) {
    Error.call(r), r.stack = new Error().stack;
  }, n = e(t);
  return n.prototype = Object.create(Error.prototype), n.prototype.constructor = n, n;
}
var xn = si(function(e) {
  return function(n) {
    e(this), this.message = n ? n.length + ` errors occurred during unsubscription:
` + n.map(function(r, i) {
      return i + 1 + ") " + r.toString();
    }).join(`
  `) : "", this.name = "UnsubscriptionError", this.errors = n;
  };
});
function gr(e, t) {
  if (e) {
    var n = e.indexOf(t);
    0 <= n && e.splice(n, 1);
  }
}
var Qn = function() {
  function e(t) {
    this.initialTeardown = t, this.closed = !1, this._parentage = null, this._finalizers = null;
  }
  return e.prototype.unsubscribe = function() {
    var t, n, r, i, o;
    if (!this.closed) {
      this.closed = !0;
      var s = this._parentage;
      if (s)
        if (this._parentage = null, Array.isArray(s))
          try {
            for (var a = wt(s), c = a.next(); !c.done; c = a.next()) {
              var u = c.value;
              u.remove(this);
            }
          } catch (v) {
            t = { error: v };
          } finally {
            try {
              c && !c.done && (n = a.return) && n.call(a);
            } finally {
              if (t)
                throw t.error;
            }
          }
        else
          s.remove(this);
      var l = this.initialTeardown;
      if (W(l))
        try {
          l();
        } catch (v) {
          o = v instanceof xn ? v.errors : [v];
        }
      var d = this._finalizers;
      if (d) {
        this._finalizers = null;
        try {
          for (var f = wt(d), y = f.next(); !y.done; y = f.next()) {
            var w = y.value;
            try {
              yr(w);
            } catch (v) {
              o = o ?? [], v instanceof xn ? o = je(je([], Be(o)), Be(v.errors)) : o.push(v);
            }
          }
        } catch (v) {
          r = { error: v };
        } finally {
          try {
            y && !y.done && (i = f.return) && i.call(f);
          } finally {
            if (r)
              throw r.error;
          }
        }
      }
      if (o)
        throw new xn(o);
    }
  }, e.prototype.add = function(t) {
    var n;
    if (t && t !== this)
      if (this.closed)
        yr(t);
      else {
        if (t instanceof e) {
          if (t.closed || t._hasParent(this))
            return;
          t._addParent(this);
        }
        (this._finalizers = (n = this._finalizers) !== null && n !== void 0 ? n : []).push(t);
      }
  }, e.prototype._hasParent = function(t) {
    var n = this._parentage;
    return n === t || Array.isArray(n) && n.includes(t);
  }, e.prototype._addParent = function(t) {
    var n = this._parentage;
    this._parentage = Array.isArray(n) ? (n.push(t), n) : n ? [n, t] : t;
  }, e.prototype._removeParent = function(t) {
    var n = this._parentage;
    n === t ? this._parentage = null : Array.isArray(n) && gr(n, t);
  }, e.prototype.remove = function(t) {
    var n = this._finalizers;
    n && gr(n, t), t instanceof e && t._removeParent(this);
  }, e.EMPTY = function() {
    var t = new e();
    return t.closed = !0, t;
  }(), e;
}();
Qn.EMPTY;
function ai(e) {
  return e instanceof Qn || e && "closed" in e && W(e.remove) && W(e.add) && W(e.unsubscribe);
}
function yr(e) {
  W(e) ? e() : e.unsubscribe();
}
var ci = {
  onUnhandledError: null,
  onStoppedNotification: null,
  Promise: void 0,
  useDeprecatedSynchronousErrorHandling: !1,
  useDeprecatedNextContext: !1
}, ui = {
  setTimeout: function(e, t) {
    for (var n = [], r = 2; r < arguments.length; r++)
      n[r - 2] = arguments[r];
    return setTimeout.apply(void 0, je([e, t], Be(n)));
  },
  clearTimeout: function(e) {
    var t = ui.delegate;
    return ((t == null ? void 0 : t.clearTimeout) || clearTimeout)(e);
  },
  delegate: void 0
};
function li(e) {
  ui.setTimeout(function() {
    throw e;
  });
}
function vr() {
}
function ia(e) {
  e();
}
var Xn = function(e) {
  Gn(t, e);
  function t(n) {
    var r = e.call(this) || this;
    return r.isStopped = !1, n ? (r.destination = n, ai(n) && n.add(r)) : r.destination = ca, r;
  }
  return t.create = function(n, r, i) {
    return new Nn(n, r, i);
  }, t.prototype.next = function(n) {
    this.isStopped || this._next(n);
  }, t.prototype.error = function(n) {
    this.isStopped || (this.isStopped = !0, this._error(n));
  }, t.prototype.complete = function() {
    this.isStopped || (this.isStopped = !0, this._complete());
  }, t.prototype.unsubscribe = function() {
    this.closed || (this.isStopped = !0, e.prototype.unsubscribe.call(this), this.destination = null);
  }, t.prototype._next = function(n) {
    this.destination.next(n);
  }, t.prototype._error = function(n) {
    try {
      this.destination.error(n);
    } finally {
      this.unsubscribe();
    }
  }, t.prototype._complete = function() {
    try {
      this.destination.complete();
    } finally {
      this.unsubscribe();
    }
  }, t;
}(Qn), oa = Function.prototype.bind;
function Tn(e, t) {
  return oa.call(e, t);
}
var sa = function() {
  function e(t) {
    this.partialObserver = t;
  }
  return e.prototype.next = function(t) {
    var n = this.partialObserver;
    if (n.next)
      try {
        n.next(t);
      } catch (r) {
        Ot(r);
      }
  }, e.prototype.error = function(t) {
    var n = this.partialObserver;
    if (n.error)
      try {
        n.error(t);
      } catch (r) {
        Ot(r);
      }
    else
      Ot(t);
  }, e.prototype.complete = function() {
    var t = this.partialObserver;
    if (t.complete)
      try {
        t.complete();
      } catch (n) {
        Ot(n);
      }
  }, e;
}(), Nn = function(e) {
  Gn(t, e);
  function t(n, r, i) {
    var o = e.call(this) || this, s;
    if (W(n) || !n)
      s = {
        next: n ?? void 0,
        error: r ?? void 0,
        complete: i ?? void 0
      };
    else {
      var a;
      o && ci.useDeprecatedNextContext ? (a = Object.create(n), a.unsubscribe = function() {
        return o.unsubscribe();
      }, s = {
        next: n.next && Tn(n.next, a),
        error: n.error && Tn(n.error, a),
        complete: n.complete && Tn(n.complete, a)
      }) : s = n;
    }
    return o.destination = new sa(s), o;
  }
  return t;
}(Xn);
function Ot(e) {
  li(e);
}
function aa(e) {
  throw e;
}
var ca = {
  closed: !0,
  next: vr,
  error: aa,
  complete: vr
}, Kn = function() {
  return typeof Symbol == "function" && Symbol.observable || "@@observable";
}();
function di(e) {
  return e;
}
function ua() {
  for (var e = [], t = 0; t < arguments.length; t++)
    e[t] = arguments[t];
  return fi(e);
}
function fi(e) {
  return e.length === 0 ? di : e.length === 1 ? e[0] : function(n) {
    return e.reduce(function(r, i) {
      return i(r);
    }, n);
  };
}
var Y = function() {
  function e(t) {
    t && (this._subscribe = t);
  }
  return e.prototype.lift = function(t) {
    var n = new e();
    return n.source = this, n.operator = t, n;
  }, e.prototype.subscribe = function(t, n, r) {
    var i = this, o = da(t) ? t : new Nn(t, n, r);
    return ia(function() {
      var s = i, a = s.operator, c = s.source;
      o.add(a ? a.call(o, c) : c ? i._subscribe(o) : i._trySubscribe(o));
    }), o;
  }, e.prototype._trySubscribe = function(t) {
    try {
      return this._subscribe(t);
    } catch (n) {
      t.error(n);
    }
  }, e.prototype.forEach = function(t, n) {
    var r = this;
    return n = wr(n), new n(function(i, o) {
      var s = new Nn({
        next: function(a) {
          try {
            t(a);
          } catch (c) {
            o(c), s.unsubscribe();
          }
        },
        error: o,
        complete: i
      });
      r.subscribe(s);
    });
  }, e.prototype._subscribe = function(t) {
    var n;
    return (n = this.source) === null || n === void 0 ? void 0 : n.subscribe(t);
  }, e.prototype[Kn] = function() {
    return this;
  }, e.prototype.pipe = function() {
    for (var t = [], n = 0; n < arguments.length; n++)
      t[n] = arguments[n];
    return fi(t)(this);
  }, e.prototype.toPromise = function(t) {
    var n = this;
    return t = wr(t), new t(function(r, i) {
      var o;
      n.subscribe(function(s) {
        return o = s;
      }, function(s) {
        return i(s);
      }, function() {
        return r(o);
      });
    });
  }, e.create = function(t) {
    return new e(t);
  }, e;
}();
function wr(e) {
  var t;
  return (t = e ?? ci.Promise) !== null && t !== void 0 ? t : Promise;
}
function la(e) {
  return e && W(e.next) && W(e.error) && W(e.complete);
}
function da(e) {
  return e && e instanceof Xn || la(e) && ai(e);
}
function fa(e) {
  return W(e == null ? void 0 : e.lift);
}
function St(e) {
  return function(t) {
    if (fa(t))
      return t.lift(function(n) {
        try {
          return e(n, this);
        } catch (r) {
          this.error(r);
        }
      });
    throw new TypeError("Unable to lift unknown Observable type");
  };
}
function hn(e, t, n, r, i) {
  return new ha(e, t, n, r, i);
}
var ha = function(e) {
  Gn(t, e);
  function t(n, r, i, o, s, a) {
    var c = e.call(this, n) || this;
    return c.onFinalize = s, c.shouldUnsubscribe = a, c._next = r ? function(u) {
      try {
        r(u);
      } catch (l) {
        n.error(l);
      }
    } : e.prototype._next, c._error = o ? function(u) {
      try {
        o(u);
      } catch (l) {
        n.error(l);
      } finally {
        this.unsubscribe();
      }
    } : e.prototype._error, c._complete = i ? function() {
      try {
        i();
      } catch (u) {
        n.error(u);
      } finally {
        this.unsubscribe();
      }
    } : e.prototype._complete, c;
  }
  return t.prototype.unsubscribe = function() {
    var n;
    if (!this.shouldUnsubscribe || this.shouldUnsubscribe()) {
      var r = this.closed;
      e.prototype.unsubscribe.call(this), !r && ((n = this.onFinalize) === null || n === void 0 || n.call(this));
    }
  }, t;
}(Xn);
function pa(e) {
  return e[e.length - 1];
}
function ma(e) {
  return W(pa(e)) ? e.pop() : void 0;
}
var hi = function(e) {
  return e && typeof e.length == "number" && typeof e != "function";
};
function pi(e) {
  return W(e == null ? void 0 : e.then);
}
function mi(e) {
  return W(e[Kn]);
}
function gi(e) {
  return Symbol.asyncIterator && W(e == null ? void 0 : e[Symbol.asyncIterator]);
}
function yi(e) {
  return new TypeError("You provided " + (e !== null && typeof e == "object" ? "an invalid object" : "'" + e + "'") + " where a stream was expected. You can provide an Observable, Promise, ReadableStream, Array, AsyncIterable, or Iterable.");
}
function ga() {
  return typeof Symbol != "function" || !Symbol.iterator ? "@@iterator" : Symbol.iterator;
}
var vi = ga();
function wi(e) {
  return W(e == null ? void 0 : e[vi]);
}
function bi(e) {
  return na(this, arguments, function() {
    var n, r, i, o;
    return oi(this, function(s) {
      switch (s.label) {
        case 0:
          n = e.getReader(), s.label = 1;
        case 1:
          s.trys.push([1, , 9, 10]), s.label = 2;
        case 2:
          return [4, Qe(n.read())];
        case 3:
          return r = s.sent(), i = r.value, o = r.done, o ? [4, Qe(void 0)] : [3, 5];
        case 4:
          return [2, s.sent()];
        case 5:
          return [4, Qe(i)];
        case 6:
          return [4, s.sent()];
        case 7:
          return s.sent(), [3, 2];
        case 8:
          return [3, 10];
        case 9:
          return n.releaseLock(), [7];
        case 10:
          return [2];
      }
    });
  });
}
function _i(e) {
  return W(e == null ? void 0 : e.getReader);
}
function Jn(e) {
  if (e instanceof Y)
    return e;
  if (e != null) {
    if (mi(e))
      return ya(e);
    if (hi(e))
      return va(e);
    if (pi(e))
      return wa(e);
    if (gi(e))
      return Si(e);
    if (wi(e))
      return ba(e);
    if (_i(e))
      return _a(e);
  }
  throw yi(e);
}
function ya(e) {
  return new Y(function(t) {
    var n = e[Kn]();
    if (W(n.subscribe))
      return n.subscribe(t);
    throw new TypeError("Provided object does not correctly implement Symbol.observable");
  });
}
function va(e) {
  return new Y(function(t) {
    for (var n = 0; n < e.length && !t.closed; n++)
      t.next(e[n]);
    t.complete();
  });
}
function wa(e) {
  return new Y(function(t) {
    e.then(function(n) {
      t.closed || (t.next(n), t.complete());
    }, function(n) {
      return t.error(n);
    }).then(null, li);
  });
}
function ba(e) {
  return new Y(function(t) {
    var n, r;
    try {
      for (var i = wt(e), o = i.next(); !o.done; o = i.next()) {
        var s = o.value;
        if (t.next(s), t.closed)
          return;
      }
    } catch (a) {
      n = { error: a };
    } finally {
      try {
        o && !o.done && (r = i.return) && r.call(i);
      } finally {
        if (n)
          throw n.error;
      }
    }
    t.complete();
  });
}
function Si(e) {
  return new Y(function(t) {
    Sa(e, t).catch(function(n) {
      return t.error(n);
    });
  });
}
function _a(e) {
  return Si(bi(e));
}
function Sa(e, t) {
  var n, r, i, o;
  return ta(this, void 0, void 0, function() {
    var s, a;
    return oi(this, function(c) {
      switch (c.label) {
        case 0:
          c.trys.push([0, 5, 6, 11]), n = ra(e), c.label = 1;
        case 1:
          return [4, n.next()];
        case 2:
          if (r = c.sent(), !!r.done)
            return [3, 4];
          if (s = r.value, t.next(s), t.closed)
            return [2];
          c.label = 3;
        case 3:
          return [3, 1];
        case 4:
          return [3, 11];
        case 5:
          return a = c.sent(), i = { error: a }, [3, 11];
        case 6:
          return c.trys.push([6, , 9, 10]), r && !r.done && (o = n.return) ? [4, o.call(n)] : [3, 8];
        case 7:
          c.sent(), c.label = 8;
        case 8:
          return [3, 10];
        case 9:
          if (i)
            throw i.error;
          return [7];
        case 10:
          return [7];
        case 11:
          return t.complete(), [2];
      }
    });
  });
}
function Se(e, t, n, r, i) {
  r === void 0 && (r = 0), i === void 0 && (i = !1);
  var o = t.schedule(function() {
    n(), i ? e.add(this.schedule(null, r)) : this.unsubscribe();
  }, r);
  if (e.add(o), !i)
    return o;
}
function Ci(e, t) {
  return t === void 0 && (t = 0), St(function(n, r) {
    n.subscribe(hn(r, function(i) {
      return Se(r, e, function() {
        return r.next(i);
      }, t);
    }, function() {
      return Se(r, e, function() {
        return r.complete();
      }, t);
    }, function(i) {
      return Se(r, e, function() {
        return r.error(i);
      }, t);
    }));
  });
}
function $i(e, t) {
  return t === void 0 && (t = 0), St(function(n, r) {
    r.add(e.schedule(function() {
      return n.subscribe(r);
    }, t));
  });
}
function Ca(e, t) {
  return Jn(e).pipe($i(t), Ci(t));
}
function $a(e, t) {
  return Jn(e).pipe($i(t), Ci(t));
}
function xa(e, t) {
  return new Y(function(n) {
    var r = 0;
    return t.schedule(function() {
      r === e.length ? n.complete() : (n.next(e[r++]), n.closed || this.schedule());
    });
  });
}
function Ta(e, t) {
  return new Y(function(n) {
    var r;
    return Se(n, t, function() {
      r = e[vi](), Se(n, t, function() {
        var i, o, s;
        try {
          i = r.next(), o = i.value, s = i.done;
        } catch (a) {
          n.error(a);
          return;
        }
        s ? n.complete() : n.next(o);
      }, 0, !0);
    }), function() {
      return W(r == null ? void 0 : r.return) && r.return();
    };
  });
}
function xi(e, t) {
  if (!e)
    throw new Error("Iterable cannot be null");
  return new Y(function(n) {
    Se(n, t, function() {
      var r = e[Symbol.asyncIterator]();
      Se(n, t, function() {
        r.next().then(function(i) {
          i.done ? n.complete() : n.next(i.value);
        });
      }, 0, !0);
    });
  });
}
function Aa(e, t) {
  return xi(bi(e), t);
}
function Ea(e, t) {
  if (e != null) {
    if (mi(e))
      return Ca(e, t);
    if (hi(e))
      return xa(e, t);
    if (pi(e))
      return $a(e, t);
    if (gi(e))
      return xi(e, t);
    if (wi(e))
      return Ta(e, t);
    if (_i(e))
      return Aa(e, t);
  }
  throw yi(e);
}
function Ti(e, t) {
  return t ? Ea(e, t) : Jn(e);
}
var Oa = si(function(e) {
  return function() {
    e(this), this.name = "EmptyError", this.message = "no elements in sequence";
  };
});
function U(e, t) {
  var n = typeof t == "object";
  return new Promise(function(r, i) {
    var o = !1, s;
    e.subscribe({
      next: function(a) {
        s = a, o = !0;
      },
      error: i,
      complete: function() {
        o ? r(s) : n ? r(t.defaultValue) : i(new Oa());
      }
    });
  });
}
function fe(e, t) {
  return St(function(n, r) {
    var i = 0;
    n.subscribe(hn(r, function(o) {
      r.next(e.call(t, o, i++));
    }));
  });
}
var Ra = Array.isArray;
function Pa(e, t) {
  return Ra(t) ? e.apply(void 0, je([], Be(t))) : e(t);
}
function Ia(e) {
  return fe(function(t) {
    return Pa(e, t);
  });
}
function ka(e, t, n) {
  return n === void 0 && (n = di), function(r) {
    br(t, function() {
      for (var i = e.length, o = new Array(i), s = i, a = i, c = function(l) {
        br(t, function() {
          var d = Ti(e[l], t), f = !1;
          d.subscribe(hn(r, function(y) {
            o[l] = y, f || (f = !0, a--), a || r.next(n(o.slice()));
          }, function() {
            --s || r.complete();
          }));
        }, r);
      }, u = 0; u < i; u++)
        c(u);
    }, r);
  };
}
function br(e, t, n) {
  e ? Se(n, e, t) : t();
}
var Na = Array.isArray;
function Ma(e) {
  return e.length === 1 && Na(e[0]) ? e[0] : e;
}
function Ct(e, t) {
  return St(function(n, r) {
    var i = 0;
    n.subscribe(hn(r, function(o) {
      return e.call(t, o, i++) && r.next(o);
    }));
  });
}
function Ai() {
  for (var e = [], t = 0; t < arguments.length; t++)
    e[t] = arguments[t];
  var n = ma(e);
  return n ? ua(Ai.apply(void 0, je([], Be(e))), Ia(n)) : St(function(r, i) {
    ka(je([r], Be(Ma(e))))(i);
  });
}
function La() {
  for (var e = [], t = 0; t < arguments.length; t++)
    e[t] = arguments[t];
  return Ai.apply(void 0, je([], Be(e)));
}
class Fa extends Error {
  constructor(t) {
    const n = Ei(t);
    super(n.message), this.statusCode = 400, Object.assign(this, n);
  }
}
class Da extends Error {
  constructor(t) {
    const n = Ei(t);
    super(n.message), this.statusCode = 500, Object.assign(this, n);
  }
}
function Ei(e) {
  const t = e.body, n = {
    response: e,
    statusCode: e.statusCode,
    responseBody: za(t, e),
    message: "",
    details: void 0
  };
  if (t.error && t.message)
    return n.message = `${t.error} - ${t.message}`, n;
  if (qa(t)) {
    const r = t.error.items || [], i = r.slice(0, 5).map((s) => {
      var a;
      return (a = s.error) == null ? void 0 : a.description;
    }).filter(Boolean);
    let o = i.length ? `:
- ${i.join(`
- `)}` : "";
    return r.length > 5 && (o += `
...and ${r.length - 5} more`), n.message = `${t.error.description}${o}`, n.details = t.error, n;
  }
  return t.error && t.error.description ? (n.message = t.error.description, n.details = t.error, n) : (n.message = t.error || t.message || Ha(e), n);
}
function qa(e) {
  return _r(e) && _r(e.error) && e.error.type === "mutationError" && typeof e.error.description == "string";
}
function _r(e) {
  return typeof e == "object" && e !== null && !Array.isArray(e);
}
function Ha(e) {
  const t = e.statusMessage ? ` ${e.statusMessage}` : "";
  return `${e.method}-request to ${e.url} resulted in HTTP ${e.statusCode}${t}`;
}
function za(e, t) {
  return (t.headers["content-type"] || "").toLowerCase().indexOf("application/json") !== -1 ? JSON.stringify(e, null, 2) : e;
}
const Ba = {
  onResponse: (e) => {
    if (e.statusCode >= 500)
      throw new Da(e);
    if (e.statusCode >= 400)
      throw new Fa(e);
    return e;
  }
}, ja = {
  onResponse: (e) => {
    const t = e.headers["x-sanity-warning"];
    return (Array.isArray(t) ? t : [t]).filter(Boolean).forEach((n) => console.warn(n)), e;
  }
};
function Sr(e, {
  maxRetries: t = 5,
  retryDelay: n
}) {
  const r = qs([
    t > 0 ? Yn({
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      retryDelay: n,
      // This option is typed incorrectly in get-it.
      maxRetries: t,
      shouldRetry: Ua
    }) : {},
    ...e,
    ja,
    Vs(),
    Ys(),
    Xs(),
    Ba,
    Qs({ implementation: Y })
  ]);
  function i(o, s = r) {
    return s({ maxRedirects: 0, ...o });
  }
  return i.defaultRequester = r, i;
}
function Ua(e, t, n) {
  const r = n.method === "GET" || n.method === "HEAD", i = (n.uri || n.url).startsWith("/data/query"), o = e.response && (e.response.statusCode === 429 || e.response.statusCode === 502 || e.response.statusCode === 503);
  return (r || i) && o ? !0 : Yn.shouldRetry(e, t, n);
}
function Oi(e) {
  if (typeof e == "string")
    return { id: e };
  if (Array.isArray(e))
    return { query: "*[_id in $ids]", params: { ids: e } };
  if (typeof e == "object" && e !== null && "query" in e && typeof e.query == "string")
    return "params" in e && typeof e.params == "object" && e.params !== null ? { query: e.query, params: e.params } : { query: e.query };
  const t = [
    "* Document ID (<docId>)",
    "* Array of document IDs",
    "* Object containing `query`"
  ].join(`
`);
  throw new Error(`Unknown selection - must be one of:

${t}`);
}
const Cr = ["image", "file"], $r = ["before", "after", "replace"], Ri = (e) => {
  if (!/^(~[a-z0-9]{1}[-\w]{0,63}|[a-z0-9]{1}[-\w]{0,63})$/.test(e))
    throw new Error(
      "Datasets can only contain lowercase characters, numbers, underscores and dashes, and start with tilde, and be maximum 64 characters"
    );
}, Wa = (e) => {
  if (!/^[-a-z0-9]+$/i.test(e))
    throw new Error("`projectId` can only contain only a-z, 0-9 and dashes");
}, Va = (e) => {
  if (Cr.indexOf(e) === -1)
    throw new Error(`Invalid asset type: ${e}. Must be one of ${Cr.join(", ")}`);
}, ct = (e, t) => {
  if (t === null || typeof t != "object" || Array.isArray(t))
    throw new Error(`${e}() takes an object of properties`);
}, Pi = (e, t) => {
  if (typeof t != "string" || !/^[a-z0-9_][a-z0-9_.-]{0,127}$/i.test(t) || t.includes(".."))
    throw new Error(`${e}(): "${t}" is not a valid document ID`);
}, Yt = (e, t) => {
  if (!t._id)
    throw new Error(`${e}() requires that the document contains an ID ("_id" property)`);
  Pi(e, t._id);
}, Ya = (e, t, n) => {
  const r = "insert(at, selector, items)";
  if ($r.indexOf(e) === -1) {
    const i = $r.map((o) => `"${o}"`).join(", ");
    throw new Error(`${r} takes an "at"-argument which is one of: ${i}`);
  }
  if (typeof t != "string")
    throw new Error(`${r} takes a "selector"-argument which must be a string`);
  if (!Array.isArray(n))
    throw new Error(`${r} takes an "items"-argument which must be an array`);
}, Ii = (e) => {
  if (!e.dataset)
    throw new Error("`dataset` must be provided to perform queries");
  return e.dataset || "";
}, ki = (e) => {
  if (typeof e != "string" || !/^[a-z0-9._-]{1,75}$/i.test(e))
    throw new Error(
      "Tag can only contain alphanumeric characters, underscores, dashes and dots, and be between one and 75 characters long."
    );
  return e;
};
var Ni = (e, t, n) => {
  if (!t.has(e))
    throw TypeError("Cannot " + n);
}, Xe = (e, t, n) => (Ni(e, t, "read from private field"), n ? n.call(e) : t.get(e)), Mi = (e, t, n) => {
  if (t.has(e))
    throw TypeError("Cannot add the same private member more than once");
  t instanceof WeakSet ? t.add(e) : t.set(e, n);
}, Li = (e, t, n, r) => (Ni(e, t, "write to private field"), r ? r.call(e, n) : t.set(e, n), n);
class Fi {
  constructor(t, n = {}) {
    this.selection = t, this.operations = n;
  }
  /**
   * Sets the given attributes to the document. Does NOT merge objects.
   * The operation is added to the current patch, ready to be commited by `commit()`
   *
   * @param attrs - Attributes to set. To set a deep attribute, use JSONMatch, eg: \{"nested.prop": "value"\}
   */
  set(t) {
    return this._assign("set", t);
  }
  /**
   * Sets the given attributes to the document if they are not currently set. Does NOT merge objects.
   * The operation is added to the current patch, ready to be commited by `commit()`
   *
   * @param attrs - Attributes to set. To set a deep attribute, use JSONMatch, eg: \{"nested.prop": "value"\}
   */
  setIfMissing(t) {
    return this._assign("setIfMissing", t);
  }
  /**
   * Performs a "diff-match-patch" operation on the string attributes provided.
   * The operation is added to the current patch, ready to be commited by `commit()`
   *
   * @param attrs - Attributes to perform operation on. To set a deep attribute, use JSONMatch, eg: \{"nested.prop": "dmp"\}
   */
  diffMatchPatch(t) {
    return ct("diffMatchPatch", t), this._assign("diffMatchPatch", t);
  }
  /**
   * Unsets the attribute paths provided.
   * The operation is added to the current patch, ready to be commited by `commit()`
   *
   * @param attrs - Attribute paths to unset.
   */
  unset(t) {
    if (!Array.isArray(t))
      throw new Error("unset(attrs) takes an array of attributes to unset, non-array given");
    return this.operations = Object.assign({}, this.operations, { unset: t }), this;
  }
  /**
   * Increment a numeric value. Each entry in the argument is either an attribute or a JSON path. The value may be a positive or negative integer or floating-point value. The operation will fail if target value is not a numeric value, or doesn't exist.
   *
   * @param attrs - Object of attribute paths to increment, values representing the number to increment by.
   */
  inc(t) {
    return this._assign("inc", t);
  }
  /**
   * Decrement a numeric value. Each entry in the argument is either an attribute or a JSON path. The value may be a positive or negative integer or floating-point value. The operation will fail if target value is not a numeric value, or doesn't exist.
   *
   * @param attrs - Object of attribute paths to decrement, values representing the number to decrement by.
   */
  dec(t) {
    return this._assign("dec", t);
  }
  /**
   * Provides methods for modifying arrays, by inserting, appending and replacing elements via a JSONPath expression.
   *
   * @param at - Location to insert at, relative to the given selector, or 'replace' the matched path
   * @param selector - JSONPath expression, eg `comments[-1]` or `blocks[_key=="abc123"]`
   * @param items - Array of items to insert/replace
   */
  insert(t, n, r) {
    return Ya(t, n, r), this._assign("insert", { [t]: n, items: r });
  }
  /**
   * Append the given items to the array at the given JSONPath
   *
   * @param selector - Attribute/path to append to, eg `comments` or `person.hobbies`
   * @param items - Array of items to append to the array
   */
  append(t, n) {
    return this.insert("after", `${t}[-1]`, n);
  }
  /**
   * Prepend the given items to the array at the given JSONPath
   *
   * @param selector - Attribute/path to prepend to, eg `comments` or `person.hobbies`
   * @param items - Array of items to prepend to the array
   */
  prepend(t, n) {
    return this.insert("before", `${t}[0]`, n);
  }
  /**
   * Change the contents of an array by removing existing elements and/or adding new elements.
   *
   * @param selector - Attribute or JSONPath expression for array
   * @param start - Index at which to start changing the array (with origin 0). If greater than the length of the array, actual starting index will be set to the length of the array. If negative, will begin that many elements from the end of the array (with origin -1) and will be set to 0 if absolute value is greater than the length of the array.x
   * @param deleteCount - An integer indicating the number of old array elements to remove.
   * @param items - The elements to add to the array, beginning at the start index. If you don't specify any elements, splice() will only remove elements from the array.
   */
  splice(t, n, r, i) {
    const o = typeof r > "u" || r === -1, s = n < 0 ? n - 1 : n, a = o ? -1 : Math.max(0, n + r), c = s < 0 && a >= 0 ? "" : a, u = `${t}[${s}:${c}]`;
    return this.insert("replace", u, i || []);
  }
  /**
   * Adds a revision clause, preventing the document from being patched if the `_rev` property does not match the given value
   *
   * @param rev - Revision to lock the patch to
   */
  ifRevisionId(t) {
    return this.operations.ifRevisionID = t, this;
  }
  /**
   * Return a plain JSON representation of the patch
   */
  serialize() {
    return { ...Oi(this.selection), ...this.operations };
  }
  /**
   * Return a plain JSON representation of the patch
   */
  toJSON() {
    return this.serialize();
  }
  /**
   * Clears the patch of all operations
   */
  reset() {
    return this.operations = {}, this;
  }
  _assign(t, n, r = !0) {
    return ct(t, n), this.operations = Object.assign({}, this.operations, {
      [t]: Object.assign({}, r && this.operations[t] || {}, n)
    }), this;
  }
  _set(t, n) {
    return this._assign(t, n, !1);
  }
}
var Ve;
const Ga = class Di extends Fi {
  constructor(t, n, r) {
    super(t, n), Mi(this, Ve, void 0), Li(this, Ve, r);
  }
  /**
   * Clones the patch
   */
  clone() {
    return new Di(this.selection, { ...this.operations }, Xe(this, Ve));
  }
  commit(t) {
    if (!Xe(this, Ve))
      throw new Error(
        "No `client` passed to patch, either provide one or pass the patch to a clients `mutate()` method"
      );
    const n = typeof this.selection == "string", r = Object.assign({ returnFirst: n, returnDocuments: !0 }, t);
    return Xe(this, Ve).mutate({ patch: this.serialize() }, r);
  }
};
Ve = /* @__PURE__ */ new WeakMap();
let ut = Ga;
var Ye;
const Qa = class qi extends Fi {
  constructor(t, n, r) {
    super(t, n), Mi(this, Ye, void 0), Li(this, Ye, r);
  }
  /**
   * Clones the patch
   */
  clone() {
    return new qi(this.selection, { ...this.operations }, Xe(this, Ye));
  }
  commit(t) {
    if (!Xe(this, Ye))
      throw new Error(
        "No `client` passed to patch, either provide one or pass the patch to a clients `mutate()` method"
      );
    const n = typeof this.selection == "string", r = Object.assign({ returnFirst: n, returnDocuments: !0 }, t);
    return Xe(this, Ye).mutate({ patch: this.serialize() }, r);
  }
};
Ye = /* @__PURE__ */ new WeakMap();
let lt = Qa;
var Hi = (e, t, n) => {
  if (!t.has(e))
    throw TypeError("Cannot " + n);
}, be = (e, t, n) => (Hi(e, t, "read from private field"), n ? n.call(e) : t.get(e)), zi = (e, t, n) => {
  if (t.has(e))
    throw TypeError("Cannot add the same private member more than once");
  t instanceof WeakSet ? t.add(e) : t.set(e, n);
}, Bi = (e, t, n, r) => (Hi(e, t, "write to private field"), r ? r.call(e, n) : t.set(e, n), n);
const ji = { returnDocuments: !1 };
class Ui {
  constructor(t = [], n) {
    this.operations = t, this.trxId = n;
  }
  /**
   * Creates a new Sanity document. If `_id` is provided and already exists, the mutation will fail. If no `_id` is given, one will automatically be generated by the database.
   * The operation is added to the current transaction, ready to be commited by `commit()`
   *
   * @param doc - Document to create. Requires a `_type` property.
   */
  create(t) {
    return ct("create", t), this._add({ create: t });
  }
  /**
   * Creates a new Sanity document. If a document with the same `_id` already exists, the create operation will be ignored.
   * The operation is added to the current transaction, ready to be commited by `commit()`
   *
   * @param doc - Document to create if it does not already exist. Requires `_id` and `_type` properties.
   */
  createIfNotExists(t) {
    const n = "createIfNotExists";
    return ct(n, t), Yt(n, t), this._add({ [n]: t });
  }
  /**
   * Creates a new Sanity document, or replaces an existing one if the same `_id` is already used.
   * The operation is added to the current transaction, ready to be commited by `commit()`
   *
   * @param doc - Document to create or replace. Requires `_id` and `_type` properties.
   */
  createOrReplace(t) {
    const n = "createOrReplace";
    return ct(n, t), Yt(n, t), this._add({ [n]: t });
  }
  /**
   * Deletes the document with the given document ID
   * The operation is added to the current transaction, ready to be commited by `commit()`
   *
   * @param documentId - Document ID to delete
   */
  delete(t) {
    return Pi("delete", t), this._add({ delete: { id: t } });
  }
  transactionId(t) {
    return t ? (this.trxId = t, this) : this.trxId;
  }
  /**
   * Return a plain JSON representation of the transaction
   */
  serialize() {
    return [...this.operations];
  }
  /**
   * Return a plain JSON representation of the transaction
   */
  toJSON() {
    return this.serialize();
  }
  /**
   * Clears the transaction of all operations
   */
  reset() {
    return this.operations = [], this;
  }
  _add(t) {
    return this.operations.push(t), this;
  }
}
var Ie;
const Xa = class Wi extends Ui {
  constructor(t, n, r) {
    super(t, r), zi(this, Ie, void 0), Bi(this, Ie, n);
  }
  /**
   * Clones the transaction
   */
  clone() {
    return new Wi([...this.operations], be(this, Ie), this.trxId);
  }
  commit(t) {
    if (!be(this, Ie))
      throw new Error(
        "No `client` passed to transaction, either provide one or pass the transaction to a clients `mutate()` method"
      );
    return be(this, Ie).mutate(
      this.serialize(),
      Object.assign({ transactionId: this.trxId }, ji, t || {})
    );
  }
  patch(t, n) {
    const r = typeof n == "function";
    if (typeof t != "string" && t instanceof lt)
      return this._add({ patch: t.serialize() });
    if (r) {
      const i = n(new lt(t, {}, be(this, Ie)));
      if (!(i instanceof lt))
        throw new Error("function passed to `patch()` must return the patch");
      return this._add({ patch: i.serialize() });
    }
    return this._add({ patch: { id: t, ...n } });
  }
};
Ie = /* @__PURE__ */ new WeakMap();
let Vi = Xa;
var ke;
const Ka = class Yi extends Ui {
  constructor(t, n, r) {
    super(t, r), zi(this, ke, void 0), Bi(this, ke, n);
  }
  /**
   * Clones the transaction
   */
  clone() {
    return new Yi([...this.operations], be(this, ke), this.trxId);
  }
  commit(t) {
    if (!be(this, ke))
      throw new Error(
        "No `client` passed to transaction, either provide one or pass the transaction to a clients `mutate()` method"
      );
    return be(this, ke).mutate(
      this.serialize(),
      Object.assign({ transactionId: this.trxId }, ji, t || {})
    );
  }
  patch(t, n) {
    const r = typeof n == "function";
    if (typeof t != "string" && t instanceof ut)
      return this._add({ patch: t.serialize() });
    if (r) {
      const i = n(new ut(t, {}, be(this, ke)));
      if (!(i instanceof ut))
        throw new Error("function passed to `patch()` must return the patch");
      return this._add({ patch: i.serialize() });
    }
    return this._add({ patch: { id: t, ...n } });
  }
};
ke = /* @__PURE__ */ new WeakMap();
let Gi = Ka;
const Ja = "https://www.sanity.io/help/";
function Zn(e) {
  return Ja + e;
}
function Za(e) {
  let t = !1, n;
  return (...r) => (t || (n = e(...r), t = !0), n);
}
const pn = (e) => (
  // eslint-disable-next-line no-console
  Za((...t) => console.warn(e.join(" "), ...t))
), ec = pn([
  "Since you haven't set a value for `useCdn`, we will deliver content using our",
  "global, edge-cached API-CDN. If you wish to have content delivered faster, set",
  "`useCdn: false` to use the Live API. Note: You may incur higher costs using the live API."
]), tc = pn([
  "The Sanity client is configured with the `perspective` set to `previewDrafts`, which doesn't support the API-CDN.",
  "The Live API will be used instead. Set `useCdn: false` in your configuration to hide this warning."
]), nc = pn([
  "You have configured Sanity client to use a token in the browser. This may cause unintentional security issues.",
  `See ${Zn(
    "js-client-browser-token"
  )} for more information and how to hide this warning.`
]), rc = pn([
  "Using the Sanity client without specifying an API version is deprecated.",
  `See ${Zn("js-client-api-version")}`
]), ic = "apicdn.sanity.io", dt = {
  apiHost: "https://api.sanity.io",
  apiVersion: "1",
  useProjectHostname: !0,
  stega: { enabled: !1 }
}, oc = ["localhost", "127.0.0.1", "0.0.0.0"], sc = (e) => oc.indexOf(e) !== -1;
function ac(e) {
  if (e === "1" || e === "X")
    return;
  const t = new Date(e);
  if (!(/^\d{4}-\d{2}-\d{2}$/.test(e) && t instanceof Date && t.getTime() > 0))
    throw new Error("Invalid API version string, expected `1` or date in format `YYYY-MM-DD`");
}
const Qi = function(e) {
  switch (e) {
    case "previewDrafts":
    case "published":
    case "raw":
      return;
    default:
      throw new TypeError(
        "Invalid API perspective string, expected `published`, `previewDrafts` or `raw`"
      );
  }
}, Xi = (e, t) => {
  const n = {
    ...t,
    ...e,
    stega: {
      ...typeof t.stega == "boolean" ? { enabled: t.stega } : t.stega || dt.stega,
      ...typeof e.stega == "boolean" ? { enabled: e.stega } : e.stega || {}
    }
  };
  n.apiVersion || rc();
  const r = {
    ...dt,
    ...n
  }, i = r.useProjectHostname;
  if (typeof Promise > "u") {
    const d = Zn("js-client-promise-polyfill");
    throw new Error(`No native Promise-implementation found, polyfill needed - see ${d}`);
  }
  if (i && !r.projectId)
    throw new Error("Configuration must contain `projectId`");
  if (typeof r.perspective == "string" && Qi(r.perspective), "encodeSourceMap" in r)
    throw new Error(
      "It looks like you're using options meant for '@sanity/preview-kit/client'. 'encodeSourceMap' is not supported in '@sanity/client'. Did you mean 'stega.enabled'?"
    );
  if ("encodeSourceMapAtPath" in r)
    throw new Error(
      "It looks like you're using options meant for '@sanity/preview-kit/client'. 'encodeSourceMapAtPath' is not supported in '@sanity/client'. Did you mean 'stega.filter'?"
    );
  if (typeof r.stega.enabled != "boolean")
    throw new Error(`stega.enabled must be a boolean, received ${r.stega.enabled}`);
  if (r.stega.enabled && r.stega.studioUrl === void 0)
    throw new Error("stega.studioUrl must be defined when stega.enabled is true");
  if (r.stega.enabled && typeof r.stega.studioUrl != "string" && typeof r.stega.studioUrl != "function")
    throw new Error(
      `stega.studioUrl must be a string or a function, received ${r.stega.studioUrl}`
    );
  const o = typeof window < "u" && window.location && window.location.hostname, s = o && sc(window.location.hostname);
  o && s && r.token && r.ignoreBrowserTokenWarning !== !0 ? nc() : typeof r.useCdn > "u" && ec(), i && Wa(r.projectId), r.dataset && Ri(r.dataset), "requestTagPrefix" in r && (r.requestTagPrefix = r.requestTagPrefix ? ki(r.requestTagPrefix).replace(/\.+$/, "") : void 0), r.apiVersion = `${r.apiVersion}`.replace(/^v/, ""), r.isDefaultApi = r.apiHost === dt.apiHost, r.useCdn = r.useCdn !== !1 && !r.withCredentials, ac(r.apiVersion);
  const a = r.apiHost.split("://", 2), c = a[0], u = a[1], l = r.isDefaultApi ? ic : u;
  return r.useProjectHostname ? (r.url = `${c}://${r.projectId}.${u}/v${r.apiVersion}`, r.cdnUrl = `${c}://${r.projectId}.${l}/v${r.apiVersion}`) : (r.url = `${r.apiHost}/v${r.apiVersion}`, r.cdnUrl = r.url), r;
}, cc = "X-Sanity-Project-ID";
function uc(e, t = {}) {
  const n = {}, r = t.token || e.token;
  r && (n.Authorization = `Bearer ${r}`), !t.useGlobalApi && !e.useProjectHostname && e.projectId && (n[cc] = e.projectId);
  const i = !!(typeof t.withCredentials > "u" ? e.token || e.withCredentials : t.withCredentials), o = typeof t.timeout > "u" ? e.timeout : t.timeout;
  return Object.assign({}, t, {
    headers: Object.assign({}, n, t.headers || {}),
    timeout: typeof o > "u" ? 5 * 60 * 1e3 : o,
    proxy: t.proxy || e.proxy,
    json: !0,
    withCredentials: i,
    fetch: typeof t.fetch == "object" && typeof e.fetch == "object" ? { ...e.fetch, ...t.fetch } : t.fetch || e.fetch
  });
}
var Ki = { 0: 8203, 1: 8204, 2: 8205, 3: 8290, 4: 8291, 5: 8288, 6: 65279, 7: 8289, 8: 119155, 9: 119156, a: 119157, b: 119158, c: 119159, d: 119160, e: 119161, f: 119162 }, er = { 0: 8203, 1: 8204, 2: 8205, 3: 65279 }, lc = new Array(4).fill(String.fromCodePoint(er[0])).join("");
function dc(e) {
  let t = JSON.stringify(e);
  return `${lc}${Array.from(t).map((n) => {
    let r = n.charCodeAt(0);
    if (r > 255)
      throw new Error(`Only ASCII edit info can be encoded. Error attempting to encode ${t} on character ${n} (${r})`);
    return Array.from(r.toString(4).padStart(4, "0")).map((i) => String.fromCodePoint(er[i])).join("");
  }).join("")}`;
}
function fc(e) {
  return Number.isNaN(Number(e)) ? !!Date.parse(e) : !1;
}
function hc(e) {
  try {
    new URL(e, e.startsWith("/") ? "https://acme.com" : void 0);
  } catch {
    return !1;
  }
  return !0;
}
function jl(e, t, n = "auto") {
  return n === !0 || n === "auto" && (fc(e) || hc(e)) ? e : `${e}${dc(t)}`;
}
Object.fromEntries(Object.entries(er).map((e) => e.reverse()));
Object.fromEntries(Object.entries(Ki).map((e) => e.reverse()));
var pc = `${Object.values(Ki).map((e) => `\\u{${e.toString(16)}}`).join("")}`, xr = new RegExp(`[${pc}]{4,}`, "gu");
function mc(e) {
  var t;
  return { cleaned: e.replace(xr, ""), encoded: ((t = e.match(xr)) == null ? void 0 : t[0]) || "" };
}
function gc(e) {
  try {
    return JSON.parse(
      JSON.stringify(e, (t, n) => typeof n != "string" ? n : mc(n).cleaned)
    );
  } catch {
    return e;
  }
}
const Ji = ({
  query: e,
  params: t = {},
  options: n = {}
}) => {
  const r = new URLSearchParams(), { tag: i, returnQuery: o, ...s } = n;
  i && r.append("tag", i), r.append("query", e);
  for (const [a, c] of Object.entries(t))
    r.append(`$${a}`, JSON.stringify(c));
  for (const [a, c] of Object.entries(s))
    c && r.append(a, `${c}`);
  return o === !1 && r.append("returnQuery", "false"), `?${r}`;
}, yc = (e, t) => e === !1 ? void 0 : typeof e > "u" ? t : e, vc = (e = {}) => ({
  dryRun: e.dryRun,
  returnIds: !0,
  returnDocuments: yc(e.returnDocuments, !0),
  visibility: e.visibility || "sync",
  autoGenerateArrayKeys: e.autoGenerateArrayKeys,
  skipCrossDatasetReferenceValidation: e.skipCrossDatasetReferenceValidation
}), tr = (e) => e.type === "response", wc = (e) => e.body, bc = (e, t) => e.reduce((n, r) => (n[t(r)] = r, n), /* @__PURE__ */ Object.create(null)), _c = 11264;
function Zi(e, t, n, r, i = {}, o = {}) {
  const s = "stega" in o ? {
    ...n || {},
    ...typeof o.stega == "boolean" ? { enabled: o.stega } : o.stega || {}
  } : n, a = s.enabled ? gc(i) : i, c = o.filterResponse === !1 ? (w) => w : (w) => w.result, { cache: u, next: l, ...d } = {
    // Opt out of setting a `signal` on an internal `fetch` if one isn't provided.
    // This is necessary in React Server Components to avoid opting out of Request Memoization.
    useAbortSignal: typeof o.signal < "u",
    // Set `resultSourceMap' when stega is enabled, as it's required for encoding.
    resultSourceMap: s.enabled ? "withKeyArraySelector" : o.resultSourceMap,
    ...o,
    // Default to not returning the query, unless `filterResponse` is `false`,
    // or `returnQuery` is explicitly set. `true` is the default in Content Lake, so skip if truthy
    returnQuery: o.filterResponse === !1 && o.returnQuery !== !1
  }, f = typeof u < "u" || typeof l < "u" ? { ...d, fetch: { cache: u, next: l } } : d, y = $t(e, t, "query", { query: r, params: a }, f);
  return s.enabled ? y.pipe(
    La(
      Ti(
        import("./stegaEncodeSourceMap-3qZl1FVY.js").then(function(w) {
          return w.a;
        }).then(
          ({ stegaEncodeSourceMap: w }) => w
        )
      )
    ),
    fe(
      ([w, v]) => {
        const b = v(w.result, w.resultSourceMap, s);
        return c({ ...w, result: b });
      }
    )
  ) : y.pipe(fe(c));
}
function eo(e, t, n, r = {}) {
  const i = { uri: tt(e, "doc", n), json: !0, tag: r.tag };
  return xt(e, t, i).pipe(
    Ct(tr),
    fe((o) => o.body.documents && o.body.documents[0])
  );
}
function to(e, t, n, r = {}) {
  const i = { uri: tt(e, "doc", n.join(",")), json: !0, tag: r.tag };
  return xt(e, t, i).pipe(
    Ct(tr),
    fe((o) => {
      const s = bc(o.body.documents || [], (a) => a._id);
      return n.map((a) => s[a] || null);
    })
  );
}
function no(e, t, n, r) {
  return Yt("createIfNotExists", n), mn(e, t, n, "createIfNotExists", r);
}
function ro(e, t, n, r) {
  return Yt("createOrReplace", n), mn(e, t, n, "createOrReplace", r);
}
function io(e, t, n, r) {
  return $t(
    e,
    t,
    "mutate",
    { mutations: [{ delete: Oi(n) }] },
    r
  );
}
function oo(e, t, n, r) {
  let i;
  n instanceof lt || n instanceof ut ? i = { patch: n.serialize() } : n instanceof Vi || n instanceof Gi ? i = n.serialize() : i = n;
  const o = Array.isArray(i) ? i : [i], s = r && r.transactionId || void 0;
  return $t(e, t, "mutate", { mutations: o, transactionId: s }, r);
}
function $t(e, t, n, r, i = {}) {
  const o = n === "mutate", s = n === "query", a = o ? "" : Ji(r), c = !o && a.length < _c, u = c ? a : "", l = i.returnFirst, { timeout: d, token: f, tag: y, headers: w, returnQuery: v } = i, b = tt(e, n, u), _ = {
    method: c ? "GET" : "POST",
    uri: b,
    json: !0,
    body: c ? void 0 : r,
    query: o && vc(i),
    timeout: d,
    headers: w,
    token: f,
    tag: y,
    returnQuery: v,
    perspective: i.perspective,
    resultSourceMap: i.resultSourceMap,
    canUseCdn: s,
    signal: i.signal,
    fetch: i.fetch,
    useAbortSignal: i.useAbortSignal,
    useCdn: i.useCdn
  };
  return xt(e, t, _).pipe(
    Ct(tr),
    fe(wc),
    fe((C) => {
      if (!o)
        return C;
      const T = C.results || [];
      if (i.returnDocuments)
        return l ? T[0] && T[0].document : T.map((M) => M.document);
      const $ = l ? "documentId" : "documentIds", R = l ? T[0] && T[0].id : T.map((M) => M.id);
      return {
        transactionId: C.transactionId,
        results: T,
        [$]: R
      };
    })
  );
}
function mn(e, t, n, r, i = {}) {
  const o = { [r]: n }, s = Object.assign({ returnFirst: !0, returnDocuments: !0 }, i);
  return $t(e, t, "mutate", { mutations: [o] }, s);
}
function xt(e, t, n) {
  var r, i;
  const o = n.url || n.uri, s = e.config(), a = typeof n.canUseCdn > "u" ? ["GET", "HEAD"].indexOf(n.method || "GET") >= 0 && o.indexOf("/data/") === 0 : n.canUseCdn;
  let c = ((r = n.useCdn) != null ? r : s.useCdn) && a;
  const u = n.tag && s.requestTagPrefix ? [s.requestTagPrefix, n.tag].join(".") : n.tag || s.requestTagPrefix;
  if (u && n.tag !== null && (n.query = { tag: ki(u), ...n.query }), ["GET", "HEAD", "POST"].indexOf(n.method || "GET") >= 0 && o.indexOf("/data/query/") === 0) {
    const f = (i = n.resultSourceMap) != null ? i : s.resultSourceMap;
    f !== void 0 && f !== !1 && (n.query = { resultSourceMap: f, ...n.query });
    const y = n.perspective || s.perspective;
    typeof y == "string" && y !== "raw" && (Qi(y), n.query = { perspective: y, ...n.query }, y === "previewDrafts" && c && (c = !1, tc())), n.returnQuery === !1 && (n.query = { returnQuery: "false", ...n.query });
  }
  const l = uc(
    s,
    Object.assign({}, n, {
      url: nr(e, o, c)
    })
  ), d = new Y(
    (f) => t(l, s.requester).subscribe(f)
  );
  return n.signal ? d.pipe(Sc(n.signal)) : d;
}
function ne(e, t, n) {
  return xt(e, t, n).pipe(
    Ct((r) => r.type === "response"),
    fe((r) => r.body)
  );
}
function tt(e, t, n) {
  const r = e.config(), i = Ii(r), o = `/${t}/${i}`;
  return `/data${n ? `${o}/${n}` : o}`.replace(/\/($|\?)/, "$1");
}
function nr(e, t, n = !1) {
  const { url: r, cdnUrl: i } = e.config();
  return `${n ? i : r}/${t.replace(/^\//, "")}`;
}
function Sc(e) {
  return (t) => new Y((n) => {
    const r = () => n.error($c(e));
    if (e && e.aborted) {
      r();
      return;
    }
    const i = t.subscribe(n);
    return e.addEventListener("abort", r), () => {
      e.removeEventListener("abort", r), i.unsubscribe();
    };
  });
}
const Cc = !!globalThis.DOMException;
function $c(e) {
  var t, n;
  if (Cc)
    return new DOMException((t = e == null ? void 0 : e.reason) != null ? t : "The operation was aborted.", "AbortError");
  const r = new Error((n = e == null ? void 0 : e.reason) != null ? n : "The operation was aborted.");
  return r.name = "AbortError", r;
}
var so = (e, t, n) => {
  if (!t.has(e))
    throw TypeError("Cannot " + n);
}, Gt = (e, t, n) => (so(e, t, "read from private field"), n ? n.call(e) : t.get(e)), Qt = (e, t, n) => {
  if (t.has(e))
    throw TypeError("Cannot add the same private member more than once");
  t instanceof WeakSet ? t.add(e) : t.set(e, n);
}, Xt = (e, t, n, r) => (so(e, t, "write to private field"), r ? r.call(e, n) : t.set(e, n), n), Dt, qt;
class xc {
  constructor(t, n) {
    Qt(this, Dt, void 0), Qt(this, qt, void 0), Xt(this, Dt, t), Xt(this, qt, n);
  }
  upload(t, n, r) {
    return ao(Gt(this, Dt), Gt(this, qt), t, n, r);
  }
}
Dt = /* @__PURE__ */ new WeakMap(), qt = /* @__PURE__ */ new WeakMap();
var Ht, zt;
class Tc {
  constructor(t, n) {
    Qt(this, Ht, void 0), Qt(this, zt, void 0), Xt(this, Ht, t), Xt(this, zt, n);
  }
  upload(t, n, r) {
    const i = ao(Gt(this, Ht), Gt(this, zt), t, n, r);
    return U(
      i.pipe(
        Ct((o) => o.type === "response"),
        fe(
          (o) => o.body.document
        )
      )
    );
  }
}
Ht = /* @__PURE__ */ new WeakMap(), zt = /* @__PURE__ */ new WeakMap();
function ao(e, t, n, r, i = {}) {
  Va(n);
  let o = i.extract || void 0;
  o && !o.length && (o = ["none"]);
  const s = Ii(e.config()), a = n === "image" ? "images" : "files", c = Ac(i, r), { tag: u, label: l, title: d, description: f, creditLine: y, filename: w, source: v } = c, b = {
    label: l,
    title: d,
    description: f,
    filename: w,
    meta: o,
    creditLine: y
  };
  return v && (b.sourceId = v.id, b.sourceName = v.name, b.sourceUrl = v.url), xt(e, t, {
    tag: u,
    method: "POST",
    timeout: c.timeout || 0,
    uri: `/assets/${a}/${s}`,
    headers: c.contentType ? { "Content-Type": c.contentType } : {},
    query: b,
    body: r
  });
}
function Ac(e, t) {
  return typeof File > "u" || !(t instanceof File) ? e : Object.assign(
    {
      filename: e.preserveFilename === !1 ? void 0 : t.name,
      contentType: t.type
    },
    e
  );
}
var Ec = (e, t) => Object.keys(t).concat(Object.keys(e)).reduce((n, r) => (n[r] = typeof e[r] > "u" ? t[r] : e[r], n), {});
const Oc = (e, t) => t.reduce((n, r) => (typeof e[r] > "u" || (n[r] = e[r]), n), {}), Rc = 14800, Pc = [
  "includePreviousRevision",
  "includeResult",
  "visibility",
  "effectFormat",
  "tag"
], Ic = {
  includeResult: !0
};
function co(e, t, n = {}) {
  const { url: r, token: i, withCredentials: o, requestTagPrefix: s } = this.config(), a = n.tag && s ? [s, n.tag].join(".") : n.tag, c = { ...Ec(n, Ic), tag: a }, u = Oc(c, Pc), l = Ji({ query: e, params: t, options: { tag: a, ...u } }), d = `${r}${tt(this, "listen", l)}`;
  if (d.length > Rc)
    return new Y((v) => v.error(new Error("Query too large for listener")));
  const f = c.events ? c.events : ["mutation"], y = f.indexOf("reconnect") !== -1, w = {};
  return (i || o) && (w.withCredentials = !0), i && (w.headers = {
    Authorization: `Bearer ${i}`
  }), new Y((v) => {
    let b;
    A().then((g) => {
      b = g;
    }).catch((g) => {
      v.error(g), m();
    });
    let _, C = !1;
    function T() {
      C || (z(), !C && b.readyState === b.CLOSED && (F(), clearTimeout(_), _ = setTimeout(E, 100)));
    }
    function $(g) {
      v.error(kc(g));
    }
    function R(g) {
      const h = uo(g);
      return h instanceof Error ? v.error(h) : v.next(h);
    }
    function M() {
      C = !0, F(), v.complete();
    }
    function F() {
      b && (b.removeEventListener("error", T), b.removeEventListener("channelError", $), b.removeEventListener("disconnect", M), f.forEach((g) => b.removeEventListener(g, R)), b.close());
    }
    function z() {
      y && v.next({ type: "reconnect" });
    }
    async function A() {
      const { default: g } = await import("./browser-BKaJrolo.js").then((p) => p.b), h = new g(d, w);
      return h.addEventListener("error", T), h.addEventListener("channelError", $), h.addEventListener("disconnect", M), f.forEach((p) => h.addEventListener(p, R)), h;
    }
    function E() {
      A().then((g) => {
        b = g;
      }).catch((g) => {
        v.error(g), m();
      });
    }
    function m() {
      C = !0, F();
    }
    return m;
  });
}
function uo(e) {
  try {
    const t = e.data && JSON.parse(e.data) || {};
    return Object.assign({ type: e.type }, t);
  } catch (t) {
    return t;
  }
}
function kc(e) {
  if (e instanceof Error)
    return e;
  const t = uo(e);
  return t instanceof Error ? t : new Error(Nc(t));
}
function Nc(e) {
  return e.error ? e.error.description ? e.error.description : typeof e.error == "string" ? e.error : JSON.stringify(e.error, null, 2) : e.message || "Unknown listener error";
}
var lo = (e, t, n) => {
  if (!t.has(e))
    throw TypeError("Cannot " + n);
}, V = (e, t, n) => (lo(e, t, "read from private field"), n ? n.call(e) : t.get(e)), Kt = (e, t, n) => {
  if (t.has(e))
    throw TypeError("Cannot add the same private member more than once");
  t instanceof WeakSet ? t.add(e) : t.set(e, n);
}, Jt = (e, t, n, r) => (lo(e, t, "write to private field"), r ? r.call(e, n) : t.set(e, n), n), Ne, Me;
class Mc {
  constructor(t, n) {
    Kt(this, Ne, void 0), Kt(this, Me, void 0), Jt(this, Ne, t), Jt(this, Me, n);
  }
  /**
   * Create a new dataset with the given name
   *
   * @param name - Name of the dataset to create
   * @param options - Options for the dataset
   */
  create(t, n) {
    return Ke(V(this, Ne), V(this, Me), "PUT", t, n);
  }
  /**
   * Edit a dataset with the given name
   *
   * @param name - Name of the dataset to edit
   * @param options - New options for the dataset
   */
  edit(t, n) {
    return Ke(V(this, Ne), V(this, Me), "PATCH", t, n);
  }
  /**
   * Delete a dataset with the given name
   *
   * @param name - Name of the dataset to delete
   */
  delete(t) {
    return Ke(V(this, Ne), V(this, Me), "DELETE", t);
  }
  /**
   * Fetch a list of datasets for the configured project
   */
  list() {
    return ne(V(this, Ne), V(this, Me), {
      uri: "/datasets",
      tag: null
    });
  }
}
Ne = /* @__PURE__ */ new WeakMap(), Me = /* @__PURE__ */ new WeakMap();
var Le, Fe;
class Lc {
  constructor(t, n) {
    Kt(this, Le, void 0), Kt(this, Fe, void 0), Jt(this, Le, t), Jt(this, Fe, n);
  }
  /**
   * Create a new dataset with the given name
   *
   * @param name - Name of the dataset to create
   * @param options - Options for the dataset
   */
  create(t, n) {
    return U(
      Ke(V(this, Le), V(this, Fe), "PUT", t, n)
    );
  }
  /**
   * Edit a dataset with the given name
   *
   * @param name - Name of the dataset to edit
   * @param options - New options for the dataset
   */
  edit(t, n) {
    return U(
      Ke(V(this, Le), V(this, Fe), "PATCH", t, n)
    );
  }
  /**
   * Delete a dataset with the given name
   *
   * @param name - Name of the dataset to delete
   */
  delete(t) {
    return U(Ke(V(this, Le), V(this, Fe), "DELETE", t));
  }
  /**
   * Fetch a list of datasets for the configured project
   */
  list() {
    return U(
      ne(V(this, Le), V(this, Fe), { uri: "/datasets", tag: null })
    );
  }
}
Le = /* @__PURE__ */ new WeakMap(), Fe = /* @__PURE__ */ new WeakMap();
function Ke(e, t, n, r, i) {
  return Ri(r), ne(e, t, {
    method: n,
    uri: `/datasets/${r}`,
    body: i,
    tag: null
  });
}
var fo = (e, t, n) => {
  if (!t.has(e))
    throw TypeError("Cannot " + n);
}, _e = (e, t, n) => (fo(e, t, "read from private field"), n ? n.call(e) : t.get(e)), Zt = (e, t, n) => {
  if (t.has(e))
    throw TypeError("Cannot add the same private member more than once");
  t instanceof WeakSet ? t.add(e) : t.set(e, n);
}, en = (e, t, n, r) => (fo(e, t, "write to private field"), r ? r.call(e, n) : t.set(e, n), n), it, ot;
class Fc {
  constructor(t, n) {
    Zt(this, it, void 0), Zt(this, ot, void 0), en(this, it, t), en(this, ot, n);
  }
  list(t) {
    const n = (t == null ? void 0 : t.includeMembers) === !1 ? "/projects?includeMembers=false" : "/projects";
    return ne(_e(this, it), _e(this, ot), { uri: n });
  }
  /**
   * Fetch a project by project ID
   *
   * @param projectId - ID of the project to fetch
   */
  getById(t) {
    return ne(_e(this, it), _e(this, ot), { uri: `/projects/${t}` });
  }
}
it = /* @__PURE__ */ new WeakMap(), ot = /* @__PURE__ */ new WeakMap();
var st, at;
class Dc {
  constructor(t, n) {
    Zt(this, st, void 0), Zt(this, at, void 0), en(this, st, t), en(this, at, n);
  }
  list(t) {
    const n = (t == null ? void 0 : t.includeMembers) === !1 ? "/projects?includeMembers=false" : "/projects";
    return U(ne(_e(this, st), _e(this, at), { uri: n }));
  }
  /**
   * Fetch a project by project ID
   *
   * @param projectId - ID of the project to fetch
   */
  getById(t) {
    return U(
      ne(_e(this, st), _e(this, at), { uri: `/projects/${t}` })
    );
  }
}
st = /* @__PURE__ */ new WeakMap(), at = /* @__PURE__ */ new WeakMap();
var ho = (e, t, n) => {
  if (!t.has(e))
    throw TypeError("Cannot " + n);
}, tn = (e, t, n) => (ho(e, t, "read from private field"), n ? n.call(e) : t.get(e)), nn = (e, t, n) => {
  if (t.has(e))
    throw TypeError("Cannot add the same private member more than once");
  t instanceof WeakSet ? t.add(e) : t.set(e, n);
}, rn = (e, t, n, r) => (ho(e, t, "write to private field"), r ? r.call(e, n) : t.set(e, n), n), Bt, jt;
class qc {
  constructor(t, n) {
    nn(this, Bt, void 0), nn(this, jt, void 0), rn(this, Bt, t), rn(this, jt, n);
  }
  /**
   * Fetch a user by user ID
   *
   * @param id - User ID of the user to fetch. If `me` is provided, a minimal response including the users role is returned.
   */
  getById(t) {
    return ne(
      tn(this, Bt),
      tn(this, jt),
      { uri: `/users/${t}` }
    );
  }
}
Bt = /* @__PURE__ */ new WeakMap(), jt = /* @__PURE__ */ new WeakMap();
var Ut, Wt;
class Hc {
  constructor(t, n) {
    nn(this, Ut, void 0), nn(this, Wt, void 0), rn(this, Ut, t), rn(this, Wt, n);
  }
  /**
   * Fetch a user by user ID
   *
   * @param id - User ID of the user to fetch. If `me` is provided, a minimal response including the users role is returned.
   */
  getById(t) {
    return U(
      ne(tn(this, Ut), tn(this, Wt), {
        uri: `/users/${t}`
      })
    );
  }
}
Ut = /* @__PURE__ */ new WeakMap(), Wt = /* @__PURE__ */ new WeakMap();
var po = (e, t, n) => {
  if (!t.has(e))
    throw TypeError("Cannot " + n);
}, P = (e, t, n) => (po(e, t, "read from private field"), n ? n.call(e) : t.get(e)), on = (e, t, n) => {
  if (t.has(e))
    throw TypeError("Cannot add the same private member more than once");
  t instanceof WeakSet ? t.add(e) : t.set(e, n);
}, sn = (e, t, n, r) => (po(e, t, "write to private field"), r ? r.call(e, n) : t.set(e, n), n), ge, j;
const zc = class Mn {
  constructor(t, n = dt) {
    on(this, ge, void 0), on(this, j, void 0), this.listen = co, this.config(n), sn(this, j, t), this.assets = new xc(this, P(this, j)), this.datasets = new Mc(this, P(this, j)), this.projects = new Fc(this, P(this, j)), this.users = new qc(this, P(this, j));
  }
  /**
   * Clone the client - returns a new instance
   */
  clone() {
    return new Mn(P(this, j), this.config());
  }
  config(t) {
    if (t === void 0)
      return { ...P(this, ge) };
    if (P(this, ge) && P(this, ge).allowReconfigure === !1)
      throw new Error(
        "Existing client instance cannot be reconfigured - use `withConfig(newConfig)` to return a new client"
      );
    return sn(this, ge, Xi(t, P(this, ge) || {})), this;
  }
  /**
   * Clone the client with a new (partial) configuration.
   *
   * @param newConfig - New client configuration properties, shallowly merged with existing configuration
   */
  withConfig(t) {
    const n = this.config();
    return new Mn(P(this, j), {
      ...n,
      ...t,
      stega: {
        ...n.stega || {},
        ...typeof (t == null ? void 0 : t.stega) == "boolean" ? { enabled: t.stega } : (t == null ? void 0 : t.stega) || {}
      }
    });
  }
  fetch(t, n, r) {
    return Zi(
      this,
      P(this, j),
      P(this, ge).stega,
      t,
      n,
      r
    );
  }
  /**
   * Fetch a single document with the given ID.
   *
   * @param id - Document ID to fetch
   * @param options - Request options
   */
  getDocument(t, n) {
    return eo(this, P(this, j), t, n);
  }
  /**
   * Fetch multiple documents in one request.
   * Should be used sparingly - performing a query is usually a better option.
   * The order/position of documents is preserved based on the original array of IDs.
   * If any of the documents are missing, they will be replaced by a `null` entry in the returned array
   *
   * @param ids - Document IDs to fetch
   * @param options - Request options
   */
  getDocuments(t, n) {
    return to(this, P(this, j), t, n);
  }
  create(t, n) {
    return mn(this, P(this, j), t, "create", n);
  }
  createIfNotExists(t, n) {
    return no(this, P(this, j), t, n);
  }
  createOrReplace(t, n) {
    return ro(this, P(this, j), t, n);
  }
  delete(t, n) {
    return io(this, P(this, j), t, n);
  }
  mutate(t, n) {
    return oo(this, P(this, j), t, n);
  }
  /**
   * Create a new buildable patch of operations to perform
   *
   * @param selection - Document ID, an array of document IDs, or an object with `query` and optional `params`, defining which document(s) to patch
   * @param operations - Optional object of patch operations to initialize the patch instance with
   * @returns Patch instance - call `.commit()` to perform the operations defined
   */
  patch(t, n) {
    return new ut(t, n, this);
  }
  /**
   * Create a new transaction of mutations
   *
   * @param operations - Optional array of mutation operations to initialize the transaction instance with
   */
  transaction(t) {
    return new Gi(t, this);
  }
  /**
   * Perform an HTTP request against the Sanity API
   *
   * @param options - Request options
   */
  request(t) {
    return ne(this, P(this, j), t);
  }
  /**
   * Get a Sanity API URL for the URI provided
   *
   * @param uri - URI/path to build URL for
   * @param canUseCdn - Whether or not to allow using the API CDN for this route
   */
  getUrl(t, n) {
    return nr(this, t, n);
  }
  /**
   * Get a Sanity API URL for the data operation and path provided
   *
   * @param operation - Data operation (eg `query`, `mutate`, `listen` or similar)
   * @param path - Path to append after the operation
   */
  getDataUrl(t, n) {
    return tt(this, t, n);
  }
};
ge = /* @__PURE__ */ new WeakMap(), j = /* @__PURE__ */ new WeakMap();
let Bc = zc;
var ye, B;
const jc = class Ln {
  constructor(t, n = dt) {
    on(this, ye, void 0), on(this, B, void 0), this.listen = co, this.config(n), sn(this, B, t), this.assets = new Tc(this, P(this, B)), this.datasets = new Lc(this, P(this, B)), this.projects = new Dc(this, P(this, B)), this.users = new Hc(this, P(this, B)), this.observable = new Bc(t, n);
  }
  /**
   * Clone the client - returns a new instance
   */
  clone() {
    return new Ln(P(this, B), this.config());
  }
  config(t) {
    if (t === void 0)
      return { ...P(this, ye) };
    if (P(this, ye) && P(this, ye).allowReconfigure === !1)
      throw new Error(
        "Existing client instance cannot be reconfigured - use `withConfig(newConfig)` to return a new client"
      );
    return this.observable && this.observable.config(t), sn(this, ye, Xi(t, P(this, ye) || {})), this;
  }
  /**
   * Clone the client with a new (partial) configuration.
   *
   * @param newConfig - New client configuration properties, shallowly merged with existing configuration
   */
  withConfig(t) {
    const n = this.config();
    return new Ln(P(this, B), {
      ...n,
      ...t,
      stega: {
        ...n.stega || {},
        ...typeof (t == null ? void 0 : t.stega) == "boolean" ? { enabled: t.stega } : (t == null ? void 0 : t.stega) || {}
      }
    });
  }
  fetch(t, n, r) {
    return U(
      Zi(
        this,
        P(this, B),
        P(this, ye).stega,
        t,
        n,
        r
      )
    );
  }
  /**
   * Fetch a single document with the given ID.
   *
   * @param id - Document ID to fetch
   * @param options - Request options
   */
  getDocument(t, n) {
    return U(eo(this, P(this, B), t, n));
  }
  /**
   * Fetch multiple documents in one request.
   * Should be used sparingly - performing a query is usually a better option.
   * The order/position of documents is preserved based on the original array of IDs.
   * If any of the documents are missing, they will be replaced by a `null` entry in the returned array
   *
   * @param ids - Document IDs to fetch
   * @param options - Request options
   */
  getDocuments(t, n) {
    return U(to(this, P(this, B), t, n));
  }
  create(t, n) {
    return U(
      mn(this, P(this, B), t, "create", n)
    );
  }
  createIfNotExists(t, n) {
    return U(
      no(this, P(this, B), t, n)
    );
  }
  createOrReplace(t, n) {
    return U(
      ro(this, P(this, B), t, n)
    );
  }
  delete(t, n) {
    return U(io(this, P(this, B), t, n));
  }
  mutate(t, n) {
    return U(oo(this, P(this, B), t, n));
  }
  /**
   * Create a new buildable patch of operations to perform
   *
   * @param selection - Document ID, an array of document IDs, or an object with `query` and optional `params`, defining which document(s) to patch
   * @param operations - Optional object of patch operations to initialize the patch instance with
   * @returns Patch instance - call `.commit()` to perform the operations defined
   */
  patch(t, n) {
    return new lt(t, n, this);
  }
  /**
   * Create a new transaction of mutations
   *
   * @param operations - Optional array of mutation operations to initialize the transaction instance with
   */
  transaction(t) {
    return new Vi(t, this);
  }
  /**
   * Perform a request against the Sanity API
   * NOTE: Only use this for Sanity API endpoints, not for your own APIs!
   *
   * @param options - Request options
   * @returns Promise resolving to the response body
   */
  request(t) {
    return U(ne(this, P(this, B), t));
  }
  /**
   * Perform an HTTP request a `/data` sub-endpoint
   * NOTE: Considered internal, thus marked as deprecated. Use `request` instead.
   *
   * @deprecated - Use `request()` or your own HTTP library instead
   * @param endpoint - Endpoint to hit (mutate, query etc)
   * @param body - Request body
   * @param options - Request options
   * @internal
   */
  dataRequest(t, n, r) {
    return U($t(this, P(this, B), t, n, r));
  }
  /**
   * Get a Sanity API URL for the URI provided
   *
   * @param uri - URI/path to build URL for
   * @param canUseCdn - Whether or not to allow using the API CDN for this route
   */
  getUrl(t, n) {
    return nr(this, t, n);
  }
  /**
   * Get a Sanity API URL for the data operation and path provided
   *
   * @param operation - Data operation (eg `query`, `mutate`, `listen` or similar)
   * @param path - Path to append after the operation
   */
  getDataUrl(t, n) {
    return tt(this, t, n);
  }
};
ye = /* @__PURE__ */ new WeakMap(), B = /* @__PURE__ */ new WeakMap();
let Uc = jc;
function Wc(e, t) {
  return { requester: Sr(e, {}).defaultRequester, createClient: (n) => new t(
    Sr(e, {
      maxRetries: n.maxRetries,
      retryDelay: n.retryDelay
    }),
    n
  ) };
}
var Vc = [];
const Yc = Wc(Vc, Uc), Gc = Yc.createClient, mo = Gc({
  projectId: "0ls0csm4",
  dataset: "production",
  token: "skF3I3GTefhnWc6ta4QSMIwXiCUlQ1DHc2UuHfSoL22XgPVAnI6SX0e3Sxh5lLw7EnaIM4RHkd4w0ihgdtI7LFv7bNVF9sYS2PYeH87oQZitkj1M26Yl5mBHNV3YSYrTKxki5Ni2ABxP8mI3QSWc9u1tUCY4o43vbvZ5U4q2T8Qje5BXKeV3",
  useCdn: !1,
  ignoreBrowserTokenWarning: !0,
  apiVersion: "2020-01-01"
}), Qc = xs(mo), Xc = async (e, t = {}) => {
  try {
    return await mo.fetch(e, t);
  } catch (n) {
    throw console.log("Error fetching cms: ", n), n;
  }
}, Kc = (e) => Qc.image(e), go = {
  fetchCms: Xc,
  resolveImage: Kc
};
function Jc(e) {
  const t = [];
  return new Proxy(e, {
    apply(n, r, i) {
      const o = It(i), s = t.find((c) => rs(c.key, o));
      if (s)
        return s.value;
      const a = Reflect.apply(n, r, i);
      return t.push({ key: o, value: a }), a;
    }
  });
}
const Zc = Jc(go.fetchCms), eu = async (e) => {
  const t = Array.isArray(e) ? e : [e], n = is(t), i = `*[_type == "pages" && ${`label in ${JSON.stringify(n)}`} && __i18n_lang == "no" && !(_id in path("drafts.**"))]`;
  return await Zc(i);
}, yo = () => ({
  fetchPagesCms: eu
}), gn = () => {
  const e = (c) => {
    const u = c == null ? void 0 : c.icon;
    return u ? go.resolveImage(u).url() : "";
  }, t = (c, u) => c == null ? void 0 : c.find((l) => l.label === u);
  return {
    getIconUrl: e,
    getCmsItem: t,
    getCmsItemText: (c, u) => {
      const l = t(c, u);
      return (l == null ? void 0 : l.title) ?? "";
    },
    findIconAndResolveUrl: (c, u) => {
      if (!u)
        return "";
      const l = t(u, c);
      return l ? e(l) : "";
    },
    getServiceIcon: (c, u) => {
      const l = c == null ? void 0 : c.icons;
      if (l != null && l.length)
        return e(l[0]);
      const d = u == null ? void 0 : u.icons;
      return d != null && d.length ? e(d[0]) : "";
    },
    getServiceName: (c, u) => {
      const l = c == null ? void 0 : c.title, d = u == null ? void 0 : u.name;
      return l || d || "";
    },
    getServiceTypeCms: (c, u) => c == null ? void 0 : c.find(
      (l) => l.label === u
    ),
    getServiceCategoryCms: (c, u) => {
      var l;
      return (l = c == null ? void 0 : c.serviceCategories) == null ? void 0 : l.find(
        (d) => d.label === u
      );
    }
  };
}, tu = ["src"], nu = /* @__PURE__ */ G({
  __name: "NotificationsButton",
  props: {
    audience: {},
    audienceId: {}
  },
  emits: ["clicked"],
  setup(e, { emit: t }) {
    const n = t, r = e, i = Wn(), { fetchPagesCms: o } = yo(), { getCmsItem: s, findIconAndResolveUrl: a } = gn(), c = fn({
      cms: void 0
    }), u = L(() => {
      var _;
      return s((_ = c.cms) == null ? void 0 : _.buttons, "notificationsButton");
    }), l = L(() => {
      var _;
      return a("icon", (_ = u.value) == null ? void 0 : _.icons);
    }), d = L(() => {
      var _;
      return a("activeIcon", (_ = u.value) == null ? void 0 : _.icons);
    }), f = L(
      () => i.unreadNotifications
    ), y = L(() => {
      var _;
      return !!((_ = f.value.items) != null && _.length);
    }), w = () => {
      n("clicked");
    }, v = async () => {
      const _ = await o(Vn.NOTIFICATIONS_COMPONENT);
      c.cms = _ == null ? void 0 : _[0];
    };
    return (() => {
      v(), i.allNotifications.items || i.fetchMoreNotifications(
        r.audience,
        r.audienceId,
        le.ALL
      ), i.unreadNotifications.items || i.fetchMoreNotifications(
        r.audience,
        r.audienceId,
        le.UNREAD
      );
    })(), (_, C) => (N(), q("button", {
      class: "notifications-button",
      onClick: w
    }, [
      H("img", {
        src: y.value ? d.value : l.value,
        alt: ""
      }, null, 8, tu)
    ]));
  }
}), he = (e, t) => {
  const n = e.__vccOpts || e;
  for (const [r, i] of t)
    n[r] = i;
  return n;
}, Ul = /* @__PURE__ */ he(nu, [["__scopeId", "data-v-ed9c2bbb"]]), ru = /* @__PURE__ */ G({
  __name: "NotificationsTab",
  props: {
    text: {
      type: String,
      required: !0
    },
    active: {
      type: Boolean,
      default: !1
    }
  },
  setup(e) {
    const t = e, n = L(() => t.active ? ["base-tab--active"] : ["base-tab--inactive"]);
    return (r, i) => (N(), q("div", {
      class: ze(["base-tab", n.value])
    }, [
      H("span", null, oe(e.text), 1)
    ], 2));
  }
}), iu = /* @__PURE__ */ he(ru, [["__scopeId", "data-v-71b44ff3"]]), ou = { class: "base-tabs" }, su = { class: "base-tabs__content" }, au = ["onClick"], cu = /* @__PURE__ */ G({
  __name: "NotificationsTabs",
  props: {
    tabs: {
      type: Array,
      required: !0
    },
    activeTabLabel: {
      type: String,
      default: ""
    }
  },
  emits: ["tab-changed"],
  setup(e, { emit: t }) {
    const n = t, r = (i) => {
      n("tab-changed", i);
    };
    return (i, o) => (N(), q("div", ou, [
      H("div", su, [
        (N(!0), q(Ge, null, jn(e.tabs, (s) => (N(), q("div", {
          key: s.label,
          class: "base-tabs__tab",
          onClick: (a) => r(s.label)
        }, [
          xe(iu, {
            text: s.text,
            active: s.label === e.activeTabLabel
          }, null, 8, ["text", "active"])
        ], 8, au))), 128))
      ])
    ]));
  }
}), uu = /* @__PURE__ */ he(cu, [["__scopeId", "data-v-809df7cb"]]);
var lu = { exports: {} };
(function(e, t) {
  (function(n, r) {
    e.exports = r(Rn);
  })(Xr, function(n) {
    function r(s) {
      return s && typeof s == "object" && "default" in s ? s : { default: s };
    }
    var i = r(n), o = { name: "nb", weekdays: "søndag_mandag_tirsdag_onsdag_torsdag_fredag_lørdag".split("_"), weekdaysShort: "sø._ma._ti._on._to._fr._lø.".split("_"), weekdaysMin: "sø_ma_ti_on_to_fr_lø".split("_"), months: "januar_februar_mars_april_mai_juni_juli_august_september_oktober_november_desember".split("_"), monthsShort: "jan._feb._mars_april_mai_juni_juli_aug._sep._okt._nov._des.".split("_"), ordinal: function(s) {
      return s + ".";
    }, weekStart: 1, yearStart: 4, formats: { LT: "HH:mm", LTS: "HH:mm:ss", L: "DD.MM.YYYY", LL: "D. MMMM YYYY", LLL: "D. MMMM YYYY [kl.] HH:mm", LLLL: "dddd D. MMMM YYYY [kl.] HH:mm" }, relativeTime: { future: "om %s", past: "%s siden", s: "noen sekunder", m: "ett minutt", mm: "%d minutter", h: "en time", hh: "%d timer", d: "en dag", dd: "%d dager", M: "en måned", MM: "%d måneder", y: "ett år", yy: "%d år" } };
    return i.default.locale(o, null, !0), o;
  });
})(lu);
const du = ["top", "right", "bottom", "left"], Tr = ["start", "end"], Ar = /* @__PURE__ */ du.reduce((e, t) => e.concat(t, t + "-" + Tr[0], t + "-" + Tr[1]), []), qe = Math.min, De = Math.max, fu = {
  left: "right",
  right: "left",
  bottom: "top",
  top: "bottom"
}, hu = {
  start: "end",
  end: "start"
};
function Fn(e, t, n) {
  return De(e, qe(t, n));
}
function Ue(e, t) {
  return typeof e == "function" ? e(t) : e;
}
function ce(e) {
  return e.split("-")[0];
}
function te(e) {
  return e.split("-")[1];
}
function vo(e) {
  return e === "x" ? "y" : "x";
}
function rr(e) {
  return e === "y" ? "height" : "width";
}
function Tt(e) {
  return ["top", "bottom"].includes(ce(e)) ? "y" : "x";
}
function ir(e) {
  return vo(Tt(e));
}
function wo(e, t, n) {
  n === void 0 && (n = !1);
  const r = te(e), i = ir(e), o = rr(i);
  let s = i === "x" ? r === (n ? "end" : "start") ? "right" : "left" : r === "start" ? "bottom" : "top";
  return t.reference[o] > t.floating[o] && (s = cn(s)), [s, cn(s)];
}
function pu(e) {
  const t = cn(e);
  return [an(e), t, an(t)];
}
function an(e) {
  return e.replace(/start|end/g, (t) => hu[t]);
}
function mu(e, t, n) {
  const r = ["left", "right"], i = ["right", "left"], o = ["top", "bottom"], s = ["bottom", "top"];
  switch (e) {
    case "top":
    case "bottom":
      return n ? t ? i : r : t ? r : i;
    case "left":
    case "right":
      return t ? o : s;
    default:
      return [];
  }
}
function gu(e, t, n, r) {
  const i = te(e);
  let o = mu(ce(e), n === "start", r);
  return i && (o = o.map((s) => s + "-" + i), t && (o = o.concat(o.map(an)))), o;
}
function cn(e) {
  return e.replace(/left|right|bottom|top/g, (t) => fu[t]);
}
function yu(e) {
  return {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    ...e
  };
}
function bo(e) {
  return typeof e != "number" ? yu(e) : {
    top: e,
    right: e,
    bottom: e,
    left: e
  };
}
function ft(e) {
  const {
    x: t,
    y: n,
    width: r,
    height: i
  } = e;
  return {
    width: r,
    height: i,
    top: n,
    left: t,
    right: t + r,
    bottom: n + i,
    x: t,
    y: n
  };
}
function Er(e, t, n) {
  let {
    reference: r,
    floating: i
  } = e;
  const o = Tt(t), s = ir(t), a = rr(s), c = ce(t), u = o === "y", l = r.x + r.width / 2 - i.width / 2, d = r.y + r.height / 2 - i.height / 2, f = r[a] / 2 - i[a] / 2;
  let y;
  switch (c) {
    case "top":
      y = {
        x: l,
        y: r.y - i.height
      };
      break;
    case "bottom":
      y = {
        x: l,
        y: r.y + r.height
      };
      break;
    case "right":
      y = {
        x: r.x + r.width,
        y: d
      };
      break;
    case "left":
      y = {
        x: r.x - i.width,
        y: d
      };
      break;
    default:
      y = {
        x: r.x,
        y: r.y
      };
  }
  switch (te(t)) {
    case "start":
      y[s] -= f * (n && u ? -1 : 1);
      break;
    case "end":
      y[s] += f * (n && u ? -1 : 1);
      break;
  }
  return y;
}
const vu = async (e, t, n) => {
  const {
    placement: r = "bottom",
    strategy: i = "absolute",
    middleware: o = [],
    platform: s
  } = n, a = o.filter(Boolean), c = await (s.isRTL == null ? void 0 : s.isRTL(t));
  let u = await s.getElementRects({
    reference: e,
    floating: t,
    strategy: i
  }), {
    x: l,
    y: d
  } = Er(u, r, c), f = r, y = {}, w = 0;
  for (let v = 0; v < a.length; v++) {
    const {
      name: b,
      fn: _
    } = a[v], {
      x: C,
      y: T,
      data: $,
      reset: R
    } = await _({
      x: l,
      y: d,
      initialPlacement: r,
      placement: f,
      strategy: i,
      middlewareData: y,
      rects: u,
      platform: s,
      elements: {
        reference: e,
        floating: t
      }
    });
    l = C ?? l, d = T ?? d, y = {
      ...y,
      [b]: {
        ...y[b],
        ...$
      }
    }, R && w <= 50 && (w++, typeof R == "object" && (R.placement && (f = R.placement), R.rects && (u = R.rects === !0 ? await s.getElementRects({
      reference: e,
      floating: t,
      strategy: i
    }) : R.rects), {
      x: l,
      y: d
    } = Er(u, f, c)), v = -1);
  }
  return {
    x: l,
    y: d,
    placement: f,
    strategy: i,
    middlewareData: y
  };
};
async function yn(e, t) {
  var n;
  t === void 0 && (t = {});
  const {
    x: r,
    y: i,
    platform: o,
    rects: s,
    elements: a,
    strategy: c
  } = e, {
    boundary: u = "clippingAncestors",
    rootBoundary: l = "viewport",
    elementContext: d = "floating",
    altBoundary: f = !1,
    padding: y = 0
  } = Ue(t, e), w = bo(y), b = a[f ? d === "floating" ? "reference" : "floating" : d], _ = ft(await o.getClippingRect({
    element: (n = await (o.isElement == null ? void 0 : o.isElement(b))) == null || n ? b : b.contextElement || await (o.getDocumentElement == null ? void 0 : o.getDocumentElement(a.floating)),
    boundary: u,
    rootBoundary: l,
    strategy: c
  })), C = d === "floating" ? {
    x: r,
    y: i,
    width: s.floating.width,
    height: s.floating.height
  } : s.reference, T = await (o.getOffsetParent == null ? void 0 : o.getOffsetParent(a.floating)), $ = await (o.isElement == null ? void 0 : o.isElement(T)) ? await (o.getScale == null ? void 0 : o.getScale(T)) || {
    x: 1,
    y: 1
  } : {
    x: 1,
    y: 1
  }, R = ft(o.convertOffsetParentRelativeRectToViewportRelativeRect ? await o.convertOffsetParentRelativeRectToViewportRelativeRect({
    elements: a,
    rect: C,
    offsetParent: T,
    strategy: c
  }) : C);
  return {
    top: (_.top - R.top + w.top) / $.y,
    bottom: (R.bottom - _.bottom + w.bottom) / $.y,
    left: (_.left - R.left + w.left) / $.x,
    right: (R.right - _.right + w.right) / $.x
  };
}
const wu = (e) => ({
  name: "arrow",
  options: e,
  async fn(t) {
    const {
      x: n,
      y: r,
      placement: i,
      rects: o,
      platform: s,
      elements: a,
      middlewareData: c
    } = t, {
      element: u,
      padding: l = 0
    } = Ue(e, t) || {};
    if (u == null)
      return {};
    const d = bo(l), f = {
      x: n,
      y: r
    }, y = ir(i), w = rr(y), v = await s.getDimensions(u), b = y === "y", _ = b ? "top" : "left", C = b ? "bottom" : "right", T = b ? "clientHeight" : "clientWidth", $ = o.reference[w] + o.reference[y] - f[y] - o.floating[w], R = f[y] - o.reference[y], M = await (s.getOffsetParent == null ? void 0 : s.getOffsetParent(u));
    let F = M ? M[T] : 0;
    (!F || !await (s.isElement == null ? void 0 : s.isElement(M))) && (F = a.floating[T] || o.floating[w]);
    const z = $ / 2 - R / 2, A = F / 2 - v[w] / 2 - 1, E = qe(d[_], A), m = qe(d[C], A), g = E, h = F - v[w] - m, p = F / 2 - v[w] / 2 + z, x = Fn(g, p, h), S = !c.arrow && te(i) != null && p !== x && o.reference[w] / 2 - (p < g ? E : m) - v[w] / 2 < 0, O = S ? p < g ? p - g : p - h : 0;
    return {
      [y]: f[y] + O,
      data: {
        [y]: x,
        centerOffset: p - x - O,
        ...S && {
          alignmentOffset: O
        }
      },
      reset: S
    };
  }
});
function bu(e, t, n) {
  return (e ? [...n.filter((i) => te(i) === e), ...n.filter((i) => te(i) !== e)] : n.filter((i) => ce(i) === i)).filter((i) => e ? te(i) === e || (t ? an(i) !== i : !1) : !0);
}
const _u = function(e) {
  return e === void 0 && (e = {}), {
    name: "autoPlacement",
    options: e,
    async fn(t) {
      var n, r, i;
      const {
        rects: o,
        middlewareData: s,
        placement: a,
        platform: c,
        elements: u
      } = t, {
        crossAxis: l = !1,
        alignment: d,
        allowedPlacements: f = Ar,
        autoAlignment: y = !0,
        ...w
      } = Ue(e, t), v = d !== void 0 || f === Ar ? bu(d || null, y, f) : f, b = await yn(t, w), _ = ((n = s.autoPlacement) == null ? void 0 : n.index) || 0, C = v[_];
      if (C == null)
        return {};
      const T = wo(C, o, await (c.isRTL == null ? void 0 : c.isRTL(u.floating)));
      if (a !== C)
        return {
          reset: {
            placement: v[0]
          }
        };
      const $ = [b[ce(C)], b[T[0]], b[T[1]]], R = [...((r = s.autoPlacement) == null ? void 0 : r.overflows) || [], {
        placement: C,
        overflows: $
      }], M = v[_ + 1];
      if (M)
        return {
          data: {
            index: _ + 1,
            overflows: R
          },
          reset: {
            placement: M
          }
        };
      const F = R.map((E) => {
        const m = te(E.placement);
        return [E.placement, m && l ? (
          // Check along the mainAxis and main crossAxis side.
          E.overflows.slice(0, 2).reduce((g, h) => g + h, 0)
        ) : (
          // Check only the mainAxis.
          E.overflows[0]
        ), E.overflows];
      }).sort((E, m) => E[1] - m[1]), A = ((i = F.filter((E) => E[2].slice(
        0,
        // Aligned placements should not check their opposite crossAxis
        // side.
        te(E[0]) ? 2 : 3
      ).every((m) => m <= 0))[0]) == null ? void 0 : i[0]) || F[0][0];
      return A !== a ? {
        data: {
          index: _ + 1,
          overflows: R
        },
        reset: {
          placement: A
        }
      } : {};
    }
  };
}, Su = function(e) {
  return e === void 0 && (e = {}), {
    name: "flip",
    options: e,
    async fn(t) {
      var n, r;
      const {
        placement: i,
        middlewareData: o,
        rects: s,
        initialPlacement: a,
        platform: c,
        elements: u
      } = t, {
        mainAxis: l = !0,
        crossAxis: d = !0,
        fallbackPlacements: f,
        fallbackStrategy: y = "bestFit",
        fallbackAxisSideDirection: w = "none",
        flipAlignment: v = !0,
        ...b
      } = Ue(e, t);
      if ((n = o.arrow) != null && n.alignmentOffset)
        return {};
      const _ = ce(i), C = ce(a) === a, T = await (c.isRTL == null ? void 0 : c.isRTL(u.floating)), $ = f || (C || !v ? [cn(a)] : pu(a));
      !f && w !== "none" && $.push(...gu(a, v, w, T));
      const R = [a, ...$], M = await yn(t, b), F = [];
      let z = ((r = o.flip) == null ? void 0 : r.overflows) || [];
      if (l && F.push(M[_]), d) {
        const g = wo(i, s, T);
        F.push(M[g[0]], M[g[1]]);
      }
      if (z = [...z, {
        placement: i,
        overflows: F
      }], !F.every((g) => g <= 0)) {
        var A, E;
        const g = (((A = o.flip) == null ? void 0 : A.index) || 0) + 1, h = R[g];
        if (h)
          return {
            data: {
              index: g,
              overflows: z
            },
            reset: {
              placement: h
            }
          };
        let p = (E = z.filter((x) => x.overflows[0] <= 0).sort((x, S) => x.overflows[1] - S.overflows[1])[0]) == null ? void 0 : E.placement;
        if (!p)
          switch (y) {
            case "bestFit": {
              var m;
              const x = (m = z.map((S) => [S.placement, S.overflows.filter((O) => O > 0).reduce((O, I) => O + I, 0)]).sort((S, O) => S[1] - O[1])[0]) == null ? void 0 : m[0];
              x && (p = x);
              break;
            }
            case "initialPlacement":
              p = a;
              break;
          }
        if (i !== p)
          return {
            reset: {
              placement: p
            }
          };
      }
      return {};
    }
  };
};
async function Cu(e, t) {
  const {
    placement: n,
    platform: r,
    elements: i
  } = e, o = await (r.isRTL == null ? void 0 : r.isRTL(i.floating)), s = ce(n), a = te(n), c = Tt(n) === "y", u = ["left", "top"].includes(s) ? -1 : 1, l = o && c ? -1 : 1, d = Ue(t, e);
  let {
    mainAxis: f,
    crossAxis: y,
    alignmentAxis: w
  } = typeof d == "number" ? {
    mainAxis: d,
    crossAxis: 0,
    alignmentAxis: null
  } : {
    mainAxis: 0,
    crossAxis: 0,
    alignmentAxis: null,
    ...d
  };
  return a && typeof w == "number" && (y = a === "end" ? w * -1 : w), c ? {
    x: y * l,
    y: f * u
  } : {
    x: f * u,
    y: y * l
  };
}
const $u = function(e) {
  return e === void 0 && (e = 0), {
    name: "offset",
    options: e,
    async fn(t) {
      var n, r;
      const {
        x: i,
        y: o,
        placement: s,
        middlewareData: a
      } = t, c = await Cu(t, e);
      return s === ((n = a.offset) == null ? void 0 : n.placement) && (r = a.arrow) != null && r.alignmentOffset ? {} : {
        x: i + c.x,
        y: o + c.y,
        data: {
          ...c,
          placement: s
        }
      };
    }
  };
}, xu = function(e) {
  return e === void 0 && (e = {}), {
    name: "shift",
    options: e,
    async fn(t) {
      const {
        x: n,
        y: r,
        placement: i
      } = t, {
        mainAxis: o = !0,
        crossAxis: s = !1,
        limiter: a = {
          fn: (b) => {
            let {
              x: _,
              y: C
            } = b;
            return {
              x: _,
              y: C
            };
          }
        },
        ...c
      } = Ue(e, t), u = {
        x: n,
        y: r
      }, l = await yn(t, c), d = Tt(ce(i)), f = vo(d);
      let y = u[f], w = u[d];
      if (o) {
        const b = f === "y" ? "top" : "left", _ = f === "y" ? "bottom" : "right", C = y + l[b], T = y - l[_];
        y = Fn(C, y, T);
      }
      if (s) {
        const b = d === "y" ? "top" : "left", _ = d === "y" ? "bottom" : "right", C = w + l[b], T = w - l[_];
        w = Fn(C, w, T);
      }
      const v = a.fn({
        ...t,
        [f]: y,
        [d]: w
      });
      return {
        ...v,
        data: {
          x: v.x - n,
          y: v.y - r
        }
      };
    }
  };
}, Tu = function(e) {
  return e === void 0 && (e = {}), {
    name: "size",
    options: e,
    async fn(t) {
      const {
        placement: n,
        rects: r,
        platform: i,
        elements: o
      } = t, {
        apply: s = () => {
        },
        ...a
      } = Ue(e, t), c = await yn(t, a), u = ce(n), l = te(n), d = Tt(n) === "y", {
        width: f,
        height: y
      } = r.floating;
      let w, v;
      u === "top" || u === "bottom" ? (w = u, v = l === (await (i.isRTL == null ? void 0 : i.isRTL(o.floating)) ? "start" : "end") ? "left" : "right") : (v = u, w = l === "end" ? "top" : "bottom");
      const b = y - c.top - c.bottom, _ = f - c.left - c.right, C = qe(y - c[w], b), T = qe(f - c[v], _), $ = !t.middlewareData.shift;
      let R = C, M = T;
      if (d ? M = l || $ ? qe(T, _) : _ : R = l || $ ? qe(C, b) : b, $ && !l) {
        const z = De(c.left, 0), A = De(c.right, 0), E = De(c.top, 0), m = De(c.bottom, 0);
        d ? M = f - 2 * (z !== 0 || A !== 0 ? z + A : De(c.left, c.right)) : R = y - 2 * (E !== 0 || m !== 0 ? E + m : De(c.top, c.bottom));
      }
      await s({
        ...t,
        availableWidth: M,
        availableHeight: R
      });
      const F = await i.getDimensions(o.floating);
      return f !== F.width || y !== F.height ? {
        reset: {
          rects: !0
        }
      } : {};
    }
  };
};
function J(e) {
  var t;
  return ((t = e.ownerDocument) == null ? void 0 : t.defaultView) || window;
}
function se(e) {
  return J(e).getComputedStyle(e);
}
const Or = Math.min, ht = Math.max, un = Math.round;
function _o(e) {
  const t = se(e);
  let n = parseFloat(t.width), r = parseFloat(t.height);
  const i = e.offsetWidth, o = e.offsetHeight, s = un(n) !== i || un(r) !== o;
  return s && (n = i, r = o), { width: n, height: r, fallback: s };
}
function Te(e) {
  return Co(e) ? (e.nodeName || "").toLowerCase() : "";
}
let Rt;
function So() {
  if (Rt)
    return Rt;
  const e = navigator.userAgentData;
  return e && Array.isArray(e.brands) ? (Rt = e.brands.map((t) => t.brand + "/" + t.version).join(" "), Rt) : navigator.userAgent;
}
function ae(e) {
  return e instanceof J(e).HTMLElement;
}
function Ce(e) {
  return e instanceof J(e).Element;
}
function Co(e) {
  return e instanceof J(e).Node;
}
function Rr(e) {
  return typeof ShadowRoot > "u" ? !1 : e instanceof J(e).ShadowRoot || e instanceof ShadowRoot;
}
function vn(e) {
  const { overflow: t, overflowX: n, overflowY: r, display: i } = se(e);
  return /auto|scroll|overlay|hidden|clip/.test(t + r + n) && !["inline", "contents"].includes(i);
}
function Au(e) {
  return ["table", "td", "th"].includes(Te(e));
}
function Dn(e) {
  const t = /firefox/i.test(So()), n = se(e), r = n.backdropFilter || n.WebkitBackdropFilter;
  return n.transform !== "none" || n.perspective !== "none" || !!r && r !== "none" || t && n.willChange === "filter" || t && !!n.filter && n.filter !== "none" || ["transform", "perspective"].some((i) => n.willChange.includes(i)) || ["paint", "layout", "strict", "content"].some((i) => {
    const o = n.contain;
    return o != null && o.includes(i);
  });
}
function $o() {
  return !/^((?!chrome|android).)*safari/i.test(So());
}
function or(e) {
  return ["html", "body", "#document"].includes(Te(e));
}
function xo(e) {
  return Ce(e) ? e : e.contextElement;
}
const To = { x: 1, y: 1 };
function Je(e) {
  const t = xo(e);
  if (!ae(t))
    return To;
  const n = t.getBoundingClientRect(), { width: r, height: i, fallback: o } = _o(t);
  let s = (o ? un(n.width) : n.width) / r, a = (o ? un(n.height) : n.height) / i;
  return s && Number.isFinite(s) || (s = 1), a && Number.isFinite(a) || (a = 1), { x: s, y: a };
}
function bt(e, t, n, r) {
  var i, o;
  t === void 0 && (t = !1), n === void 0 && (n = !1);
  const s = e.getBoundingClientRect(), a = xo(e);
  let c = To;
  t && (r ? Ce(r) && (c = Je(r)) : c = Je(e));
  const u = a ? J(a) : window, l = !$o() && n;
  let d = (s.left + (l && ((i = u.visualViewport) == null ? void 0 : i.offsetLeft) || 0)) / c.x, f = (s.top + (l && ((o = u.visualViewport) == null ? void 0 : o.offsetTop) || 0)) / c.y, y = s.width / c.x, w = s.height / c.y;
  if (a) {
    const v = J(a), b = r && Ce(r) ? J(r) : r;
    let _ = v.frameElement;
    for (; _ && r && b !== v; ) {
      const C = Je(_), T = _.getBoundingClientRect(), $ = getComputedStyle(_);
      T.x += (_.clientLeft + parseFloat($.paddingLeft)) * C.x, T.y += (_.clientTop + parseFloat($.paddingTop)) * C.y, d *= C.x, f *= C.y, y *= C.x, w *= C.y, d += T.x, f += T.y, _ = J(_).frameElement;
    }
  }
  return { width: y, height: w, top: f, right: d + y, bottom: f + w, left: d, x: d, y: f };
}
function $e(e) {
  return ((Co(e) ? e.ownerDocument : e.document) || window.document).documentElement;
}
function wn(e) {
  return Ce(e) ? { scrollLeft: e.scrollLeft, scrollTop: e.scrollTop } : { scrollLeft: e.pageXOffset, scrollTop: e.pageYOffset };
}
function Ao(e) {
  return bt($e(e)).left + wn(e).scrollLeft;
}
function _t(e) {
  if (Te(e) === "html")
    return e;
  const t = e.assignedSlot || e.parentNode || Rr(e) && e.host || $e(e);
  return Rr(t) ? t.host : t;
}
function Eo(e) {
  const t = _t(e);
  return or(t) ? t.ownerDocument.body : ae(t) && vn(t) ? t : Eo(t);
}
function ln(e, t) {
  var n;
  t === void 0 && (t = []);
  const r = Eo(e), i = r === ((n = e.ownerDocument) == null ? void 0 : n.body), o = J(r);
  return i ? t.concat(o, o.visualViewport || [], vn(r) ? r : []) : t.concat(r, ln(r));
}
function Pr(e, t, n) {
  return t === "viewport" ? ft(function(r, i) {
    const o = J(r), s = $e(r), a = o.visualViewport;
    let c = s.clientWidth, u = s.clientHeight, l = 0, d = 0;
    if (a) {
      c = a.width, u = a.height;
      const f = $o();
      (f || !f && i === "fixed") && (l = a.offsetLeft, d = a.offsetTop);
    }
    return { width: c, height: u, x: l, y: d };
  }(e, n)) : Ce(t) ? ft(function(r, i) {
    const o = bt(r, !0, i === "fixed"), s = o.top + r.clientTop, a = o.left + r.clientLeft, c = ae(r) ? Je(r) : { x: 1, y: 1 };
    return { width: r.clientWidth * c.x, height: r.clientHeight * c.y, x: a * c.x, y: s * c.y };
  }(t, n)) : ft(function(r) {
    const i = $e(r), o = wn(r), s = r.ownerDocument.body, a = ht(i.scrollWidth, i.clientWidth, s.scrollWidth, s.clientWidth), c = ht(i.scrollHeight, i.clientHeight, s.scrollHeight, s.clientHeight);
    let u = -o.scrollLeft + Ao(r);
    const l = -o.scrollTop;
    return se(s).direction === "rtl" && (u += ht(i.clientWidth, s.clientWidth) - a), { width: a, height: c, x: u, y: l };
  }($e(e)));
}
function Ir(e) {
  return ae(e) && se(e).position !== "fixed" ? e.offsetParent : null;
}
function kr(e) {
  const t = J(e);
  let n = Ir(e);
  for (; n && Au(n) && se(n).position === "static"; )
    n = Ir(n);
  return n && (Te(n) === "html" || Te(n) === "body" && se(n).position === "static" && !Dn(n)) ? t : n || function(r) {
    let i = _t(r);
    for (; ae(i) && !or(i); ) {
      if (Dn(i))
        return i;
      i = _t(i);
    }
    return null;
  }(e) || t;
}
function Eu(e, t, n) {
  const r = ae(t), i = $e(t), o = bt(e, !0, n === "fixed", t);
  let s = { scrollLeft: 0, scrollTop: 0 };
  const a = { x: 0, y: 0 };
  if (r || !r && n !== "fixed")
    if ((Te(t) !== "body" || vn(i)) && (s = wn(t)), ae(t)) {
      const c = bt(t, !0);
      a.x = c.x + t.clientLeft, a.y = c.y + t.clientTop;
    } else
      i && (a.x = Ao(i));
  return { x: o.left + s.scrollLeft - a.x, y: o.top + s.scrollTop - a.y, width: o.width, height: o.height };
}
const Ou = { getClippingRect: function(e) {
  let { element: t, boundary: n, rootBoundary: r, strategy: i } = e;
  const o = n === "clippingAncestors" ? function(u, l) {
    const d = l.get(u);
    if (d)
      return d;
    let f = ln(u).filter((b) => Ce(b) && Te(b) !== "body"), y = null;
    const w = se(u).position === "fixed";
    let v = w ? _t(u) : u;
    for (; Ce(v) && !or(v); ) {
      const b = se(v), _ = Dn(v);
      (w ? _ || y : _ || b.position !== "static" || !y || !["absolute", "fixed"].includes(y.position)) ? y = b : f = f.filter((C) => C !== v), v = _t(v);
    }
    return l.set(u, f), f;
  }(t, this._c) : [].concat(n), s = [...o, r], a = s[0], c = s.reduce((u, l) => {
    const d = Pr(t, l, i);
    return u.top = ht(d.top, u.top), u.right = Or(d.right, u.right), u.bottom = Or(d.bottom, u.bottom), u.left = ht(d.left, u.left), u;
  }, Pr(t, a, i));
  return { width: c.right - c.left, height: c.bottom - c.top, x: c.left, y: c.top };
}, convertOffsetParentRelativeRectToViewportRelativeRect: function(e) {
  let { rect: t, offsetParent: n, strategy: r } = e;
  const i = ae(n), o = $e(n);
  if (n === o)
    return t;
  let s = { scrollLeft: 0, scrollTop: 0 }, a = { x: 1, y: 1 };
  const c = { x: 0, y: 0 };
  if ((i || !i && r !== "fixed") && ((Te(n) !== "body" || vn(o)) && (s = wn(n)), ae(n))) {
    const u = bt(n);
    a = Je(n), c.x = u.x + n.clientLeft, c.y = u.y + n.clientTop;
  }
  return { width: t.width * a.x, height: t.height * a.y, x: t.x * a.x - s.scrollLeft * a.x + c.x, y: t.y * a.y - s.scrollTop * a.y + c.y };
}, isElement: Ce, getDimensions: function(e) {
  return ae(e) ? _o(e) : e.getBoundingClientRect();
}, getOffsetParent: kr, getDocumentElement: $e, getScale: Je, async getElementRects(e) {
  let { reference: t, floating: n, strategy: r } = e;
  const i = this.getOffsetParent || kr, o = this.getDimensions;
  return { reference: Eu(t, await i(n), r), floating: { x: 0, y: 0, ...await o(n) } };
}, getClientRects: (e) => Array.from(e.getClientRects()), isRTL: (e) => se(e).direction === "rtl" }, Ru = (e, t, n) => {
  const r = /* @__PURE__ */ new Map(), i = { platform: Ou, ...n }, o = { ...i.platform, _c: r };
  return vu(e, t, { ...i, platform: o });
}, He = {
  // Disable popper components
  disabled: !1,
  // Default position offset along main axis (px)
  distance: 5,
  // Default position offset along cross axis (px)
  skidding: 0,
  // Default container where the tooltip will be appended
  container: "body",
  // Element used to compute position and size boundaries
  boundary: void 0,
  // Skip delay & CSS transitions when another popper is shown, so that the popper appear to instanly move to the new position.
  instantMove: !1,
  // Auto destroy tooltip DOM nodes (ms)
  disposeTimeout: 150,
  // Triggers on the popper itself
  popperTriggers: [],
  // Positioning strategy
  strategy: "absolute",
  // Prevent overflow
  preventOverflow: !0,
  // Flip to the opposite placement if needed
  flip: !0,
  // Shift on the cross axis to prevent the popper from overflowing
  shift: !0,
  // Overflow padding (px)
  overflowPadding: 0,
  // Arrow padding (px)
  arrowPadding: 0,
  // Compute arrow overflow (useful to hide it)
  arrowOverflow: !0,
  /**
   * By default, compute autohide on 'click'.
   */
  autoHideOnMousedown: !1,
  // Themes
  themes: {
    tooltip: {
      // Default tooltip placement relative to target element
      placement: "top",
      // Default events that trigger the tooltip
      triggers: ["hover", "focus", "touch"],
      // Close tooltip on click on tooltip target
      hideTriggers: (e) => [...e, "click"],
      // Delay (ms)
      delay: {
        show: 200,
        hide: 0
      },
      // Update popper on content resize
      handleResize: !1,
      // Enable HTML content in directive
      html: !1,
      // Displayed when tooltip content is loading
      loadingContent: "..."
    },
    dropdown: {
      // Default dropdown placement relative to target element
      placement: "bottom",
      // Default events that trigger the dropdown
      triggers: ["click"],
      // Delay (ms)
      delay: 0,
      // Update popper on content resize
      handleResize: !0,
      // Hide on clock outside
      autoHide: !0
    },
    menu: {
      $extend: "dropdown",
      triggers: ["hover", "focus"],
      popperTriggers: ["hover"],
      delay: {
        show: 0,
        hide: 400
      }
    }
  }
};
function qn(e, t) {
  let n = He.themes[e] || {}, r;
  do
    r = n[t], typeof r > "u" ? n.$extend ? n = He.themes[n.$extend] || {} : (n = null, r = He[t]) : n = null;
  while (n);
  return r;
}
function Pu(e) {
  const t = [e];
  let n = He.themes[e] || {};
  do
    n.$extend && !n.$resetCss ? (t.push(n.$extend), n = He.themes[n.$extend] || {}) : n = null;
  while (n);
  return t.map((r) => `v-popper--theme-${r}`);
}
function Nr(e) {
  const t = [e];
  let n = He.themes[e] || {};
  do
    n.$extend ? (t.push(n.$extend), n = He.themes[n.$extend] || {}) : n = null;
  while (n);
  return t;
}
let Ze = !1;
if (typeof window < "u") {
  Ze = !1;
  try {
    const e = Object.defineProperty({}, "passive", {
      get() {
        Ze = !0;
      }
    });
    window.addEventListener("test", null, e);
  } catch {
  }
}
let Oo = !1;
typeof window < "u" && typeof navigator < "u" && (Oo = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream);
const Iu = ["auto", "top", "bottom", "left", "right"].reduce((e, t) => e.concat([
  t,
  `${t}-start`,
  `${t}-end`
]), []), Mr = {
  hover: "mouseenter",
  focus: "focus",
  click: "click",
  touch: "touchstart",
  pointer: "pointerdown"
}, Lr = {
  hover: "mouseleave",
  focus: "blur",
  click: "click",
  touch: "touchend",
  pointer: "pointerup"
};
function Fr(e, t) {
  const n = e.indexOf(t);
  n !== -1 && e.splice(n, 1);
}
function An() {
  return new Promise((e) => requestAnimationFrame(() => {
    requestAnimationFrame(e);
  }));
}
const Z = [];
let Pe = null;
const Dr = {};
function qr(e) {
  let t = Dr[e];
  return t || (t = Dr[e] = []), t;
}
let Hn = function() {
};
typeof window < "u" && (Hn = window.Element);
function k(e) {
  return function(t) {
    return qn(t.theme, e);
  };
}
const En = "__floating-vue__popper", Ro = () => G({
  name: "VPopper",
  provide() {
    return {
      [En]: {
        parentPopper: this
      }
    };
  },
  inject: {
    [En]: { default: null }
  },
  props: {
    theme: {
      type: String,
      required: !0
    },
    targetNodes: {
      type: Function,
      required: !0
    },
    referenceNode: {
      type: Function,
      default: null
    },
    popperNode: {
      type: Function,
      required: !0
    },
    shown: {
      type: Boolean,
      default: !1
    },
    showGroup: {
      type: String,
      default: null
    },
    // eslint-disable-next-line vue/require-prop-types
    ariaId: {
      default: null
    },
    disabled: {
      type: Boolean,
      default: k("disabled")
    },
    positioningDisabled: {
      type: Boolean,
      default: k("positioningDisabled")
    },
    placement: {
      type: String,
      default: k("placement"),
      validator: (e) => Iu.includes(e)
    },
    delay: {
      type: [String, Number, Object],
      default: k("delay")
    },
    distance: {
      type: [Number, String],
      default: k("distance")
    },
    skidding: {
      type: [Number, String],
      default: k("skidding")
    },
    triggers: {
      type: Array,
      default: k("triggers")
    },
    showTriggers: {
      type: [Array, Function],
      default: k("showTriggers")
    },
    hideTriggers: {
      type: [Array, Function],
      default: k("hideTriggers")
    },
    popperTriggers: {
      type: Array,
      default: k("popperTriggers")
    },
    popperShowTriggers: {
      type: [Array, Function],
      default: k("popperShowTriggers")
    },
    popperHideTriggers: {
      type: [Array, Function],
      default: k("popperHideTriggers")
    },
    container: {
      type: [String, Object, Hn, Boolean],
      default: k("container")
    },
    boundary: {
      type: [String, Hn],
      default: k("boundary")
    },
    strategy: {
      type: String,
      validator: (e) => ["absolute", "fixed"].includes(e),
      default: k("strategy")
    },
    autoHide: {
      type: [Boolean, Function],
      default: k("autoHide")
    },
    handleResize: {
      type: Boolean,
      default: k("handleResize")
    },
    instantMove: {
      type: Boolean,
      default: k("instantMove")
    },
    eagerMount: {
      type: Boolean,
      default: k("eagerMount")
    },
    popperClass: {
      type: [String, Array, Object],
      default: k("popperClass")
    },
    computeTransformOrigin: {
      type: Boolean,
      default: k("computeTransformOrigin")
    },
    /**
     * @deprecated
     */
    autoMinSize: {
      type: Boolean,
      default: k("autoMinSize")
    },
    autoSize: {
      type: [Boolean, String],
      default: k("autoSize")
    },
    /**
     * @deprecated
     */
    autoMaxSize: {
      type: Boolean,
      default: k("autoMaxSize")
    },
    autoBoundaryMaxSize: {
      type: Boolean,
      default: k("autoBoundaryMaxSize")
    },
    preventOverflow: {
      type: Boolean,
      default: k("preventOverflow")
    },
    overflowPadding: {
      type: [Number, String],
      default: k("overflowPadding")
    },
    arrowPadding: {
      type: [Number, String],
      default: k("arrowPadding")
    },
    arrowOverflow: {
      type: Boolean,
      default: k("arrowOverflow")
    },
    flip: {
      type: Boolean,
      default: k("flip")
    },
    shift: {
      type: Boolean,
      default: k("shift")
    },
    shiftCrossAxis: {
      type: Boolean,
      default: k("shiftCrossAxis")
    },
    noAutoFocus: {
      type: Boolean,
      default: k("noAutoFocus")
    },
    disposeTimeout: {
      type: Number,
      default: k("disposeTimeout")
    }
  },
  emits: {
    show: () => !0,
    hide: () => !0,
    "update:shown": (e) => !0,
    "apply-show": () => !0,
    "apply-hide": () => !0,
    "close-group": () => !0,
    "close-directive": () => !0,
    "auto-hide": () => !0,
    resize: () => !0
  },
  data() {
    return {
      isShown: !1,
      isMounted: !1,
      skipTransition: !1,
      classes: {
        showFrom: !1,
        showTo: !1,
        hideFrom: !1,
        hideTo: !0
      },
      result: {
        x: 0,
        y: 0,
        placement: "",
        strategy: this.strategy,
        arrow: {
          x: 0,
          y: 0,
          centerOffset: 0
        },
        transformOrigin: null
      },
      randomId: `popper_${[Math.random(), Date.now()].map((e) => e.toString(36).substring(2, 10)).join("_")}`,
      shownChildren: /* @__PURE__ */ new Set(),
      lastAutoHide: !0,
      pendingHide: !1,
      containsGlobalTarget: !1,
      isDisposed: !0,
      mouseDownContains: !1
    };
  },
  computed: {
    popperId() {
      return this.ariaId != null ? this.ariaId : this.randomId;
    },
    shouldMountContent() {
      return this.eagerMount || this.isMounted;
    },
    slotData() {
      return {
        popperId: this.popperId,
        isShown: this.isShown,
        shouldMountContent: this.shouldMountContent,
        skipTransition: this.skipTransition,
        autoHide: typeof this.autoHide == "function" ? this.lastAutoHide : this.autoHide,
        show: this.show,
        hide: this.hide,
        handleResize: this.handleResize,
        onResize: this.onResize,
        classes: {
          ...this.classes,
          popperClass: this.popperClass
        },
        result: this.positioningDisabled ? null : this.result,
        attrs: this.$attrs
      };
    },
    parentPopper() {
      var e;
      return (e = this[En]) == null ? void 0 : e.parentPopper;
    },
    hasPopperShowTriggerHover() {
      var e, t;
      return ((e = this.popperTriggers) == null ? void 0 : e.includes("hover")) || ((t = this.popperShowTriggers) == null ? void 0 : t.includes("hover"));
    }
  },
  watch: {
    shown: "$_autoShowHide",
    disabled(e) {
      e ? this.dispose() : this.init();
    },
    async container() {
      this.isShown && (this.$_ensureTeleport(), await this.$_computePosition());
    },
    triggers: {
      handler: "$_refreshListeners",
      deep: !0
    },
    positioningDisabled: "$_refreshListeners",
    ...[
      "placement",
      "distance",
      "skidding",
      "boundary",
      "strategy",
      "overflowPadding",
      "arrowPadding",
      "preventOverflow",
      "shift",
      "shiftCrossAxis",
      "flip"
    ].reduce((e, t) => (e[t] = "$_computePosition", e), {})
  },
  created() {
    this.autoMinSize && console.warn('[floating-vue] `autoMinSize` option is deprecated. Use `autoSize="min"` instead.'), this.autoMaxSize && console.warn("[floating-vue] `autoMaxSize` option is deprecated. Use `autoBoundaryMaxSize` instead.");
  },
  mounted() {
    this.init(), this.$_detachPopperNode();
  },
  activated() {
    this.$_autoShowHide();
  },
  deactivated() {
    this.hide();
  },
  beforeUnmount() {
    this.dispose();
  },
  methods: {
    show({ event: e = null, skipDelay: t = !1, force: n = !1 } = {}) {
      var r, i;
      (r = this.parentPopper) != null && r.lockedChild && this.parentPopper.lockedChild !== this || (this.pendingHide = !1, (n || !this.disabled) && (((i = this.parentPopper) == null ? void 0 : i.lockedChild) === this && (this.parentPopper.lockedChild = null), this.$_scheduleShow(e, t), this.$emit("show"), this.$_showFrameLocked = !0, requestAnimationFrame(() => {
        this.$_showFrameLocked = !1;
      })), this.$emit("update:shown", !0));
    },
    hide({ event: e = null, skipDelay: t = !1 } = {}) {
      var n;
      if (!this.$_hideInProgress) {
        if (this.shownChildren.size > 0) {
          this.pendingHide = !0;
          return;
        }
        if (this.hasPopperShowTriggerHover && this.$_isAimingPopper()) {
          this.parentPopper && (this.parentPopper.lockedChild = this, clearTimeout(this.parentPopper.lockedChildTimer), this.parentPopper.lockedChildTimer = setTimeout(() => {
            this.parentPopper.lockedChild === this && (this.parentPopper.lockedChild.hide({ skipDelay: t }), this.parentPopper.lockedChild = null);
          }, 1e3));
          return;
        }
        ((n = this.parentPopper) == null ? void 0 : n.lockedChild) === this && (this.parentPopper.lockedChild = null), this.pendingHide = !1, this.$_scheduleHide(e, t), this.$emit("hide"), this.$emit("update:shown", !1);
      }
    },
    init() {
      var e;
      this.isDisposed && (this.isDisposed = !1, this.isMounted = !1, this.$_events = [], this.$_preventShow = !1, this.$_referenceNode = ((e = this.referenceNode) == null ? void 0 : e.call(this)) ?? this.$el, this.$_targetNodes = this.targetNodes().filter((t) => t.nodeType === t.ELEMENT_NODE), this.$_popperNode = this.popperNode(), this.$_innerNode = this.$_popperNode.querySelector(".v-popper__inner"), this.$_arrowNode = this.$_popperNode.querySelector(".v-popper__arrow-container"), this.$_swapTargetAttrs("title", "data-original-title"), this.$_detachPopperNode(), this.triggers.length && this.$_addEventListeners(), this.shown && this.show());
    },
    dispose() {
      this.isDisposed || (this.isDisposed = !0, this.$_removeEventListeners(), this.hide({ skipDelay: !0 }), this.$_detachPopperNode(), this.isMounted = !1, this.isShown = !1, this.$_updateParentShownChildren(!1), this.$_swapTargetAttrs("data-original-title", "title"));
    },
    async onResize() {
      this.isShown && (await this.$_computePosition(), this.$emit("resize"));
    },
    async $_computePosition() {
      if (this.isDisposed || this.positioningDisabled)
        return;
      const e = {
        strategy: this.strategy,
        middleware: []
      };
      (this.distance || this.skidding) && e.middleware.push($u({
        mainAxis: this.distance,
        crossAxis: this.skidding
      }));
      const t = this.placement.startsWith("auto");
      if (t ? e.middleware.push(_u({
        alignment: this.placement.split("-")[1] ?? ""
      })) : e.placement = this.placement, this.preventOverflow && (this.shift && e.middleware.push(xu({
        padding: this.overflowPadding,
        boundary: this.boundary,
        crossAxis: this.shiftCrossAxis
      })), !t && this.flip && e.middleware.push(Su({
        padding: this.overflowPadding,
        boundary: this.boundary
      }))), e.middleware.push(wu({
        element: this.$_arrowNode,
        padding: this.arrowPadding
      })), this.arrowOverflow && e.middleware.push({
        name: "arrowOverflow",
        fn: ({ placement: r, rects: i, middlewareData: o }) => {
          let s;
          const { centerOffset: a } = o.arrow;
          return r.startsWith("top") || r.startsWith("bottom") ? s = Math.abs(a) > i.reference.width / 2 : s = Math.abs(a) > i.reference.height / 2, {
            data: {
              overflow: s
            }
          };
        }
      }), this.autoMinSize || this.autoSize) {
        const r = this.autoSize ? this.autoSize : this.autoMinSize ? "min" : null;
        e.middleware.push({
          name: "autoSize",
          fn: ({ rects: i, placement: o, middlewareData: s }) => {
            var a;
            if ((a = s.autoSize) != null && a.skip)
              return {};
            let c, u;
            return o.startsWith("top") || o.startsWith("bottom") ? c = i.reference.width : u = i.reference.height, this.$_innerNode.style[r === "min" ? "minWidth" : r === "max" ? "maxWidth" : "width"] = c != null ? `${c}px` : null, this.$_innerNode.style[r === "min" ? "minHeight" : r === "max" ? "maxHeight" : "height"] = u != null ? `${u}px` : null, {
              data: {
                skip: !0
              },
              reset: {
                rects: !0
              }
            };
          }
        });
      }
      (this.autoMaxSize || this.autoBoundaryMaxSize) && (this.$_innerNode.style.maxWidth = null, this.$_innerNode.style.maxHeight = null, e.middleware.push(Tu({
        boundary: this.boundary,
        padding: this.overflowPadding,
        apply: ({ availableWidth: r, availableHeight: i }) => {
          this.$_innerNode.style.maxWidth = r != null ? `${r}px` : null, this.$_innerNode.style.maxHeight = i != null ? `${i}px` : null;
        }
      })));
      const n = await Ru(this.$_referenceNode, this.$_popperNode, e);
      Object.assign(this.result, {
        x: n.x,
        y: n.y,
        placement: n.placement,
        strategy: n.strategy,
        arrow: {
          ...n.middlewareData.arrow,
          ...n.middlewareData.arrowOverflow
        }
      });
    },
    $_scheduleShow(e, t = !1) {
      if (this.$_updateParentShownChildren(!0), this.$_hideInProgress = !1, clearTimeout(this.$_scheduleTimer), Pe && this.instantMove && Pe.instantMove && Pe !== this.parentPopper) {
        Pe.$_applyHide(!0), this.$_applyShow(!0);
        return;
      }
      t ? this.$_applyShow() : this.$_scheduleTimer = setTimeout(this.$_applyShow.bind(this), this.$_computeDelay("show"));
    },
    $_scheduleHide(e, t = !1) {
      if (this.shownChildren.size > 0) {
        this.pendingHide = !0;
        return;
      }
      this.$_updateParentShownChildren(!1), this.$_hideInProgress = !0, clearTimeout(this.$_scheduleTimer), this.isShown && (Pe = this), t ? this.$_applyHide() : this.$_scheduleTimer = setTimeout(this.$_applyHide.bind(this), this.$_computeDelay("hide"));
    },
    $_computeDelay(e) {
      const t = this.delay;
      return parseInt(t && t[e] || t || 0);
    },
    async $_applyShow(e = !1) {
      clearTimeout(this.$_disposeTimer), clearTimeout(this.$_scheduleTimer), this.skipTransition = e, !this.isShown && (this.$_ensureTeleport(), await An(), await this.$_computePosition(), await this.$_applyShowEffect(), this.positioningDisabled || this.$_registerEventListeners([
        ...ln(this.$_referenceNode),
        ...ln(this.$_popperNode)
      ], "scroll", () => {
        this.$_computePosition();
      }));
    },
    async $_applyShowEffect() {
      if (this.$_hideInProgress)
        return;
      if (this.computeTransformOrigin) {
        const t = this.$_referenceNode.getBoundingClientRect(), n = this.$_popperNode.querySelector(".v-popper__wrapper"), r = n.parentNode.getBoundingClientRect(), i = t.x + t.width / 2 - (r.left + n.offsetLeft), o = t.y + t.height / 2 - (r.top + n.offsetTop);
        this.result.transformOrigin = `${i}px ${o}px`;
      }
      this.isShown = !0, this.$_applyAttrsToTarget({
        "aria-describedby": this.popperId,
        "data-popper-shown": ""
      });
      const e = this.showGroup;
      if (e) {
        let t;
        for (let n = 0; n < Z.length; n++)
          t = Z[n], t.showGroup !== e && (t.hide(), t.$emit("close-group"));
      }
      Z.push(this), document.body.classList.add("v-popper--some-open");
      for (const t of Nr(this.theme))
        qr(t).push(this), document.body.classList.add(`v-popper--some-open--${t}`);
      this.$emit("apply-show"), this.classes.showFrom = !0, this.classes.showTo = !1, this.classes.hideFrom = !1, this.classes.hideTo = !1, await An(), this.classes.showFrom = !1, this.classes.showTo = !0, this.noAutoFocus || this.$_popperNode.focus();
    },
    async $_applyHide(e = !1) {
      if (this.shownChildren.size > 0) {
        this.pendingHide = !0, this.$_hideInProgress = !1;
        return;
      }
      if (clearTimeout(this.$_scheduleTimer), !this.isShown)
        return;
      this.skipTransition = e, Fr(Z, this), Z.length === 0 && document.body.classList.remove("v-popper--some-open");
      for (const n of Nr(this.theme)) {
        const r = qr(n);
        Fr(r, this), r.length === 0 && document.body.classList.remove(`v-popper--some-open--${n}`);
      }
      Pe === this && (Pe = null), this.isShown = !1, this.$_applyAttrsToTarget({
        "aria-describedby": void 0,
        "data-popper-shown": void 0
      }), clearTimeout(this.$_disposeTimer);
      const t = this.disposeTimeout;
      t !== null && (this.$_disposeTimer = setTimeout(() => {
        this.$_popperNode && (this.$_detachPopperNode(), this.isMounted = !1);
      }, t)), this.$_removeEventListeners("scroll"), this.$emit("apply-hide"), this.classes.showFrom = !1, this.classes.showTo = !1, this.classes.hideFrom = !0, this.classes.hideTo = !1, await An(), this.classes.hideFrom = !1, this.classes.hideTo = !0;
    },
    $_autoShowHide() {
      this.shown ? this.show() : this.hide();
    },
    $_ensureTeleport() {
      if (this.isDisposed)
        return;
      let e = this.container;
      if (typeof e == "string" ? e = window.document.querySelector(e) : e === !1 && (e = this.$_targetNodes[0].parentNode), !e)
        throw new Error("No container for popover: " + this.container);
      e.appendChild(this.$_popperNode), this.isMounted = !0;
    },
    $_addEventListeners() {
      const e = (n) => {
        this.isShown && !this.$_hideInProgress || (n.usedByTooltip = !0, !this.$_preventShow && this.show({ event: n }));
      };
      this.$_registerTriggerListeners(this.$_targetNodes, Mr, this.triggers, this.showTriggers, e), this.$_registerTriggerListeners([this.$_popperNode], Mr, this.popperTriggers, this.popperShowTriggers, e);
      const t = (n) => {
        n.usedByTooltip || this.hide({ event: n });
      };
      this.$_registerTriggerListeners(this.$_targetNodes, Lr, this.triggers, this.hideTriggers, t), this.$_registerTriggerListeners([this.$_popperNode], Lr, this.popperTriggers, this.popperHideTriggers, t);
    },
    $_registerEventListeners(e, t, n) {
      this.$_events.push({ targetNodes: e, eventType: t, handler: n }), e.forEach((r) => r.addEventListener(t, n, Ze ? {
        passive: !0
      } : void 0));
    },
    $_registerTriggerListeners(e, t, n, r, i) {
      let o = n;
      r != null && (o = typeof r == "function" ? r(o) : r), o.forEach((s) => {
        const a = t[s];
        a && this.$_registerEventListeners(e, a, i);
      });
    },
    $_removeEventListeners(e) {
      const t = [];
      this.$_events.forEach((n) => {
        const { targetNodes: r, eventType: i, handler: o } = n;
        !e || e === i ? r.forEach((s) => s.removeEventListener(i, o)) : t.push(n);
      }), this.$_events = t;
    },
    $_refreshListeners() {
      this.isDisposed || (this.$_removeEventListeners(), this.$_addEventListeners());
    },
    $_handleGlobalClose(e, t = !1) {
      this.$_showFrameLocked || (this.hide({ event: e }), e.closePopover ? this.$emit("close-directive") : this.$emit("auto-hide"), t && (this.$_preventShow = !0, setTimeout(() => {
        this.$_preventShow = !1;
      }, 300)));
    },
    $_detachPopperNode() {
      this.$_popperNode.parentNode && this.$_popperNode.parentNode.removeChild(this.$_popperNode);
    },
    $_swapTargetAttrs(e, t) {
      for (const n of this.$_targetNodes) {
        const r = n.getAttribute(e);
        r && (n.removeAttribute(e), n.setAttribute(t, r));
      }
    },
    $_applyAttrsToTarget(e) {
      for (const t of this.$_targetNodes)
        for (const n in e) {
          const r = e[n];
          r == null ? t.removeAttribute(n) : t.setAttribute(n, r);
        }
    },
    $_updateParentShownChildren(e) {
      let t = this.parentPopper;
      for (; t; )
        e ? t.shownChildren.add(this.randomId) : (t.shownChildren.delete(this.randomId), t.pendingHide && t.hide()), t = t.parentPopper;
    },
    $_isAimingPopper() {
      const e = this.$_referenceNode.getBoundingClientRect();
      if (pt >= e.left && pt <= e.right && mt >= e.top && mt <= e.bottom) {
        const t = this.$_popperNode.getBoundingClientRect(), n = pt - ve, r = mt - we, i = t.left + t.width / 2 - ve + (t.top + t.height / 2) - we + t.width + t.height, o = ve + n * i, s = we + r * i;
        return Pt(ve, we, o, s, t.left, t.top, t.left, t.bottom) || // Left edge
        Pt(ve, we, o, s, t.left, t.top, t.right, t.top) || // Top edge
        Pt(ve, we, o, s, t.right, t.top, t.right, t.bottom) || // Right edge
        Pt(ve, we, o, s, t.left, t.bottom, t.right, t.bottom);
      }
      return !1;
    }
  },
  render() {
    return this.$slots.default(this.slotData);
  }
});
if (typeof document < "u" && typeof window < "u") {
  if (Oo) {
    const e = Ze ? {
      passive: !0,
      capture: !0
    } : !0;
    document.addEventListener("touchstart", (t) => Hr(t), e), document.addEventListener("touchend", (t) => zr(t, !0), e);
  } else
    window.addEventListener("mousedown", (e) => Hr(e), !0), window.addEventListener("click", (e) => zr(e, !1), !0);
  window.addEventListener("resize", Mu);
}
function Hr(e, t) {
  for (let n = 0; n < Z.length; n++) {
    const r = Z[n];
    try {
      r.mouseDownContains = r.popperNode().contains(e.target);
    } catch {
    }
  }
}
function zr(e, t) {
  ku(e, t);
}
function ku(e, t) {
  const n = {};
  for (let r = Z.length - 1; r >= 0; r--) {
    const i = Z[r];
    try {
      const o = i.containsGlobalTarget = i.mouseDownContains || i.popperNode().contains(e.target);
      i.pendingHide = !1, requestAnimationFrame(() => {
        if (i.pendingHide = !1, !n[i.randomId] && Br(i, o, e)) {
          if (i.$_handleGlobalClose(e, t), !e.closeAllPopover && e.closePopover && o) {
            let a = i.parentPopper;
            for (; a; )
              n[a.randomId] = !0, a = a.parentPopper;
            return;
          }
          let s = i.parentPopper;
          for (; s && Br(s, s.containsGlobalTarget, e); )
            s.$_handleGlobalClose(e, t), s = s.parentPopper;
        }
      });
    } catch {
    }
  }
}
function Br(e, t, n) {
  return n.closeAllPopover || n.closePopover && t || Nu(e, n) && !t;
}
function Nu(e, t) {
  if (typeof e.autoHide == "function") {
    const n = e.autoHide(t);
    return e.lastAutoHide = n, n;
  }
  return e.autoHide;
}
function Mu() {
  for (let e = 0; e < Z.length; e++)
    Z[e].$_computePosition();
}
let ve = 0, we = 0, pt = 0, mt = 0;
typeof window < "u" && window.addEventListener("mousemove", (e) => {
  ve = pt, we = mt, pt = e.clientX, mt = e.clientY;
}, Ze ? {
  passive: !0
} : void 0);
function Pt(e, t, n, r, i, o, s, a) {
  const c = ((s - i) * (t - o) - (a - o) * (e - i)) / ((a - o) * (n - e) - (s - i) * (r - t)), u = ((n - e) * (t - o) - (r - t) * (e - i)) / ((a - o) * (n - e) - (s - i) * (r - t));
  return c >= 0 && c <= 1 && u >= 0 && u <= 1;
}
const Lu = {
  extends: Ro()
}, sr = (e, t) => {
  const n = e.__vccOpts || e;
  for (const [r, i] of t)
    n[r] = i;
  return n;
};
function Fu(e, t, n, r, i, o) {
  return N(), q("div", {
    ref: "reference",
    class: ze(["v-popper", {
      "v-popper--shown": e.slotData.isShown
    }])
  }, [
    gt(e.$slots, "default", Uo(Wo(e.slotData)))
  ], 2);
}
const Du = /* @__PURE__ */ sr(Lu, [["render", Fu]]);
function qu() {
  var e = window.navigator.userAgent, t = e.indexOf("MSIE ");
  if (t > 0)
    return parseInt(e.substring(t + 5, e.indexOf(".", t)), 10);
  var n = e.indexOf("Trident/");
  if (n > 0) {
    var r = e.indexOf("rv:");
    return parseInt(e.substring(r + 3, e.indexOf(".", r)), 10);
  }
  var i = e.indexOf("Edge/");
  return i > 0 ? parseInt(e.substring(i + 5, e.indexOf(".", i)), 10) : -1;
}
let Vt;
function zn() {
  zn.init || (zn.init = !0, Vt = qu() !== -1);
}
var bn = {
  name: "ResizeObserver",
  props: {
    emitOnMount: {
      type: Boolean,
      default: !1
    },
    ignoreWidth: {
      type: Boolean,
      default: !1
    },
    ignoreHeight: {
      type: Boolean,
      default: !1
    }
  },
  emits: [
    "notify"
  ],
  mounted() {
    zn(), Vr(() => {
      this._w = this.$el.offsetWidth, this._h = this.$el.offsetHeight, this.emitOnMount && this.emitSize();
    });
    const e = document.createElement("object");
    this._resizeObject = e, e.setAttribute("aria-hidden", "true"), e.setAttribute("tabindex", -1), e.onload = this.addResizeHandlers, e.type = "text/html", Vt && this.$el.appendChild(e), e.data = "about:blank", Vt || this.$el.appendChild(e);
  },
  beforeUnmount() {
    this.removeResizeHandlers();
  },
  methods: {
    compareAndNotify() {
      (!this.ignoreWidth && this._w !== this.$el.offsetWidth || !this.ignoreHeight && this._h !== this.$el.offsetHeight) && (this._w = this.$el.offsetWidth, this._h = this.$el.offsetHeight, this.emitSize());
    },
    emitSize() {
      this.$emit("notify", {
        width: this._w,
        height: this._h
      });
    },
    addResizeHandlers() {
      this._resizeObject.contentDocument.defaultView.addEventListener("resize", this.compareAndNotify), this.compareAndNotify();
    },
    removeResizeHandlers() {
      this._resizeObject && this._resizeObject.onload && (!Vt && this._resizeObject.contentDocument && this._resizeObject.contentDocument.defaultView.removeEventListener("resize", this.compareAndNotify), this.$el.removeChild(this._resizeObject), this._resizeObject.onload = null, this._resizeObject = null);
    }
  }
};
const Hu = /* @__PURE__ */ Vo("data-v-b329ee4c");
Bo("data-v-b329ee4c");
const zu = {
  class: "resize-observer",
  tabindex: "-1"
};
jo();
const Bu = /* @__PURE__ */ Hu((e, t, n, r, i, o) => (N(), de("div", zu)));
bn.render = Bu;
bn.__scopeId = "data-v-b329ee4c";
bn.__file = "src/components/ResizeObserver.vue";
const Po = (e = "theme") => ({
  computed: {
    themeClass() {
      return Pu(this[e]);
    }
  }
}), ju = G({
  name: "VPopperContent",
  components: {
    ResizeObserver: bn
  },
  mixins: [
    Po()
  ],
  props: {
    popperId: String,
    theme: String,
    shown: Boolean,
    mounted: Boolean,
    skipTransition: Boolean,
    autoHide: Boolean,
    handleResize: Boolean,
    classes: Object,
    result: Object
  },
  emits: [
    "hide",
    "resize"
  ],
  methods: {
    toPx(e) {
      return e != null && !isNaN(e) ? `${e}px` : null;
    }
  }
}), Uu = ["id", "aria-hidden", "tabindex", "data-popper-placement"], Wu = {
  ref: "inner",
  class: "v-popper__inner"
}, Vu = /* @__PURE__ */ H("div", { class: "v-popper__arrow-outer" }, null, -1), Yu = /* @__PURE__ */ H("div", { class: "v-popper__arrow-inner" }, null, -1), Gu = [
  Vu,
  Yu
];
function Qu(e, t, n, r, i, o) {
  const s = yt("ResizeObserver");
  return N(), q("div", {
    id: e.popperId,
    ref: "popover",
    class: ze(["v-popper__popper", [
      e.themeClass,
      e.classes.popperClass,
      {
        "v-popper__popper--shown": e.shown,
        "v-popper__popper--hidden": !e.shown,
        "v-popper__popper--show-from": e.classes.showFrom,
        "v-popper__popper--show-to": e.classes.showTo,
        "v-popper__popper--hide-from": e.classes.hideFrom,
        "v-popper__popper--hide-to": e.classes.hideTo,
        "v-popper__popper--skip-transition": e.skipTransition,
        "v-popper__popper--arrow-overflow": e.result && e.result.arrow.overflow,
        "v-popper__popper--no-positioning": !e.result
      }
    ]]),
    style: _n(e.result ? {
      position: e.result.strategy,
      transform: `translate3d(${Math.round(e.result.x)}px,${Math.round(e.result.y)}px,0)`
    } : void 0),
    "aria-hidden": e.shown ? "false" : "true",
    tabindex: e.autoHide ? 0 : void 0,
    "data-popper-placement": e.result ? e.result.placement : void 0,
    onKeyup: t[2] || (t[2] = Yo((a) => e.autoHide && e.$emit("hide"), ["esc"]))
  }, [
    H("div", {
      class: "v-popper__backdrop",
      onClick: t[0] || (t[0] = (a) => e.autoHide && e.$emit("hide"))
    }),
    H("div", {
      class: "v-popper__wrapper",
      style: _n(e.result ? {
        transformOrigin: e.result.transformOrigin
      } : void 0)
    }, [
      H("div", Wu, [
        e.mounted ? (N(), q(Ge, { key: 0 }, [
          H("div", null, [
            gt(e.$slots, "default")
          ]),
          e.handleResize ? (N(), de(s, {
            key: 0,
            onNotify: t[1] || (t[1] = (a) => e.$emit("resize", a))
          })) : ee("", !0)
        ], 64)) : ee("", !0)
      ], 512),
      H("div", {
        ref: "arrow",
        class: "v-popper__arrow-container",
        style: _n(e.result ? {
          left: e.toPx(e.result.arrow.x),
          top: e.toPx(e.result.arrow.y)
        } : void 0)
      }, Gu, 4)
    ], 4)
  ], 46, Uu);
}
const Io = /* @__PURE__ */ sr(ju, [["render", Qu]]), ko = {
  methods: {
    show(...e) {
      return this.$refs.popper.show(...e);
    },
    hide(...e) {
      return this.$refs.popper.hide(...e);
    },
    dispose(...e) {
      return this.$refs.popper.dispose(...e);
    },
    onResize(...e) {
      return this.$refs.popper.onResize(...e);
    }
  }
};
let Bn = function() {
};
typeof window < "u" && (Bn = window.Element);
const Xu = G({
  name: "VPopperWrapper",
  components: {
    Popper: Du,
    PopperContent: Io
  },
  mixins: [
    ko,
    Po("finalTheme")
  ],
  props: {
    theme: {
      type: String,
      default: null
    },
    referenceNode: {
      type: Function,
      default: null
    },
    shown: {
      type: Boolean,
      default: !1
    },
    showGroup: {
      type: String,
      default: null
    },
    // eslint-disable-next-line vue/require-prop-types
    ariaId: {
      default: null
    },
    disabled: {
      type: Boolean,
      default: void 0
    },
    positioningDisabled: {
      type: Boolean,
      default: void 0
    },
    placement: {
      type: String,
      default: void 0
    },
    delay: {
      type: [String, Number, Object],
      default: void 0
    },
    distance: {
      type: [Number, String],
      default: void 0
    },
    skidding: {
      type: [Number, String],
      default: void 0
    },
    triggers: {
      type: Array,
      default: void 0
    },
    showTriggers: {
      type: [Array, Function],
      default: void 0
    },
    hideTriggers: {
      type: [Array, Function],
      default: void 0
    },
    popperTriggers: {
      type: Array,
      default: void 0
    },
    popperShowTriggers: {
      type: [Array, Function],
      default: void 0
    },
    popperHideTriggers: {
      type: [Array, Function],
      default: void 0
    },
    container: {
      type: [String, Object, Bn, Boolean],
      default: void 0
    },
    boundary: {
      type: [String, Bn],
      default: void 0
    },
    strategy: {
      type: String,
      default: void 0
    },
    autoHide: {
      type: [Boolean, Function],
      default: void 0
    },
    handleResize: {
      type: Boolean,
      default: void 0
    },
    instantMove: {
      type: Boolean,
      default: void 0
    },
    eagerMount: {
      type: Boolean,
      default: void 0
    },
    popperClass: {
      type: [String, Array, Object],
      default: void 0
    },
    computeTransformOrigin: {
      type: Boolean,
      default: void 0
    },
    /**
     * @deprecated
     */
    autoMinSize: {
      type: Boolean,
      default: void 0
    },
    autoSize: {
      type: [Boolean, String],
      default: void 0
    },
    /**
     * @deprecated
     */
    autoMaxSize: {
      type: Boolean,
      default: void 0
    },
    autoBoundaryMaxSize: {
      type: Boolean,
      default: void 0
    },
    preventOverflow: {
      type: Boolean,
      default: void 0
    },
    overflowPadding: {
      type: [Number, String],
      default: void 0
    },
    arrowPadding: {
      type: [Number, String],
      default: void 0
    },
    arrowOverflow: {
      type: Boolean,
      default: void 0
    },
    flip: {
      type: Boolean,
      default: void 0
    },
    shift: {
      type: Boolean,
      default: void 0
    },
    shiftCrossAxis: {
      type: Boolean,
      default: void 0
    },
    noAutoFocus: {
      type: Boolean,
      default: void 0
    },
    disposeTimeout: {
      type: Number,
      default: void 0
    }
  },
  emits: {
    show: () => !0,
    hide: () => !0,
    "update:shown": (e) => !0,
    "apply-show": () => !0,
    "apply-hide": () => !0,
    "close-group": () => !0,
    "close-directive": () => !0,
    "auto-hide": () => !0,
    resize: () => !0
  },
  computed: {
    finalTheme() {
      return this.theme ?? this.$options.vPopperTheme;
    }
  },
  methods: {
    getTargetNodes() {
      return Array.from(this.$el.children).filter((e) => e !== this.$refs.popperContent.$el);
    }
  }
});
function Ku(e, t, n, r, i, o) {
  const s = yt("PopperContent"), a = yt("Popper");
  return N(), de(a, Go({ ref: "popper" }, e.$props, {
    theme: e.finalTheme,
    "target-nodes": e.getTargetNodes,
    "popper-node": () => e.$refs.popperContent.$el,
    class: [
      e.themeClass
    ],
    onShow: t[0] || (t[0] = () => e.$emit("show")),
    onHide: t[1] || (t[1] = () => e.$emit("hide")),
    "onUpdate:shown": t[2] || (t[2] = (c) => e.$emit("update:shown", c)),
    onApplyShow: t[3] || (t[3] = () => e.$emit("apply-show")),
    onApplyHide: t[4] || (t[4] = () => e.$emit("apply-hide")),
    onCloseGroup: t[5] || (t[5] = () => e.$emit("close-group")),
    onCloseDirective: t[6] || (t[6] = () => e.$emit("close-directive")),
    onAutoHide: t[7] || (t[7] = () => e.$emit("auto-hide")),
    onResize: t[8] || (t[8] = () => e.$emit("resize"))
  }), {
    default: vt(({
      popperId: c,
      isShown: u,
      shouldMountContent: l,
      skipTransition: d,
      autoHide: f,
      show: y,
      hide: w,
      handleResize: v,
      onResize: b,
      classes: _,
      result: C
    }) => [
      gt(e.$slots, "default", {
        shown: u,
        show: y,
        hide: w
      }),
      xe(s, {
        ref: "popperContent",
        "popper-id": c,
        theme: e.finalTheme,
        shown: u,
        mounted: l,
        "skip-transition": d,
        "auto-hide": f,
        "handle-resize": v,
        classes: _,
        result: C,
        onHide: w,
        onResize: b
      }, {
        default: vt(() => [
          gt(e.$slots, "popper", {
            shown: u,
            hide: w
          })
        ]),
        _: 2
      }, 1032, ["popper-id", "theme", "shown", "mounted", "skip-transition", "auto-hide", "handle-resize", "classes", "result", "onHide", "onResize"])
    ]),
    _: 3
  }, 16, ["theme", "target-nodes", "popper-node", "class"]);
}
const ar = /* @__PURE__ */ sr(Xu, [["render", Ku]]), Ju = {
  ...ar,
  name: "VDropdown",
  vPopperTheme: "dropdown"
};
({
  ...ar
});
({
  ...ar
});
G({
  name: "VTooltipDirective",
  components: {
    Popper: Ro(),
    PopperContent: Io
  },
  mixins: [
    ko
  ],
  inheritAttrs: !1,
  props: {
    theme: {
      type: String,
      default: "tooltip"
    },
    html: {
      type: Boolean,
      default: (e) => qn(e.theme, "html")
    },
    content: {
      type: [String, Number, Function],
      default: null
    },
    loadingContent: {
      type: String,
      default: (e) => qn(e.theme, "loadingContent")
    },
    targetNodes: {
      type: Function,
      required: !0
    }
  },
  data() {
    return {
      asyncContent: null
    };
  },
  computed: {
    isContentAsync() {
      return typeof this.content == "function";
    },
    loading() {
      return this.isContentAsync && this.asyncContent == null;
    },
    finalContent() {
      return this.isContentAsync ? this.loading ? this.loadingContent : this.asyncContent : this.content;
    }
  },
  watch: {
    content: {
      handler() {
        this.fetchContent(!0);
      },
      immediate: !0
    },
    async finalContent() {
      await this.$nextTick(), this.$refs.popper.onResize();
    }
  },
  created() {
    this.$_fetchId = 0;
  },
  methods: {
    fetchContent(e) {
      if (typeof this.content == "function" && this.$_isShown && (e || !this.$_loading && this.asyncContent == null)) {
        this.asyncContent = null, this.$_loading = !0;
        const t = ++this.$_fetchId, n = this.content(this);
        n.then ? n.then((r) => this.onResult(t, r)) : this.onResult(t, n);
      }
    },
    onResult(e, t) {
      e === this.$_fetchId && (this.$_loading = !1, this.asyncContent = t);
    },
    onShow() {
      this.$_isShown = !0, this.fetchContent();
    },
    onHide() {
      this.$_isShown = !1;
    }
  }
});
function jr(e) {
  e.addEventListener("mousedown", dn), e.addEventListener("click", dn), e.addEventListener("touchstart", No, Ze ? {
    passive: !0
  } : !1);
}
function Ur(e) {
  e.removeEventListener("mousedown", dn), e.removeEventListener("click", dn), e.removeEventListener("touchstart", No), e.removeEventListener("touchend", Mo), e.removeEventListener("touchcancel", Lo);
}
function dn(e) {
  const t = e.currentTarget;
  e.closePopover = !t.$_vclosepopover_touch, e.closeAllPopover = t.$_closePopoverModifiers && !!t.$_closePopoverModifiers.all;
}
function No(e) {
  if (e.changedTouches.length === 1) {
    const t = e.currentTarget;
    t.$_vclosepopover_touch = !0;
    const n = e.changedTouches[0];
    t.$_vclosepopover_touchPoint = n, t.addEventListener("touchend", Mo), t.addEventListener("touchcancel", Lo);
  }
}
function Mo(e) {
  const t = e.currentTarget;
  if (t.$_vclosepopover_touch = !1, e.changedTouches.length === 1) {
    const n = e.changedTouches[0], r = t.$_vclosepopover_touchPoint;
    e.closePopover = Math.abs(n.screenY - r.screenY) < 20 && Math.abs(n.screenX - r.screenX) < 20, e.closeAllPopover = t.$_closePopoverModifiers && !!t.$_closePopoverModifiers.all;
  }
}
function Lo(e) {
  const t = e.currentTarget;
  t.$_vclosepopover_touch = !1;
}
const Zu = {
  beforeMount(e, { value: t, modifiers: n }) {
    e.$_closePopoverModifiers = n, (typeof t > "u" || t) && jr(e);
  },
  updated(e, { value: t, oldValue: n, modifiers: r }) {
    e.$_closePopoverModifiers = r, t !== n && (typeof t > "u" || t ? jr(e) : Ur(e));
  },
  beforeUnmount(e) {
    Ur(e);
  }
}, el = Zu, tl = Ju, nl = ["src"], rl = /* @__PURE__ */ G({
  __name: "NotificationsMenuButton",
  props: {
    active: { type: Boolean },
    iconUrl: {}
  },
  setup(e) {
    const t = e, n = L(() => {
      const r = "notifications-menu-button", i = [];
      return t.active && i.push(`${r}--active`), i;
    });
    return (r, i) => (N(), q("button", {
      class: ze(["notifications-menu-button", n.value])
    }, [
      H("img", {
        src: r.iconUrl,
        alt: "",
        class: ""
      }, null, 8, nl)
    ], 2));
  }
}), Fo = /* @__PURE__ */ he(rl, [["__scopeId", "data-v-51403a4b"]]), il = { class: "base-popup-menu__menu" }, ol = ["onClick"], sl = { class: "base-popup-menu__menu-item-text" }, al = /* @__PURE__ */ G({
  __name: "BasePopupMenu",
  props: {
    containerId: { default: "" },
    menuItems: {},
    buttonIcon: {}
  },
  emits: ["item-clicked"],
  setup(e, { emit: t }) {
    const n = e, r = t, i = L(() => n.containerId ? `#${n.containerId}` : "body"), o = (s) => {
      r("item-clicked", s), s.handler && s.handler(s);
    };
    return (s, a) => {
      const c = yt("b-spinner");
      return N(), de(cr(tl), {
        placement: "bottom-end",
        distance: 0,
        skidding: 0,
        "arrow-overflow-padding": 0,
        "arrow-padding": 0,
        flip: !1,
        container: i.value,
        "popper-class": "base-popup-menu-popper"
      }, {
        default: vt(({ shown: u }) => [
          gt(s.$slots, "default", { shown: u }, () => [
            xe(Fo, {
              active: u,
              "icon-url": s.buttonIcon || ""
            }, null, 8, ["active", "icon-url"])
          ], !0)
        ]),
        popper: vt(() => [
          H("div", il, [
            (N(!0), q(Ge, null, jn(s.menuItems, (u) => Qo((N(), q("div", {
              key: u.label,
              class: "base-popup-menu__menu-item",
              onClick: (l) => o(u)
            }, [
              H("div", sl, oe(u.text), 1),
              u.isLoading ? (N(), de(c, {
                key: 0,
                class: "base-popup-menu__menu-item-spinner"
              })) : ee("", !0)
            ], 8, ol)), [
              [cr(el)]
            ])), 128))
          ])
        ]),
        _: 3
      }, 8, ["container"]);
    };
  }
}), Do = /* @__PURE__ */ he(al, [["__scopeId", "data-v-2e1bad4a"]]), cl = { class: "notification__row" }, ul = { class: "notification__title" }, ll = { class: "notification__content-group" }, dl = ["src"], fl = { key: 0 }, hl = { key: 1 }, pl = { class: "notification__row" }, ml = { key: 0 }, gl = { class: "notification__date" }, yl = /* @__PURE__ */ G({
  __name: "NotificationListItem",
  props: {
    notification: {},
    serviceTypesCms: {},
    audience: {},
    audienceId: {},
    containerId: {},
    cms: { default: void 0 }
  },
  emits: ["notification-clicked"],
  setup(e, { emit: t }) {
    const n = t, r = e, {
      getServiceTypeCms: i,
      getServiceCategoryCms: o,
      getServiceName: s,
      getCmsItem: a,
      getCmsItemText: c,
      getIconUrl: u,
      findIconAndResolveUrl: l
    } = gn(), d = Wn(), f = fn({
      isUpdatingNotificationReadState: !1
    }), y = L(() => {
      var E, m;
      const A = a((E = r.cms) == null ? void 0 : E.buttons, "toggleMenuButton");
      return u((m = A == null ? void 0 : A.icons) == null ? void 0 : m[0]);
    }), w = L(() => {
      var A;
      return l("unreadNotificationIcon", (A = r.cms) == null ? void 0 : A.icons);
    }), v = L(() => {
      var A, E;
      return r.notification.eventRead ? [{
        label: "mark_as_unread",
        text: c((A = r.cms) == null ? void 0 : A.otherText, "notificationMenuItem_markAsUnread"),
        isLoading: f.isUpdatingNotificationReadState,
        handler: z
      }] : [{
        label: "mark_as_read",
        text: c((E = r.cms) == null ? void 0 : E.otherText, "notificationMenuItem_markAsRead"),
        isLoading: f.isUpdatingNotificationReadState,
        handler: z
      }];
    }), b = L(() => r.notification.eventRead), _ = L(() => b.value ? [] : ["notification--unread"]), C = L(() => {
      var m, g, h;
      const A = ((m = r.notification.augmented) == null ? void 0 : m.externalTenderId) || r.notification.tenderId, E = ss.render(
        c((g = r.cms) == null ? void 0 : g.otherText, `notificationType_${r.notification.category}`),
        {
          offerLabel: (h = r.notification.augmented) != null && h.requestEstimates ? "estimat" : "tilbud"
        }
      );
      return `${E || r.notification.category} - #${A}`;
    }), T = L(() => {
      var m, g;
      const A = i(
        r.serviceTypesCms,
        (m = r.notification.augmented) == null ? void 0 : m.serviceCategoryLabel
      ), E = o(
        A,
        (g = r.notification.augmented) == null ? void 0 : g.serviceCategoryLabel
      );
      return s(E, A);
    }), $ = L(
      () => {
        var A;
        return ((A = r.notification.augmented) == null ? void 0 : A.customerOrganizationName) || "";
      }
    ), R = L(
      () => ""
    ), M = L(() => {
      const A = Rn(r.notification.created), E = Rn().startOf("day").diff(A.startOf("day"), "day"), m = "kl. HH:mm";
      return E === 0 ? `i dag ${A.format(m)}` : E === 1 ? `i går ${A.format(m)}` : E >= 2 && E <= 6 ? A.locale("nb").format(`dddd ${m}`) : A.locale("nb").format("DD.MMM YYYY");
    }), F = () => {
      n("notification-clicked", r.notification, (A) => {
        A && !r.notification.eventRead && z();
      });
    }, z = async () => {
      f.isUpdatingNotificationReadState = !0;
      try {
        await d.updateNotificationReadState(r.audience, r.audienceId, r.notification);
      } catch (A) {
        console.log("Error updating notification read state", A);
      } finally {
        f.isUpdatingNotificationReadState = !1;
      }
    };
    return (A, E) => (N(), q("div", {
      class: ze(["notification", _.value]),
      onClick: F
    }, [
      H("span", cl, [
        H("span", ul, oe(C.value), 1),
        H("span", ll, [
          b.value ? ee("", !0) : (N(), q("img", {
            key: 0,
            src: w.value,
            alt: ""
          }, null, 8, dl)),
          xe(Do, {
            "menu-items": v.value,
            "container-id": A.containerId
          }, {
            default: vt((m) => [
              xe(Fo, {
                active: m.shown,
                "icon-url": y.value,
                onClick: E[0] || (E[0] = Xo(() => {
                }, ["stop"]))
              }, null, 8, ["active", "icon-url"])
            ]),
            _: 1
          }, 8, ["menu-items", "container-id"])
        ])
      ]),
      T.value ? (N(), q("span", fl, oe(T.value), 1)) : ee("", !0),
      $.value ? (N(), q("span", hl, oe($.value), 1)) : ee("", !0),
      H("span", pl, [
        R.value ? (N(), q("span", ml, oe(R.value), 1)) : ee("", !0),
        H("span", gl, oe(M.value), 1)
      ])
    ], 2));
  }
}), vl = /* @__PURE__ */ he(yl, [["__scopeId", "data-v-8fdf4e9e"]]), wl = { class: "no-notifications" }, bl = /* @__PURE__ */ G({
  __name: "NoNotifications",
  props: {
    description: {}
  },
  setup(e) {
    return (t, n) => (N(), q("div", wl, oe(t.description), 1));
  }
}), _l = /* @__PURE__ */ he(bl, [["__scopeId", "data-v-f8ddd1cc"]]), Sl = {
  key: 0,
  class: "notifications-list__load-more-section"
}, Cl = {
  key: 1,
  class: "notifications-list__loader"
}, $l = /* @__PURE__ */ G({
  __name: "BaseNotificationsList",
  props: {
    notifications: {},
    canLoadMore: { type: Boolean },
    serviceTypesCms: {},
    audience: {},
    audienceId: {},
    containerId: {},
    cms: { default: void 0 }
  },
  emits: ["load-more", "notification-clicked"],
  setup(e, { emit: t }) {
    const n = t, r = e, { getCmsItemText: i, getCmsItem: o } = gn(), s = fn({
      isLoadingMore: !1
    }), a = L(() => {
      var f;
      return i((f = r.cms) == null ? void 0 : f.buttons, "loadMoreButton");
    }), c = L(() => {
      var f;
      return i((f = r.cms) == null ? void 0 : f.otherText, "noNotifications");
    }), u = L(() => {
      var f;
      return o((f = r.cms) == null ? void 0 : f.pageSections, "notificationsListItem");
    }), l = () => {
      s.isLoadingMore = !0, n("load-more", () => {
        s.isLoadingMore = !1;
      });
    }, d = (f, y) => {
      n("notification-clicked", f, y);
    };
    return (f, y) => {
      const w = yt("b-spinner");
      return N(), q("div", null, [
        f.notifications ? (N(), q(Ge, { key: 0 }, [
          f.notifications.length || f.canLoadMore ? (N(), q(Ge, { key: 0 }, [
            (N(!0), q(Ge, null, jn(f.notifications, (v) => (N(), de(vl, {
              key: v.id,
              notification: v,
              "service-types-cms": f.serviceTypesCms,
              audience: f.audience,
              "audience-id": f.audienceId,
              containerId: f.containerId,
              cms: u.value,
              onNotificationClicked: d
            }, null, 8, ["notification", "service-types-cms", "audience", "audience-id", "containerId", "cms"]))), 128)),
            f.canLoadMore ? (N(), q("div", Sl, [
              s.isLoadingMore ? ee("", !0) : (N(), q("button", {
                key: 0,
                class: "notifications-list__load-more-button",
                onClick: l
              }, oe(a.value), 1))
            ])) : ee("", !0)
          ], 64)) : (N(), de(_l, {
            key: 1,
            description: c.value
          }, null, 8, ["description"]))
        ], 64)) : ee("", !0),
        !f.notifications || s.isLoadingMore ? (N(), q("div", Cl, [
          xe(w, {
            class: "notifications-list__loader-icon",
            type: "grow"
          })
        ])) : ee("", !0)
      ]);
    };
  }
}), xl = /* @__PURE__ */ he($l, [["__scopeId", "data-v-e475e7bc"]]), Tl = /* @__PURE__ */ G({
  __name: "NotificationsList",
  props: {
    serviceTypesCms: {},
    notifications: {},
    audience: {},
    audienceId: {},
    containerId: {},
    cms: { default: void 0 }
  },
  emits: ["notification-clicked", "load-more"],
  setup(e, { emit: t }) {
    const n = t, r = e, i = L(() => !r.notifications.fetchedAll), o = async (a) => {
      n("load-more", a);
    }, s = (a, c) => {
      n("notification-clicked", a, c);
    };
    return (a, c) => (N(), de(xl, {
      notifications: a.notifications.items,
      "can-load-more": i.value,
      "service-types-cms": a.serviceTypesCms,
      audience: a.audience,
      "audience-id": a.audienceId,
      "container-id": a.containerId,
      cms: a.cms,
      onLoadMore: o,
      onNotificationClicked: s
    }, null, 8, ["notifications", "can-load-more", "service-types-cms", "audience", "audience-id", "container-id", "cms"]));
  }
}), { configuration: Al } = Un(), qo = () => ({
  baseUri: Al.BASE_URI,
  contextPath: "/tender",
  headers: [Gr()],
  endpoints: [
    {
      key: Symbol.for(
        "fetchPriceRequestSummaries"
        /* FETCH_PRICE_REQUEST_SUMMARIES */
      ),
      method: "GET",
      url: "",
      description: "Fetch price request summaries"
    },
    {
      key: Symbol.for(
        "fetchSupplierPriceRequestSummaries"
        /* FETCH_SUPPLIER_PRICE_REQUEST_SUMMARIES */
      ),
      method: "GET",
      url: "",
      description: "Fetch supplier summaries for a tender"
    }
  ]
}), El = async (e, t) => Ae(
  {
    endpointKey: Symbol.for(
      "fetchPriceRequestSummaries"
      /* FETCH_PRICE_REQUEST_SUMMARIES */
    ),
    config: qo()
  },
  {
    pathParams: [JSON.stringify(e), "orgNumber", t, "summaries"]
  }
), Ol = async (e, t) => Ae(
  {
    endpointKey: Symbol.for(
      "fetchSupplierPriceRequestSummaries"
      /* FETCH_SUPPLIER_PRICE_REQUEST_SUMMARIES */
    ),
    config: qo()
  },
  {
    pathParams: [JSON.stringify(e), "supplier", t, "summaries"]
  }
), Rl = () => ({
  fetchPriceRequestSummaries: El,
  fetchSupplierPriceRequestSummaries: Ol
}), Wr = Rl(), Pl = Yr("lib_tenders", {
  state: () => ({
    priceRequestSummaries: [],
    supplierPriceRequestSummaries: []
  }),
  getters: {
    getPriceRequestSummaries: (e) => e.priceRequestSummaries,
    getSupplierPriceRequestSummaries: (e) => e.supplierPriceRequestSummaries
  },
  actions: {
    async fetchPriceRequestSummaries(e, t) {
      (await Wr.fetchPriceRequestSummaries(e, t)).data.forEach((r) => {
        const i = this.priceRequestSummaries.find(
          (o) => r.priceRequestId === o.priceRequestId
        );
        i ? Object.assign(i, r) : this.priceRequestSummaries.push(r);
      });
    },
    async fetchSupplierPriceRequestSummaries(e, t) {
      (await Wr.fetchSupplierPriceRequestSummaries(e, t)).data.forEach((r) => {
        const i = this.supplierPriceRequestSummaries.find(
          (o) => r.priceRequestId === o.priceRequestId
        );
        i ? Object.assign(i, r) : this.supplierPriceRequestSummaries.push(r);
      });
    }
  }
}), Il = { class: "notifications__header" }, kl = { class: "notifications__header-top-bar" }, Nl = { class: "notifications__title" }, Ml = { class: "notifications__tabs" }, On = "appNotifications", Ll = /* @__PURE__ */ G({
  __name: "Notifications",
  props: {
    serviceTypesCms: {},
    audience: {},
    audienceId: {},
    tenders: { default: null },
    orgNumber: {}
  },
  emits: ["notification-clicked", "close"],
  setup(e, { emit: t }) {
    const n = t, r = e, i = Wn(), o = Pl(), { fetchPagesCms: s } = yo(), { getCmsItem: a, getCmsItemText: c, getIconUrl: u } = gn(), l = Ko(null), d = fn({
      activeTabLabel: "all",
      bodyScrollTop: 0,
      bodyScrollBottom: 0,
      isMarkingNotificationsAsRead: !1,
      cms: void 0
    }), f = L(() => {
      var h, p;
      return [
        {
          label: "all",
          text: c((h = d.cms) == null ? void 0 : h.otherText, "notificationsTabs_all")
        },
        {
          label: "unread",
          text: c((p = d.cms) == null ? void 0 : p.otherText, "notificationsTabs_unread")
        }
      ];
    }), y = L(() => {
      var h;
      return ((h = d.cms) == null ? void 0 : h.title) || "";
    }), w = L(() => {
      var p, x;
      const h = a((p = d.cms) == null ? void 0 : p.buttons, "toggleMenuButton");
      return u((x = h == null ? void 0 : h.icons) == null ? void 0 : x[0]);
    }), v = L(() => {
      const h = i.unreadNotifications;
      return r.audience === ie.Customer ? E(
        h,
        o.getPriceRequestSummaries
      ) : m(
        h,
        o.getSupplierPriceRequestSummaries
      );
    }), b = L(() => {
      const h = i.allNotifications;
      return r.audience === ie.Customer ? E(
        h,
        o.getPriceRequestSummaries
      ) : m(
        h,
        o.getSupplierPriceRequestSummaries
      );
    }), _ = L(() => {
      var h;
      return [
        {
          label: "mark_as_read",
          text: c((h = d.cms) == null ? void 0 : h.otherText, "notificationsMenuItem_markAllAsRead"),
          isLoading: d.isMarkingNotificationsAsRead,
          handler: $
        }
      ];
    }), C = L(() => d.bodyScrollTop > 64 ? ["notifications__top-gradient--show"] : []), T = L(() => d.bodyScrollBottom > 64 ? ["notifications__bottom-gradient--show"] : []);
    Jo([
      () => i.allNotifications.items,
      () => i.unreadNotifications.items
    ], async () => {
      var p, x;
      if (!r.orgNumber)
        return;
      const h = [
        ...((p = i.allNotifications) == null ? void 0 : p.items) || [],
        ...((x = i.unreadNotifications) == null ? void 0 : x.items) || []
      ];
      if (r.audience === ie.Customer) {
        const S = o.getPriceRequestSummaries.map((D) => D.tenderId), O = h.map((D) => D.tenderId).filter((D) => !S.includes(D)).map(Number), I = ur(O);
        I.length && await o.fetchPriceRequestSummaries(I, r.orgNumber);
      } else if (r.audience === ie.Supplier && r.audienceId) {
        const S = o.getSupplierPriceRequestSummaries.map((D) => D.tenderId), O = h.map((D) => D.tenderId).filter((D) => !S.includes(D)).map(Number), I = ur(O);
        I.length && await o.fetchSupplierPriceRequestSummaries(I, Number(r.audienceId));
      }
    }, { immediate: !0 }), Zo(() => {
      Vr(() => {
        l.value && (l.value.addEventListener("scroll", M), M());
      });
    }), es(() => {
      l.value && l.value.removeEventListener("scroll", M);
    });
    const $ = async () => {
      const h = r.audienceId;
      if (!(d.isMarkingNotificationsAsRead || !h)) {
        d.isMarkingNotificationsAsRead = !0;
        try {
          await i.markAllNotificationsAsRead(r.audience, h);
        } catch (p) {
          console.log("Error marking all notifications as read", p);
        } finally {
          d.isMarkingNotificationsAsRead = !1;
        }
      }
    }, R = (h) => {
      d.activeTabLabel = h;
    }, M = os(() => {
      l.value && (d.bodyScrollTop = l.value.scrollTop, d.bodyScrollBottom = l.value.scrollHeight - l.value.clientHeight - d.bodyScrollTop);
    }, 100), F = (h, p) => {
      if (r.audience === ie.Customer) {
        const x = o.priceRequestSummaries.find(
          (S) => S.tenderId === h.tenderId
        );
        n(
          "notification-clicked",
          h,
          x,
          p
        );
      } else if (r.audience === ie.Supplier) {
        const x = o.supplierPriceRequestSummaries.find(
          (S) => S.tenderId === h.tenderId
        );
        n(
          "notification-clicked",
          h,
          x,
          p
        );
      }
      n("close");
    }, z = async (h) => {
      const p = d.activeTabLabel === "all" ? le.ALL : le.UNREAD;
      await A(p), h && h();
    }, A = async (h) => {
      const p = r.audienceId;
      p && await i.fetchMoreNotifications(r.audience, p, h);
    }, E = (h, p) => {
      var S;
      const x = (S = h.items) == null ? void 0 : S.map((O) => {
        const I = p.find(
          (D) => D.tenderId === O.tenderId
        );
        return I ? {
          ...O,
          augmented: {
            externalTenderId: I.externalTenderId,
            serviceCategoryLabel: I.serviceCategoryLabel,
            customerOrganizationName: I.customerOrganizationName,
            requestEstimates: I.requestEstimates
          }
        } : {
          ...O
        };
      });
      return {
        ...h,
        items: x
      };
    }, m = (h, p) => {
      var S;
      const x = (S = h.items) == null ? void 0 : S.map((O) => {
        const I = p.find(
          (D) => D.tenderId === O.tenderId
        );
        return I ? {
          ...O,
          augmented: {
            externalTenderId: I.externalTenderId,
            serviceCategoryLabel: I.serviceCategoryLabel,
            customerOrganizationName: I.customerOrganizationName,
            requestEstimates: I.requestEstimates
          }
        } : { ...O };
      });
      return {
        ...h,
        items: x
      };
    };
    return (async () => {
      const h = await s(Vn.NOTIFICATIONS_COMPONENT);
      d.cms = h == null ? void 0 : h[0];
    })(), (h, p) => (N(), q("div", {
      id: On,
      class: "notifications"
    }, [
      H("div", Il, [
        H("div", kl, [
          H("div", Nl, oe(y.value), 1),
          xe(Do, {
            "menu-items": _.value,
            "container-id": On,
            "button-icon": w.value
          }, null, 8, ["menu-items", "button-icon"])
        ]),
        H("div", Ml, [
          xe(uu, {
            tabs: f.value,
            "active-tab-label": d.activeTabLabel,
            onTabChanged: R
          }, null, 8, ["tabs", "active-tab-label"])
        ])
      ]),
      H("div", {
        class: ze(["notifications__top-gradient", C.value])
      }, null, 2),
      H("div", {
        ref_key: "bodyElement",
        ref: l,
        class: "notifications__body"
      }, [
        (N(), de(ts(Tl), {
          key: d.activeTabLabel,
          "service-types-cms": h.serviceTypesCms,
          notifications: d.activeTabLabel === "all" ? b.value : v.value,
          audience: h.audience,
          "audience-id": h.audienceId,
          "container-id": On,
          cms: d.cms,
          onNotificationClicked: F,
          onLoadMore: z
        }, null, 40, ["service-types-cms", "notifications", "audience", "audience-id", "cms"]))
      ], 512),
      H("div", {
        class: ze(["notifications__bottom-gradient", T.value])
      }, null, 2)
    ]));
  }
}), Wl = /* @__PURE__ */ he(Ll, [["__scopeId", "data-v-152d1d2c"]]);
export {
  Ul as N,
  Wl as a,
  jl as b,
  Xr as c,
  cs as d,
  le as e,
  Kr as g,
  Un as u
};
